var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _g, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _g2, _path389, _path390, _path391, _path392, _g3, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeProdred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 843,
    height: 582,
    viewBox: "0 0 843 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_46_6883)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11H820.5C823.417 11 826.215 12.1589 828.278 14.2218C830.341 16.2847 831.5 19.0826 831.5 22V457C831.5 487.235 819.489 516.231 798.11 537.61C776.731 558.989 747.735 571 717.5 571H22.5C19.5826 571 16.7847 569.841 14.7218 567.778C12.6589 565.715 11.5 562.917 11.5 560V22C11.5 19.0826 12.6589 16.2847 14.7218 14.2218C16.7847 12.1589 19.5826 11 22.5 11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M734.921 159.05L710.851 145.161L678.389 140.142L645.911 145.161L621.841 159.05L612.762 178.598L621.825 198.145L645.911 212.05L678.389 217.053L710.867 212.05L734.921 198.145L744 178.598L734.921 159.05Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M678.389 215.503L710.339 210.548V201.965L692.998 203.627L678.389 206.904V215.503Z",
    fill: "#ABA59E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M678.389 206.904L659.768 202.285L646.439 201.965L644.105 203.659L646.439 210.548L678.389 215.503V206.904Z",
    fill: "#B5AFA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M623.039 197.042L646.438 210.548V201.965L631.766 189.658L623.039 188.475V197.042Z",
    fill: "#C7C0B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M623.039 188.475L620.913 178.102L614.472 170.031V178.598L623.039 197.042V188.475Z",
    fill: "#D8D1C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M733.722 197.042L710.339 210.548V201.965L722.294 191.927L733.722 188.475V197.042Z",
    fill: "#A39C95"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M733.722 188.475L735.544 178.486L742.273 170.031V178.598L733.722 197.042V188.475Z",
    fill: "#948E87"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M646.438 201.965L623.039 188.459L614.472 170.015L623.039 151.57L646.438 138.064L678.389 133.125L710.323 138.064L733.723 151.57L742.289 170.015L733.723 188.459L710.339 201.965L678.389 206.904L646.438 201.965Z",
    fill: "#F4EFE9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M649.284 197.346L648.165 197.985V198.88L649.284 199.503H650.834L651.921 198.88V197.985L650.834 197.346H649.284Z",
    fill: "#948E87"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M706.647 197.346L705.544 197.985V198.88L706.647 199.503H708.197L709.316 198.88V197.985L708.197 197.346H706.647Z",
    fill: "#948E87"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M736.903 168.208H735.337L734.234 168.832V169.743L735.337 170.382H736.903L738.006 169.743V168.832L736.903 168.208Z",
    fill: "#948E87"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M707.334 142.268L708.452 141.644V140.733L707.334 140.094H705.783L704.696 140.733V141.644L705.783 142.268H707.334Z",
    fill: "#948E87"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M649.284 140.094L648.165 140.733V141.644L649.284 142.268H650.834L651.921 141.644V140.733L650.834 140.094H649.284Z",
    fill: "#948E87"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M619.858 169.295L618.771 169.935V170.83L619.858 171.469H621.425L622.528 170.83V169.935L621.425 169.295H619.858Z",
    fill: "#948E87"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M632.069 177.031L630.966 177.67V178.582L632.069 179.221H633.651L634.738 178.582V177.67L633.651 177.031H632.069Z",
    fill: "#948E87"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M650.05 179.061V178.166L648.948 177.527H647.397L646.294 178.166V179.061L647.397 179.684H648.948L650.05 179.061Z",
    fill: "#948E87"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M649.203 152.161L650.306 151.522V150.611L649.203 149.972H647.653L646.55 150.611V151.522L647.653 152.161H649.203Z",
    fill: "#948E87"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M695.41 144.601L694.308 145.241V146.12L695.41 146.759H696.961L698.064 146.12V145.241L696.961 144.601H695.41Z",
    fill: "#948E87"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M722.694 160.233L721.591 160.872V161.767L722.694 162.407H724.26L725.347 161.767V160.872L724.26 160.233H722.694Z",
    fill: "#948E87"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M706.567 161.288V162.199L707.67 162.838H709.236L710.339 162.199V161.288L709.236 160.648H707.67L706.567 161.288Z",
    fill: "#948E87"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M711.442 187.388L710.339 188.012V188.923L711.442 189.562H713.008L714.095 188.923V188.012L713.008 187.388H711.442Z",
    fill: "#948E87"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M707.351 178.613L706.264 179.253V180.148L707.351 180.787H708.917L710.02 180.148V179.253L708.917 178.613H707.351Z",
    fill: "#948E87"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M662.725 194.197L661.623 194.836V195.731L662.725 196.371H664.292L665.379 195.731V194.836L664.292 194.197H662.725Z",
    fill: "#948E87"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M669.166 187.388L668.08 188.012V188.923L669.166 189.562H670.733L671.836 188.923V188.012L670.733 187.388H669.166Z",
    fill: "#948E87"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M668.08 150.659H662.902V159.514H668.08V150.659Z",
    fill: "#948E87"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M672.076 149.46L673.882 154.367L670.941 162.566L665.491 165.715L667.441 152.129L669.071 149.46H672.076Z",
    fill: "#A39C95"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M692.518 151.138H689.018V159.018H692.518V151.138Z",
    fill: "#D8D1C7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M684.702 149.46L682.705 155.454L685.821 162.566L691.288 165.715L689.322 152.129L687.18 149.252L684.702 149.46Z",
    fill: "#C7C0B8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M678.389 148.485L676.887 153.584L678.389 164.149L685.821 162.566L684.702 149.46L681.378 147.382L678.389 148.485Z",
    fill: "#B5AFA7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M678.389 148.485V164.149L670.941 162.566L672.076 149.46L675.384 147.382L678.389 148.485Z",
    fill: "#ABA59E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M693.861 147.382H664.132V164.644H693.861V147.382Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M704.154 178.613L693.269 184.911L686.221 165.539L700.286 163.078L704.154 178.613Z",
    fill: "#A39C95"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M700.286 163.078L701.548 157.084L703.674 155.79L708.133 170.031L704.154 178.613L700.286 163.078Z",
    fill: "#948E87"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M678.389 187.196L693.269 184.911L691.032 168.416L690.648 165.315L678.389 170.382V187.196Z",
    fill: "#ABA59E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M652.608 178.613L663.509 184.911L668.911 166.45L656.476 163.078L652.608 178.613Z",
    fill: "#C7C0B8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M656.476 163.078L653.088 155.79L648.628 170.031L652.608 178.613L656.476 163.078Z",
    fill: "#D8D1C7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M678.389 170.382L665.554 164.628L665.73 168.416L663.508 184.911L678.389 187.196V170.382Z",
    fill: "#B5AFA7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M700.286 148.485L691.031 143.131L678.389 141.181L665.73 143.131L656.476 148.485L653.087 155.79L656.46 163.078L665.73 168.416L678.389 170.366L691.031 168.416L700.286 163.078L703.674 155.79L700.286 148.485ZM689.337 159.45L684.718 162.119L678.389 163.094L672.075 162.119L667.44 159.45L665.746 155.805L667.44 152.145L672.075 149.476L678.389 148.501L684.702 149.476L689.321 152.145L691.015 155.805L689.321 159.466L689.337 159.45Z",
    fill: "#F4EFE9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M680.674 144.473V145.56L680.466 145.688L679.332 145.017H677.43L676.295 145.688L676.103 145.56V144.473L677.43 143.706H679.332L680.674 144.473Z",
    fill: "#948E87"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M680.467 145.688L679.332 146.343H677.43L676.295 145.688L677.43 145.017H679.332L680.467 145.688Z",
    fill: "#362C29"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M697.073 150.036V151.138L696.881 151.25L695.747 150.563H693.861L692.678 151.25L692.502 151.138V150.036L693.861 149.252H695.747L697.073 150.036Z",
    fill: "#948E87"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M696.882 151.25L695.747 151.922H693.861L692.678 151.25L693.861 150.563H695.747L696.882 151.25Z",
    fill: "#362C29"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M664.132 150.036V151.138L663.956 151.25L662.79 150.563H660.904L659.737 151.25L659.561 151.138V150.036L660.904 149.252H662.79L664.132 150.036Z",
    fill: "#948E87"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M663.956 151.25L662.789 151.922H660.903L659.736 151.25L660.903 150.563H662.789L663.956 151.25Z",
    fill: "#362C29"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M697.073 160.537V161.639L696.881 161.751L695.747 161.096H693.861L692.678 161.751L692.502 161.639V160.537L693.861 159.753H695.747L697.073 160.537Z",
    fill: "#948E87"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M696.882 161.751L695.747 162.407H693.861L692.678 161.751L693.861 161.096H695.747L696.882 161.751Z",
    fill: "#362C29"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M664.132 160.537V161.639L663.956 161.751L662.79 161.096H660.904L659.737 161.751L659.561 161.639V160.537L660.904 159.753H662.79L664.132 160.537Z",
    fill: "#948E87"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M663.956 161.751L662.789 162.407H660.903L659.736 161.751L660.903 161.096H662.789L663.956 161.751Z",
    fill: "#362C29"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M680.674 166.099V167.186L680.466 167.313L679.332 166.642H677.43L676.295 167.313L676.103 167.186V166.099L677.43 165.315H679.332L680.674 166.099Z",
    fill: "#948E87"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M680.467 167.313L679.332 167.953H677.43L676.295 167.313L677.43 166.642H679.332L680.467 167.313Z",
    fill: "#362C29"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M376.979 84.3608L355.593 72.0219L325.593 89.3316L303.216 76.4172L166.496 155.358L188.873 168.272L129.879 202.333L151.264 214.688L210.258 180.627L233.61 194.101L370.33 115.16L346.978 101.687L376.979 84.3608Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M312.375 109.598L301.347 103.221L293.547 89.7152V76.9766L301.347 72.4694L312.375 78.8466L320.175 92.3524V105.091L312.375 109.598Z",
    fill: "#362C29"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M371.686 44.5976L312.382 78.8232L320.179 92.3342L379.484 58.1086L371.686 44.5976Z",
    fill: "#B5AFA7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M379.457 70.8231V58.0845L320.175 92.3524V105.091L379.457 70.8231Z",
    fill: "#A39C95"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M360.628 38.2015L371.657 44.5788L312.375 78.8466L301.347 72.4694L360.628 38.2015Z",
    fill: "#E6E1DD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M171.26 108.048L162.964 112.843V135.986L171.26 150.355L201.596 173.835L231.932 185.39L240.227 180.595V157.452L231.932 143.083L201.596 119.604L171.26 108.048Z",
    fill: "#D8D1C7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M333.328 43.5558L363.664 67.0191L231.931 143.083L201.595 119.604L333.328 43.5558Z",
    fill: "#C7C0B8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M363.68 67.0547L231.935 143.088L240.235 157.471L371.981 81.4378L363.68 67.0547Z",
    fill: "#B5AFA7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M371.96 81.3879V104.532L240.227 180.595V157.452L371.96 81.3879Z",
    fill: "#A39C95"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M302.992 32L333.329 43.5558L201.595 119.604L171.259 108.048L302.992 32Z",
    fill: "#E6E1DD"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M184.589 161.384L189.928 137.872L129.879 172.588L130.646 184.879L184.589 161.384Z",
    fill: "#A39C95"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M196.768 162.455L189.928 150.611L130.646 184.879L137.487 197.649L196.768 162.455Z",
    fill: "#B5AFA7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M196.769 162.455L207.797 168.816L147.189 203.387L137.487 196.722L196.769 162.455Z",
    fill: "#E6E1DD"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M137.119 168.752L129.927 172.955L129.879 184.879L137.119 196.946L147.444 203.148L154.525 199.471L154.845 187.117L147.54 174.554L137.119 168.752Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M147.828 173.851L136.8 167.473L129 171.98V184.719L136.8 198.225L147.828 204.586L155.628 200.095V187.356L147.828 173.851ZM153.982 198.353L147.141 202.301L137.471 196.722L130.646 184.895V173.739L137.471 169.791L147.141 175.369L153.982 187.196V198.353Z",
    fill: "#D8D1C7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M207.123 139.59L147.818 173.815L155.616 187.326L214.92 153.1L207.123 139.59Z",
    fill: "#B5AFA7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M214.91 165.827V153.088L155.628 187.356V200.095L214.91 165.827Z",
    fill: "#A39C95"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M196.081 133.205L207.11 139.583L147.828 173.85L136.8 167.473L196.081 133.205Z",
    fill: "#E6E1DD"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M495.75 106.849L491.019 104.116L468.578 117.078L458.061 111.021L266.951 221.368L292.492 236.105L483.618 125.757L473.293 119.811L495.75 106.849Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M469.138 97.2433L466.74 95.8687L465.046 92.9278V90.1627L466.74 89.1877L469.138 90.5623L470.832 93.5032V96.2683L469.138 97.2433Z",
    fill: "#574943"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M495.287 79.3741L493.592 76.4492L470.321 88.2287L469.138 90.5623L470.832 93.5032L473.278 93.4712L495.287 79.3741Z",
    fill: "#B5AFA7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M495.286 82.1392V79.3741L470.832 93.5032V96.2683L495.286 82.1392Z",
    fill: "#A39C95"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M491.178 75.0746L493.592 76.4491L469.138 90.5623L466.74 89.1877L491.178 75.0746Z",
    fill: "#D8D1C7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M454.385 116.279L446.649 111.82L441.183 102.342V93.4073L446.649 90.2426L454.385 94.7179L459.867 104.196V113.115L454.385 116.279Z",
    fill: "#574943"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M475.787 95.0056L470.32 85.5276L458.173 87.1898L454.385 94.7179L459.867 104.196L467.763 104.1L475.787 95.0056Z",
    fill: "#B5AFA7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M475.787 103.924V95.0056L459.868 104.196V113.115L475.787 103.924Z",
    fill: "#A39C95"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M462.585 81.0363L470.321 85.5276L454.386 94.7179L446.65 90.2426L462.585 81.0363Z",
    fill: "#D8D1C7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M430.251 130.216L422.515 125.757L417.049 116.279V107.329L422.515 104.18L430.251 108.639L435.733 118.133V127.052L430.251 130.216Z",
    fill: "#574943"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M459.851 104.196L454.385 94.7179L440.672 97.2912L430.25 108.639L435.733 118.133L450.245 114.217L459.851 104.196Z",
    fill: "#211A1A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M459.867 113.115L459.851 104.196L435.733 118.133V127.052L459.867 113.115Z",
    fill: "#0A0808"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M446.649 90.2426L454.385 94.7179L430.25 108.639L422.515 104.18L446.649 90.2426Z",
    fill: "#574943"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M432.345 150.483L413.708 139.726L400.538 116.903V95.3892L413.708 87.7812L432.345 98.5538L445.531 121.378L445.515 142.875L432.345 150.483Z",
    fill: "#362C29"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M448.76 119.508L435.574 96.6838L424.641 92.2405L432.345 98.5538L445.531 121.378L447.129 131.191L448.76 119.508Z",
    fill: "#211A1A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M448.76 141.021V119.508L445.531 121.378L445.515 142.875L448.76 141.021Z",
    fill: "#0A0808"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M416.953 85.9111L435.573 96.6838L432.345 98.5538L413.708 87.7812L416.953 85.9111Z",
    fill: "#574943"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M307.42 201.134L299.684 196.674L294.218 187.196V178.262L299.684 175.097L307.42 179.572L312.902 189.035V197.985L307.42 201.134Z",
    fill: "#362C29"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M432.36 120.067L426.878 110.589L339.067 155.965L307.42 179.572L312.902 189.035L348.64 172.876L432.36 120.067Z",
    fill: "#211A1A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M432.361 129.002V120.067L312.903 189.034V197.985L432.361 129.002Z",
    fill: "#0A0808"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M419.158 106.114L426.878 110.589L307.42 179.572L299.684 175.097L419.158 106.114Z",
    fill: "#574943"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M308.779 186.078L297.478 179.541H281.479L270.179 186.078V195.3L281.479 201.837H297.478L308.779 195.3V186.078Z",
    fill: "#574943"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M297.478 201.837H281.479V212.961H297.478V201.837Z",
    fill: "#211A1A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M308.779 206.424L297.479 212.945V201.837L308.779 195.3V206.424Z",
    fill: "#0A0808"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M270.179 206.424L281.479 212.945V201.837L270.179 195.3V206.424Z",
    fill: "#362C29"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M617.029 100.136L638.702 87.6214L634.147 84.9842L612.474 97.499L602.341 91.6652L541.061 127.036L522.92 116.567L518.557 119.076L536.698 129.545L417.895 198.161L442.541 212.37L561.344 143.786L580.124 154.623L584.487 152.113L565.707 141.277L626.987 105.89L617.029 100.136Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M636.13 72.5014L633.588 71.0309L631.798 67.9302V65.0053L633.588 63.9664L636.13 65.4368L637.92 68.5376V71.4625L636.13 72.5014Z",
    fill: "#D8D1C7"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M641.212 66.6355L639.421 63.5348L636.129 65.4368L637.919 68.5375L641.212 66.6355Z",
    fill: "#B5AFA7"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M641.212 69.5605V66.6356L637.919 68.5376V71.4625L641.212 69.5605Z",
    fill: "#A39C95"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M636.897 62.0643L639.422 63.5348L636.13 65.4368L633.588 63.9663L636.897 62.0643Z",
    fill: "#E6E1DD"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M623.007 78.3351L621.345 77.3921L620.162 75.3463V73.4443L621.345 72.773L623.007 73.716L624.19 75.7459V77.6798L623.007 78.3351Z",
    fill: "#E6E1DD"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M635.617 66.4338L623.045 73.78L624.23 75.8086L636.802 68.4623L635.617 66.4338Z",
    fill: "#B5AFA7"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M636.801 70.3916V68.4736L624.19 75.7459V77.6799L636.801 70.3916Z",
    fill: "#A39C95"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M633.956 65.4847L635.618 66.4437L623.007 73.7161L621.345 72.7731L633.956 65.4847Z",
    fill: "#E6E1DD"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M599.575 93.9827L596.842 92.4164L594.924 89.0759V85.9112L596.842 84.8084L599.575 86.3748L601.493 89.7312V92.8799L599.575 93.9827Z",
    fill: "#E6E1DD"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M624.813 71.8462L599.584 86.4237L601.52 89.7728L626.748 75.1953L624.813 71.8462Z",
    fill: "#B5AFA7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M626.747 78.3032V75.1545L601.493 89.7312V92.8799L626.747 78.3032Z",
    fill: "#A39C95"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M622.08 70.2318L624.813 71.7981L599.575 86.3747L596.842 84.8084L622.08 70.2318Z",
    fill: "#E6E1DD"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M588.084 111.404L579.885 106.673L574.067 96.6359V87.1579L579.885 83.8174L588.084 88.5485L593.886 98.5859V108.064L588.084 111.404Z",
    fill: "#D8D1C7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M598.715 82.4038L588.083 88.5394L593.884 98.5896L604.515 92.4539L598.715 82.4038Z",
    fill: "#B5AFA7"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M604.515 101.91V92.4484L593.886 98.5859V108.064L604.515 101.91Z",
    fill: "#A39C95"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M590.514 77.6799L598.713 82.4109L588.084 88.5485L579.885 83.8175L590.514 77.6799Z",
    fill: "#E6E1DD"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M562.767 123.695L555.766 119.636L550.795 111.037V102.933L555.766 100.072L562.767 104.132L567.722 112.715V120.818L562.767 123.695Z",
    fill: "#574943"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M592.24 98.5699L587.27 89.9709L569.928 95.1335L562.768 104.132L567.722 112.715L579.23 111.772L592.24 98.5699Z",
    fill: "#211A1A"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M592.24 106.673V98.5699L567.722 112.715V120.818L592.24 106.673Z",
    fill: "#0A0808"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M580.269 85.9112L587.269 89.9709L562.767 104.132L555.767 100.072L580.269 85.9112Z",
    fill: "#574943"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M569.384 145.72L543.587 130.824L525.35 99.2092V69.4166L543.587 58.8837L569.4 73.78L587.636 105.379V135.187L569.384 145.72Z",
    fill: "#574943"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M556.31 129.737L548.111 125.022L542.325 114.969V105.507L548.111 102.166L556.31 106.897L562.112 116.935V126.397L556.31 129.737Z",
    fill: "#362C29"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M587.637 135.187L562.112 126.397L556.31 129.737L569.384 145.72L587.637 135.187Z",
    fill: "#0A0808"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M562.111 126.397V116.935L587.636 105.379V135.187L562.111 126.397Z",
    fill: "#211A1A"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M562.112 116.935L556.31 106.897L569.4 73.78L587.637 105.379L562.112 116.935Z",
    fill: "#362C29"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M543.587 130.824L548.11 125.022L542.324 114.969L525.35 99.2092L543.587 130.824Z",
    fill: "#0A0808"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M525.35 99.2092L542.324 114.969V105.507L537.258 86.1829L525.35 69.4166V99.2092Z",
    fill: "#211A1A"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M542.324 105.507L525.35 69.4166L543.587 58.8837L548.11 102.166L542.324 105.507Z",
    fill: "#362C29"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M556.31 106.897L548.111 102.166L543.588 58.8837L569.401 73.78L556.31 106.897Z",
    fill: "#574943"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M543.588 130.824L569.385 145.72L556.31 129.737L548.111 125.022L543.588 130.824Z",
    fill: "#211A1A"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M571.529 72.5796L569.397 73.8106L587.648 105.408L589.779 104.177L571.529 72.5796Z",
    fill: "#211A1A"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M589.795 133.941L589.779 104.148L587.637 105.379V135.187L589.795 133.941Z",
    fill: "#0A0808"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M545.746 57.637L571.526 72.5493L569.401 73.78L543.588 58.8836L545.746 57.637Z",
    fill: "#362C29"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M545.665 135.891L537.482 131.16L531.68 121.122V111.644L537.466 108.304L545.665 113.035L551.483 123.088V132.55L545.665 135.891Z",
    fill: "#362C29"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M556.304 106.85L545.661 112.997L551.465 123.045L562.108 116.898L556.304 106.85Z",
    fill: "#211A1A"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M562.111 126.396V116.934L551.482 123.088V132.55L562.111 126.396Z",
    fill: "#0A0808"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M548.11 102.166L556.309 106.897L545.665 113.035L537.465 108.304L548.11 102.166Z",
    fill: "#574943"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M466.628 179.205L459.612 175.145L454.641 166.546V158.443L459.612 155.582L466.628 159.642L471.583 168.224V176.328L466.628 179.205Z",
    fill: "#574943"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M549.374 123.328L544.403 114.729L488.75 142.012L466.629 159.641L471.584 168.224L498.052 158.635L549.374 123.328Z",
    fill: "#211A1A"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M549.374 131.431V123.328L471.584 168.224V176.328L549.374 131.431Z",
    fill: "#0A0808"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M537.402 110.669L544.402 114.729L466.628 159.642L459.612 155.582L537.402 110.669Z",
    fill: "#574943"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M471.311 169.359L465.525 159.306L459.34 155.742L464.167 152.961L470.336 156.525L476.138 166.578V173.707L471.311 176.488V169.359Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M435.845 199.296L427.646 194.565L421.844 184.527V175.049L427.646 171.709L435.845 176.456L441.631 186.477V195.955L435.845 199.296Z",
    fill: "#362C29"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M474.076 167.761L468.29 157.708L435.844 176.456L441.63 186.477L474.076 167.761Z",
    fill: "#211A1A"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M474.076 177.223V167.761L441.63 186.477V195.955L474.076 177.223Z",
    fill: "#0A0808"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M460.091 152.977L468.291 157.708L435.845 176.456L427.646 171.709L460.091 152.977Z",
    fill: "#574943"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M618.852 421.366L639.31 409.554L633.7 406.31L613.242 418.121L603.668 412.607L573.955 429.757L583.513 435.287L561.952 447.738L567.562 450.983L589.123 438.516L598.697 444.046L628.41 426.896L618.852 421.366Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M633.156 402.33L629.912 400.444L627.626 396.48V392.74L629.912 391.413L633.156 393.283L635.442 397.263V401.003L633.156 402.33Z",
    fill: "#E6E1DD"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M637.52 390.774L633.161 393.294L635.457 397.265L639.816 394.745L637.52 390.774Z",
    fill: "#B5AFA7"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M639.806 398.478V394.738L635.442 397.263V401.003L639.806 398.478Z",
    fill: "#A39C95"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M634.276 388.904L637.504 390.774L633.157 393.283L629.912 391.413L634.276 388.904Z",
    fill: "#D8D1C7"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M616.902 410.305L614.377 408.835L612.586 405.75V402.825L614.377 401.802L616.902 403.257L618.692 406.358V409.266L616.902 410.305Z",
    fill: "#E6E1DD"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M632.589 394.23L616.904 403.282L618.686 406.369L634.37 397.317L632.589 394.23Z",
    fill: "#B5AFA7"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M634.371 400.22V397.295L618.691 406.358V409.266L634.371 400.22Z",
    fill: "#A39C95"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M630.056 392.74L632.582 394.21L616.902 403.257L614.377 401.802L630.056 392.74Z",
    fill: "#D8D1C7"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M591.313 439.347L581.547 433.705L574.642 421.749V410.465L581.547 406.485L591.313 412.111L598.217 424.083V435.351L591.313 439.347Z",
    fill: "#E6E1DD"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M620.142 395.473L591.321 412.106L598.223 424.067L627.045 407.433L620.142 395.473Z",
    fill: "#B5AFA7"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M627.051 418.713V407.444L598.217 424.083V435.351L627.051 418.713Z",
    fill: "#A39C95"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M610.38 389.831L620.146 395.473L591.313 412.111L581.547 406.485L610.38 389.831Z",
    fill: "#D8D1C7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.953 423.763L606.162 418.681L599.96 407.94V397.807L606.162 394.21L614.953 399.277L621.154 410.034V420.167L614.953 423.763Z",
    fill: "#F59C72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.739 397.69L614.929 399.312L621.139 410.067L623.949 408.445L617.739 397.69Z",
    fill: "#995D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.966 418.553V408.403L621.153 410.034V420.167L623.966 418.553Z",
    fill: "#87523B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.974 392.596L617.749 397.663L614.952 399.277L606.161 394.21L608.974 392.596Z",
    fill: "#B57355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.695 434.632L585.624 429.981L579.902 420.087V410.769L585.608 407.46L593.695 412.127L599.401 422.021V431.339L593.695 434.632Z",
    fill: "#FBE979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.177 400.287L593.691 412.114L599.405 422.011L619.891 410.184L614.177 400.287Z",
    fill: "#D6A950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.892 419.512V410.193L599.401 422.021V431.339L619.892 419.512Z",
    fill: "#CC934C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.113 395.633L614.185 400.3L593.694 412.127L585.607 407.46L606.113 395.633Z",
    fill: "#E3BD5E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M596.252 416.571L595.837 415.836L616.327 404.008L616.743 404.743L596.252 416.571Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M595.278 414.877L594.862 414.141L615.353 402.314L615.768 403.049L595.278 414.877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M594.303 413.182L593.872 412.447L614.378 400.62L614.794 401.355L594.303 413.182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M617.316 405.638L596.827 417.491L597.251 418.224L617.74 406.371L617.316 405.638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M598.219 419.959L597.787 419.224L618.278 407.38L618.693 408.116L598.219 419.959Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M619.252 409.045L598.77 420.879L599.194 421.613L619.676 409.778L619.252 409.045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M589.044 409.442L588.197 408.947L608.688 397.119L609.535 397.615L589.044 409.442Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M587.094 408.323L586.247 407.828L606.737 396L607.585 396.48L587.094 408.323Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M592.96 411.696L592.113 411.216L612.603 399.373L613.45 399.868L592.96 411.696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M591.011 410.577L590.147 410.082L610.638 398.254L611.501 398.75L591.011 410.577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M599.401 423.779V422.804L619.892 410.961V411.952L599.401 423.779Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M599.401 428.286V427.311L619.892 415.484V416.459L599.401 428.286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M599.401 426.033V425.058L619.892 413.23V414.205L599.401 426.033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M599.401 430.556V429.565L619.892 417.738V418.713L599.401 430.556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.313 437.397L582.539 432.33L576.321 421.574V411.44L582.539 407.86L591.313 412.927L597.515 423.683V433.817L591.313 437.397Z",
    fill: "#F59C72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.116 411.333L591.306 412.955L597.515 423.71L600.325 422.088L594.116 411.333Z",
    fill: "#995D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.343 432.186L600.327 422.053L597.514 423.683V433.817L600.343 432.186Z",
    fill: "#87523B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.352 406.23L594.126 411.296L591.313 412.927L582.539 407.86L585.352 406.23Z",
    fill: "#B57355"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M571.334 436.614L568.808 435.159L567.018 432.058V429.134L568.808 428.111L571.334 429.565L573.124 432.666V435.575L571.334 436.614Z",
    fill: "#E6E1DD"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M587.019 420.486L571.337 429.543L573.12 432.629L588.801 423.572L587.019 420.486Z",
    fill: "#B5AFA7"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M588.787 426.528V423.603L573.124 432.666V435.575L588.787 426.528Z",
    fill: "#A39C95"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M584.488 419.048L587.013 420.519L571.334 429.565L568.809 428.111L584.488 419.048Z",
    fill: "#D8D1C7"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M567.498 440.226L564.269 438.356L561.983 434.392V430.652L564.269 429.325L567.498 431.195L569.799 435.159V438.899L567.498 440.226Z",
    fill: "#E6E1DD"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M571.851 428.71L567.491 431.227L569.785 435.2L574.145 432.682L571.851 428.71Z",
    fill: "#B5AFA7"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M574.163 436.39V432.65L569.8 435.159V438.899L574.163 436.39Z",
    fill: "#A39C95"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M568.633 426.8L571.862 428.67L567.498 431.195L564.27 429.325L568.633 426.8Z",
    fill: "#D8D1C7"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M581.546 230.575L557.891 233.484L527.843 245.871L509.031 260.511L512.435 268.775L536.106 265.866L566.139 253.479L584.967 238.854L581.546 230.575Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M520.731 254.693L518.318 256.34L512.021 261.534V262.749L514.45 265.242L519.884 264.603L526.741 259.44L531.344 257.986L534.701 255.077L534.509 254.006L531.408 248.284L525.127 250.186L520.731 254.693Z",
    fill: "#FF8E1C"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M569.352 234.666L568.457 236.92L565.948 240.74L566.14 242.083L568.921 244.001L574.451 242.994L578.654 239.621L580.301 232.94L580.988 230.751L581.579 223.382L581.052 221.432L580.46 220.234L576.321 220.553L572.245 221.64L570.151 227.138L569.352 234.666Z",
    fill: "#FF8E1C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M520.731 253.495L518.318 255.125L513.107 258.481L512.021 261.534L514.45 264.028L519.884 263.388L526.741 258.242L531.344 256.787L534.509 254.006L533.965 250.138L531.408 247.085L525.127 248.971L520.731 253.495Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M516.991 194.165L509.687 207.367L501.375 230.591L503.23 237.911L514.737 247.421L520.491 253.463L525.51 254.006L531.472 250.074L531.376 245.679L520.3 234.347L515.521 230.223L526.885 215.966L536.123 202.876V194.661L518.749 190.089L516.991 194.165Z",
    fill: "#377691"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M513.666 168.129H501.12V184.671H513.666V168.129Z",
    fill: "#C7A495"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M497.571 210.02L499.569 203.196L501.711 196.547L503.229 189.658L494.439 187.772L492.313 195.332L487.87 205.194L497.571 210.02Z",
    fill: "#F0C6B4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M505.244 161.432L502.319 159.961L497.859 161.432L495.302 174.586L494.087 187.42L496.725 189.962L501.28 190.873L505.499 189.706L506.57 184.495L498.179 174.538L505.643 166.37L505.244 161.432Z",
    fill: "#F4EFE9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M536.586 173.978L525.861 168.816L520.475 164.468L513.458 162.007L503.677 161.432L500.656 163.509L498.978 177.351L503.677 183.872L504.316 184.799L510.933 189.802L521.69 192.918L539.463 194.197L542.26 188.044V180.611L536.586 174.026V173.978ZM512.196 180.563L507.688 183.728L504.636 181.171L502.078 172.14L506.474 168.8L510.198 170.67L512.212 175.401V180.563H512.196Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M569.352 233.468L568.457 235.721L566.347 237.719L565.948 240.74L568.921 242.802L574.451 241.795L578.063 238.407L579.709 231.742L580.397 229.536L580.988 222.184L580.46 220.234L578.702 219.163L575.729 219.339L572.245 220.441L570.151 225.924L569.352 233.468Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M523.32 189.626L511.892 188.347L504.3 184.783L512.356 192.647L524.055 196.483L532.463 200.59L535.036 203.068L538.408 204.251L539.783 215.87L547.471 239.094L554.328 240.005L566.667 234.347L572.532 232.429L575.729 229.216V223.462L571.941 220.17L565.548 222.248L557.428 223.063L557.892 196.019L556.341 188.076L552.681 181.203L542.164 175.816L533.47 170.878L527.14 168.496L521.834 164.101L513.443 162.007L521.37 166.051L527.668 172.524L535.579 175.257L540.023 180.484L541.062 184.32L540.023 187.98L537.226 190.169L532.191 190.633L523.32 189.626Z",
    fill: "#428AA8"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M487.183 176.248L488.11 178.55L491.227 181.506L491.898 181.778V185.838H493.752L494.855 185.326L497.716 187.42H500.225L505.612 181.842L505.836 177.83L507.354 175.657L507.434 173.819L507.69 172.396L498.579 168.816L486.832 174.81L487.183 176.248Z",
    fill: "#F0C6B4"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M496.581 160.153L494.439 158.778L494.615 160.153L491.322 160.553L492.345 161.144L488.078 164.357L486.112 168.928L486.991 168.288L486.112 172.364L486.751 176.935L487.486 175.737L489.868 178.39L494.071 178.853L493.432 177.702L496.085 176.52L497.236 176.472L499.618 177.015L501.711 176.696L503.038 176.743L503.773 176.056V174.314L505.499 172.764H506.97L507.433 173.819L508.392 173.771L508.84 172.396L507.881 167.457L505.276 163.941L502.543 161.528L499.618 160.329L499.698 159.242L496.581 160.153Z",
    fill: "#403531"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M526.341 170.382L520.795 173.083L518.142 176.6L518.238 182.338L521.259 190.089L517.806 189.706L514.594 182.338V175.241L518.062 170.526L523.912 167.617L526.341 170.382Z",
    fill: "#428AA8"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M491.914 228.033L491.498 233.02L490.108 235.721L487.375 239.238L486.703 237L487.982 234.523L487.614 233.628L485.552 234.571L483.491 237L482.26 240.324L480.422 240.98L478.919 235.114L481.077 230.127L485.313 226.243L487.023 224.597L491.914 225.332V228.033Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M487.87 205.194L485.313 226.243L488.669 226.211L491.147 226.835L491.914 228.033L494.28 218.827L497.572 210.02L495.255 204.618H493.145L487.87 205.194Z",
    fill: "#F0C6B4"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M500.64 232.972L494.247 236.712L490.859 240.66L490.107 245.423L492.777 248.012L498.626 247.693L499.362 245.183L505.531 238.87L505.771 237V234.395L503.709 232.013L500.64 232.972Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M519.629 202.924L517.838 210.564L513.443 215.87L506.586 226.115L500.641 232.972L503.294 234.347L505.771 237L517.007 227.666L522.777 221.081L526.885 213.952L530.401 206.664L525.798 199.951L519.629 202.924Z",
    fill: "#F0C6B4"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M530.641 176.264H527.077L524.152 179.285L522.586 184.128V189.354L519.213 202.428L521.771 205.449L527.668 207.367L532.288 206.168L535.948 190.441L536.124 183.584L534.397 178.853L530.641 176.264Z",
    fill: "#F4EFE9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M443.58 258.082V244.192L426.574 234.379H402.52L385.498 244.192V258.082L402.52 267.895H426.574L443.58 258.082Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M428.988 240.133L433.735 244.608L440.736 249.003L441.775 252.248V253.287L439.297 255.493L435.014 255.764L429.612 252.616L425.632 249.163L421.716 248.284L418.471 246.686L417.161 244.4L417.305 243.377L420.261 238.678L428.988 240.133Z",
    fill: "#211A1A"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M402.312 246.51L404.23 251.273L408.562 258.29V259.312L405.765 261.63H400.97L396.542 259.169L390.101 247.213V246.19L402.312 246.51Z",
    fill: "#211A1A"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M428.988 239.094L433.735 243.585L440.736 247.964L441.775 250.554V252.248L439.297 254.47L435.014 254.725L429.612 251.577L425.632 248.108L421.716 247.245L418.471 245.647L417.161 243.377L417.305 238.758L420.261 237.655L428.988 239.094Z",
    fill: "#944E39"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M402.312 245.471L404.23 250.234L407.986 255.445L408.562 258.29L405.765 260.607H400.97L396.542 258.13L390.101 246.19L390.613 241.667L402.312 245.471Z",
    fill: "#944E39"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M436.596 131.16L438.673 146.871L439.984 149.588L444.108 148.517L446.393 127.691V116.711L441.838 108.927L435.077 110.525L436.596 131.16Z",
    fill: "#F0C6B4"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M437.283 119.54L443.581 117.206L436.596 121.857L437.283 119.54Z",
    fill: "#C7A495"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M433.655 90.9938L436.596 92.2565L439.377 97.467L442.078 108.24L440.847 111.644L435.653 113.898L428.093 96.4281L433.655 90.9938Z",
    fill: "#F4EFE9"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M412.829 86.8382L410.528 92.2565L409.537 97.8506L412.829 102.31L420.213 104.532L424.848 104.116L427.278 100.296L424.449 86.071L412.989 84.3608L412.829 86.8382Z",
    fill: "#C7A495"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M402.488 143.93L399.483 133.157V127.691H406.803L408.497 143.93L404.294 147.91L402.488 143.93Z",
    fill: "#2D5A78"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M425.631 98.1383L423.569 102.757L417.4 101.335L411.758 95.8687L410.527 92.2565L407.986 95.9486L406.148 99.5928L402.967 100.232L399.994 103.924L395.759 121.666L398.236 129.305L403.463 138.112L403.623 144.202L403.543 151.17L411.31 153.168L428.3 143.61L437.747 119.684L439.041 116.023V106.529L436.052 99.5928L432.152 94.7819L425.631 98.1383Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M416.921 176.072L420.725 202.157L417.64 210.628L416.089 237.032L418.966 241.156L424.449 242.498L430.011 239.302L435.988 205.05L437.747 178.949L436.596 154.815L414.539 163.685L416.921 176.072Z",
    fill: "#377691"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M436.596 154.815L436.5 156.828L433.991 162.854L434.342 164.197H435.733L440.016 161.368L442.702 157.18L444.108 148.517L441.982 146.871H438.162L436.356 147.75L435.221 152.129L436.596 154.815Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M436.596 103.141L427.23 109.838L413.82 115.608L415.163 131.911L411.518 144.394L406.708 146.983L402.488 143.93L397.038 158.315L395.967 200.415L391.747 210.931L390.101 240.644L392.674 245.695L397.933 247.245L402.776 245.279L407.011 211.347L410.735 204.954L419.398 170.91L426.511 166.994L436.596 154.815V132.63L438.994 118.101L438.37 109.311L436.596 103.141Z",
    fill: "#428AA8"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M421.028 93.9987L424.497 95.597L429.244 100.728L431.369 109.311L436.596 106.434L433.639 97.3551L428.077 91.1696L426.463 90.2426L421.028 93.9987Z",
    fill: "#428AA8"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M402.696 100.104L409.984 103.477L414.731 108.607L416.857 117.206L422.083 114.313L419.126 105.235L413.564 99.0493L407.842 95.8687L402.696 100.104Z",
    fill: "#428AA8"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M388.901 107.824L390.1 101.047L396.174 98.1383L402.008 99.7846L405.156 105.235L403.878 108.527L400.441 112.827L392.29 112.971L388.901 107.824Z",
    fill: "#D1D1D1"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M387.239 100.424L390.564 109.534L391.842 112.651L395.007 114.377L401.193 112.523L404.293 108.879L403.542 103.141L402.199 101.287L398.891 97.8506H391.922L387.239 100.424Z",
    fill: "#F0C6B4"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M399.994 99.0014L395.966 101.335L395.631 99.5608L398.891 97.8506L399.994 99.0014Z",
    fill: "#C7A495"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M407.474 72.0379L402.839 77.648L392.53 87.9891L387.719 94.2065L387.239 100.424L389.509 102.757L395.966 101.335L403.238 92.6561L410.351 79.5499L412.78 75.7939L415.162 73.3325L410.958 70.024L407.474 72.0379Z",
    fill: "#F0C6B4"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M433.176 76.1454L435.797 80.4449L436.053 87.1898L434.614 89.2676V91.3294L431.05 100.871L427.118 103.141L424.848 102.454L417.017 95.5969L416.425 92.3044L414.076 90.0987L413.404 86.9021L412.829 82.5547L416.857 75.7938L427.278 72.8529L433.176 76.1454Z",
    fill: "#F0C6B4"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M413.404 86.9021L414.027 85.2878L415.578 85.1759L417.096 86.9021V89.0758L418.055 90.0987H419.973L420.724 88.5164L422.099 86.4546V83.8493L420.724 81.4359L420.245 78.8945L422.594 77.9356L424.784 78.5429L427.054 80.2052L430.426 81.8514L432.696 80.9564L433.655 79.7896L433.175 76.1454L430.426 72.2935L427.198 69.6083L424.097 68.985L417.016 70.855L413.164 75.6819L411.998 78.3511L411.518 83.0182L412.413 86.8062L413.404 86.9021Z",
    fill: "#6B4414"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M407.475 72.0378L411.71 72.6452L413.149 73.8439L412.781 75.7939L414.843 75.1226L421.092 70.7432L423.202 70.9989L424.193 72.0378L425.376 70.7432L424.752 68.5215L422.739 65.0212L418.743 64.238L414.188 65.0212L407.475 72.0378Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M402.008 99.7845L402.919 107.089L398.523 111.564L392.817 111.836L388.901 107.824L395.087 121.186L399.482 124.287L406.147 121.937L408.497 112.459L406.355 104.468L402.008 99.7845Z",
    fill: "#F4EFE9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M317.697 271.06V259.025L302.961 250.506H282.119L267.382 259.025V271.06L282.119 279.563H302.961L317.697 271.06Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M302.338 254.693L306.541 257.075L316.946 262.477V263.436L316.547 266.233L309.93 266.521L301.427 263.148H300.068L292.476 262.541L288.528 260.367V259.392L291.054 252.919L302.338 254.693Z",
    fill: "#836E69"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M279.929 260.863L281.191 264.971L283.669 269.973L284.228 273.809V274.784L280.184 275.935L275.581 275.328L271.889 271.588L268.996 262.637V261.678L279.929 260.863Z",
    fill: "#836E69"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M302.338 253.734L306.541 256.116L316.003 259.76L316.946 262.477L316.547 265.258L309.93 265.578L301.427 262.173H300.068L292.476 261.566L288.528 259.392L289.407 254.294L291.054 251.96L302.338 253.734Z",
    fill: "#EFC58B"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M285.236 107.105L284.085 111.133L283.366 114.569L286.61 119.172L292.972 121.506L298.646 119.524L300.899 117.206L299.509 109.47L289.407 105.059L284.996 105.315L285.236 107.105Z",
    fill: "#C7A495"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M314.661 121.026L316.691 125.406L317.09 137.265L313.51 154.543L311.959 155.614H307.165L307.964 124.91L314.661 121.026Z",
    fill: "#F0C6B4"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M310.761 127.963L315.204 126.205L310.761 129.657V127.963Z",
    fill: "#C7A495"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M304.943 107.393L307.596 108L309.978 110.429L311.496 113.866L312.807 117.957L314.725 120.563L314.054 124.91L310.074 127.02L301.203 113.594L304.943 107.393Z",
    fill: "#F4EFE9"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M276.413 159.466L275.821 149.141L278.986 152.305L279.929 161.48L276.141 163.573L276.413 159.466Z",
    fill: "#2D5A78"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M298.741 115.192L297.431 119.236H290.846L286.099 115.592L284.085 111.133L279.114 115.192L278.618 117.814L274.926 119.332L270.02 123.056L272.145 143.307L275.773 150.595L278.107 156.669L277.196 161.927L278.315 166.067H290.446L301.586 155.758L311.336 136.754L312.439 128.57L310.281 120.067L307.164 115.192L303.6 112.044L298.741 115.192Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M289.407 192.982L293.083 215.646L289.407 226.163V252.2L293.083 255.301L299.412 256.116L303.2 253.559L305.086 223.734L307.771 215.103L310.76 188.731L309.609 173.563L289.407 181.65V192.982Z",
    fill: "#377691"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M279.929 259.904L281.191 263.996L283.669 269.014L284.228 272.195V273.809L280.184 274.976L275.581 274.369L271.889 270.629L268.996 261.678L269.092 258.146L279.929 259.904Z",
    fill: "#EFC58B"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M309.945 121.026L300.899 128.171L287.681 133.429L289.775 145.976L289.103 156.301L285.459 161.815L280.84 162.966L277.356 160.537L276.413 159.466L271.554 171.597L271.234 213.345L267.318 226.499L268.869 257.65L270.419 261.023L276.221 262.173L280.936 259.952L282.215 223.398L286.61 214.16L292.748 186.094L301.235 182.657L309.61 173.563L309.402 169.567L308.459 153.12L311.496 135.827V126.924L309.945 121.026Z",
    fill: "#428AA8"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M300.899 117.846L303.392 121.266L305.23 126.54L308.97 124.303L307.1 118.725L304.144 113.594L300.899 117.846Z",
    fill: "#428AA8"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M307.165 98.0105L306.941 101.671L306.589 102.39L306.334 107.6L304.511 116.247L300.212 118.421L294.394 115.64L289.487 111.644L289.04 109.007L286.914 108L285.635 106.034L284.628 105.315L284.085 101.527L286.802 95.549L297.175 93.0876L306.03 93.9348L307.165 98.0105Z",
    fill: "#F0C6B4"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M285.635 106.034L284.884 103.189L286.099 101.127L288.177 102.278L289.088 104.26L290.446 104.659L290.846 102.885L294.346 101.575L296.264 97.6908L301.267 98.7457V97.6908L305.263 98.6977L308.108 97.6908L307.101 92.4643L305.119 88.932L302.082 86.7104L298.534 84.4248L294.506 84.1211L290.958 84.5846L288.32 86.3587L286.099 86.9181L283.27 89.939L281.847 93.3274L281.496 97.7867L282.455 101.719L284.181 105.73L285.236 107.105L285.635 106.034Z",
    fill: "#574943"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M289.04 88.4685L291.213 89.8431L293.946 93.2315L294.793 95.549L293.227 93.5352L290.606 90.3066L289.04 88.4685Z",
    fill: "#362C29"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M275.278 169.311L281.751 168.304L283.238 170.798L288.288 173.083L290.446 178.614L287.074 181.65L281.751 182.114L271.906 176.855L271.234 174.778V171.261L275.278 169.311Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M264.153 149.38L260.094 152.113L264.153 156.461L275.278 169.311L274.67 171.405L272.848 173.563L271.234 174.778L254.228 163.238L249.481 157.276L248.57 148.166L254.42 140.989L261.916 140.27L264.153 149.38Z",
    fill: "#F0C6B4"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M279.626 125.901L274.064 122.672L268.805 123.168L262.268 129.929L254.229 140.174L255.555 145.64L260.158 149.476L265.369 150.084L277.9 137.537L279.929 131L279.626 125.901Z",
    fill: "#F4EFE9"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M274.927 119.332L281.496 121.362L285.396 125.406L287.825 129.657L290.111 134.644L294.154 131.879L292.636 127.627L290.446 123.376L286.099 117.718L279.114 115.192L274.927 119.332Z",
    fill: "#428AA8"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M308.459 153.12V159.929L308.06 163.366L306.765 166.482L308.06 170.19L312.167 168.304L314.725 162.087L313.51 154.543L310.761 152.785L308.459 153.12Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M260.094 152.113L254.771 153.264L255.714 154.207L260.094 152.113Z",
    fill: "#C7A495"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M530.864 343.767L472.67 377.364L444.811 361.285L503.006 327.688L530.864 343.767Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M511.109 345.478L499.697 338.893L491.626 324.907V311.721L499.697 307.054L511.109 313.655L519.197 327.64V340.827L511.109 345.478Z",
    fill: "#362C29"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M521.939 307.44L511.127 313.679L519.197 327.661L530.008 321.421L521.939 307.44Z",
    fill: "#211A1A"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M530.017 334.577L530.001 321.391L519.197 327.641V340.827L530.017 334.577Z",
    fill: "#0A0808"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M510.517 300.805L521.929 307.406L511.109 313.655L499.697 307.054L510.517 300.805Z",
    fill: "#574943"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M474.684 365.185L463.943 358.983L456.351 345.829V333.426L463.943 329.047L474.684 335.248L482.276 348.403V360.79L474.684 365.185Z",
    fill: "#D8D1C7"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M510.28 314.731L474.679 335.286L482.271 348.435L517.872 327.881L510.28 314.731Z",
    fill: "#B5AFA7"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M517.886 340.235V327.848L482.276 348.403V360.79L517.886 340.235Z",
    fill: "#A39C95"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M499.553 308.477L510.278 314.694L474.684 335.248L463.943 329.047L499.553 308.477Z",
    fill: "#E6E1DD"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M464.789 372.234L453.362 365.648L445.29 351.663V338.477L453.362 333.81L464.789 340.411L472.861 354.38V367.566L464.789 372.234Z",
    fill: "#362C29"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M462.12 346.309L456.03 342.793L451.731 345.27V352.287L456.03 359.735L462.12 363.251L466.404 360.774L466.419 353.757L462.12 346.309Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M475.594 334.165L464.782 340.404L472.851 354.386L483.663 348.146L475.594 334.165Z",
    fill: "#211A1A"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M483.681 361.317L483.665 348.147L472.861 354.38V367.566L483.681 361.317Z",
    fill: "#0A0808"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M464.182 327.561L475.594 334.162L464.789 340.411L453.361 333.81L464.182 327.561Z",
    fill: "#574943"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M504.844 333.89L497.892 321.839L487.103 315.621L487.119 312.297L504.844 322.526V333.89Z",
    fill: "#D8D1C7"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M500.177 319.841L488.414 325.099L489.389 332.036L500.177 325.818V319.841Z",
    fill: "#A39C95"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M515.233 320.048L510.934 322.526L507.897 327.321L510.934 332.515L515.233 330.022V320.048Z",
    fill: "#A39C95"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M510.933 322.526H504.844V333.89L510.933 332.515V322.526Z",
    fill: "#B5AFA7"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M515.233 316.532L497.492 306.303H479.015L465.941 313.847V324.508L483.682 334.753H489.772L494.071 332.26V328.759L489.388 326.058L500.177 319.841L504.844 322.526H510.934L515.233 320.048V316.532Z",
    fill: "#E6E1DD"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M488.845 328.759H486.368L484.625 329.782V331.205L486.368 332.212H488.845L490.587 331.205V329.782L488.845 328.759Z",
    fill: "#574943"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M509.815 316.66H507.338L505.596 317.667V319.089L507.338 320.096H509.815L511.557 319.089V317.667L509.815 316.66Z",
    fill: "#574943"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M483.682 346.117L476.73 334.066L465.941 327.832L465.957 324.508L483.682 334.753V346.117Z",
    fill: "#D8D1C7"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M494.072 332.26L489.773 334.753L486.736 339.548L489.773 344.726L494.072 342.249V332.26Z",
    fill: "#A39C95"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M489.772 334.753H483.683V346.117L489.772 344.726V334.753Z",
    fill: "#B5AFA7"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M495.429 314.167L490.986 311.609H484.721L480.277 314.167V317.795L484.721 320.352H490.986L495.429 317.795V314.167Z",
    fill: "#F4EFE9"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M491.002 320.352H484.72V323.309H491.002V320.352Z",
    fill: "#B5AFA7"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M495.43 320.752L490.987 323.309V320.352L495.43 317.795V320.752Z",
    fill: "#A39C95"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M480.277 320.752L484.721 323.309V320.352L480.277 317.795V320.752Z",
    fill: "#D8D1C7"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M492.297 312.888L489.771 311.434H486.207L483.682 312.888V314.95L486.207 316.404H489.771L492.297 314.95V312.888Z",
    fill: "#836E69"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M489.771 316.404H486.207V318.083H489.771V316.404Z",
    fill: "#544540"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M492.296 316.628L489.771 318.083V316.404L492.296 314.95V316.628Z",
    fill: "#403531"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M483.682 316.628L486.207 318.083V316.404L483.682 314.95V316.628Z",
    fill: "#685750"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M480.757 311.545L478.504 310.251H475.323L473.069 311.545V313.384L475.323 314.694H478.504L480.757 313.384V311.545Z",
    fill: "#A39C95"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M479.702 307.438L478.072 306.495H475.754L474.108 307.438V308.78L475.754 309.723H478.072L479.702 308.78V307.438Z",
    fill: "#F59C72"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M478.071 309.723H475.754V313.991H478.071V309.723Z",
    fill: "#B5AFA7"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M479.702 313.048L478.072 313.991V309.723L479.702 308.78V313.048Z",
    fill: "#A39C95"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M474.108 313.048L475.754 313.991V309.723L474.108 308.78V313.048Z",
    fill: "#D8D1C7"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M479.702 309.675L478.503 310.363H475.323L474.108 309.675V310.65L475.323 311.354H478.503L479.702 310.65V309.675Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M480.757 301.684L478.504 300.389H475.323L473.069 301.684V303.522L475.323 304.833H478.504L480.757 303.522V301.684Z",
    fill: "#E6E1DD"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M478.504 304.833H475.323V310.698H478.504V304.833Z",
    fill: "#B5AFA7"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M480.757 309.404L478.503 310.698V304.832L480.757 303.522V309.404Z",
    fill: "#A39C95"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M473.069 309.404L475.323 310.698V304.832L473.069 303.522V309.404Z",
    fill: "#D8D1C7"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M479.926 297.161L478.152 296.138H475.658L473.884 297.161V298.599L475.658 299.622H478.152L479.926 298.599V297.161Z",
    fill: "#836E69"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M478.152 299.622H475.658V304.225H478.152V299.622Z",
    fill: "#544540"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M479.925 303.202L478.151 304.225V299.622L479.925 298.599V303.202Z",
    fill: "#403531"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M473.884 303.202L475.658 304.225V299.622L473.884 298.599V303.202Z",
    fill: "#685750"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M346.387 382.191L333.489 374.743H296.04L283.126 382.191V392.74L296.04 400.188H333.489L346.387 392.74V382.191Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M354.075 218.923L354.842 221.832L354.586 225.604L353.372 228.881L351.518 230.335L350.127 233.244L342.103 242.067L337.868 240.548L336.861 242.067L335.359 243.17L325.385 238.087L323.979 232.509L330.068 227.714L331.906 223.718L341.448 217.405L353.675 216.542L354.075 218.923Z",
    fill: "#F0C6B4"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M292.652 253.079L294.25 258.13L297.91 261.726L302.29 262.685L303.616 259.121L301.938 254.901L294.969 251.337L292.652 253.079Z",
    fill: "#D1D1D1"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M330.899 379.538L335.119 380.273H339.754L341.224 384.908V386.059L338.283 388.137L329.125 390.47L322.7 392.628L318.544 392.085L317.601 388.201V387.05L330.899 379.538Z",
    fill: "#FF8E1C"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M289.199 391.078V392.228L289.998 395.313L293.387 396.048L295.736 394.098L298.214 389.272L302.449 386.059L304.527 382.015V380.88L300.435 378.867L289.199 391.078Z",
    fill: "#FF8E1C"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M330.899 378.387L335.119 379.138H339.754L341.224 381.152V384.908L338.283 386.986L329.125 389.335L322.7 391.477L318.544 390.95L317.601 387.05L318.304 383.502L330.899 378.387Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M292.205 280.059L292.685 283.175L295.833 285.845L297.639 285.557L299.525 284.038L302.274 282.648L302.674 281.609L304.96 280.298L303.585 278.94L300.5 277.07L298.518 273.713L292.205 280.059Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M293.035 253.223L287.473 260.431L285.571 268.727L293.962 283.047L296.328 285.141L299.141 284.022L301.075 282.088L300.116 278.908L298.054 272.227L296.328 264.555L301.89 261.119L302.977 258.769L297.271 250.01L293.035 253.223Z",
    fill: "#F0C6B4"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M314.325 232.509L312.247 231.917L308.619 232.477L304.495 235.546L301.602 240.74L297.543 246.51L292.652 253.079L296.6 254.597L301.235 258.513L302.29 262.685L307.98 255.477L314.325 232.509Z",
    fill: "#F4EFE9"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M330.564 282.504L339.083 274.305L342.407 267.848L337.868 264.619L320.654 282.504L327.511 285.253L330.564 282.504Z",
    fill: "#2D5A78"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M342.408 248.108L339.994 245.999L336.766 243.074L337.165 242.067L335.455 238.694L331.907 234.81L326.169 232.509H323.979L320.159 233.404L319.152 232.509H314.325L308.587 237.24L305.167 243.074L302.178 249.483L300.5 256.867L300.82 265.786L306.861 276.59L319.856 285.253L329.126 282.504L337.469 270.948L342.408 267.847V248.108Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M289.759 385.132L289.199 391.078L289.998 394.178L293.387 394.898L295.736 392.964L298.214 388.137L302.449 384.908L304.527 380.88L303.92 378.387L300.435 377.732L289.759 385.132Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M289.759 305.456L291.07 341.722L288.544 354.173V383.406L291.373 387.449H298.422L300.532 382.591L303.313 356.986L303.952 349.873L306.797 340.075L309.53 323.101L310.425 309.212L289.759 305.456Z",
    fill: "#377691"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M331.907 223.718L334.992 224.389L338.204 226.004L341.033 228.145H344.981L347.602 225.924L349.009 225.252L350.287 225.924L349.744 227.602L349.217 229.152L350.287 230.095L351.998 226.803L353.82 224.213L353.852 221.097L353.244 218.955V217.804L354.075 218.923L354.587 218.619V217.261L353.516 214.112L350.559 211.091L347.81 209.956L343.718 209.285L339.291 210.628L336.334 212.578L334.24 215.327L332.834 217.804L331.907 220.761V223.718Z",
    fill: "#87511B"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M375.317 273.649L380 269.238L383.932 268.79L386.745 270.501L387.8 272.802V278.412H386.393L385.834 277.246L384.379 277.405L378.737 279.819L377.331 279.339L375.317 273.649Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M356.728 265.786L361.364 269.014L366.606 269.797L372.248 272.371L375.317 273.649L377.874 275.583L378.466 277.533L377.331 279.339L365.247 279.819L359.142 278.412L352.988 275.711L348.146 268.743L356.728 265.786Z",
    fill: "#F0C6B4"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M337.277 249.723L342.407 248.108L347.234 251.433L351.054 259.68L357.399 265.322L358.614 270.085L356.201 274.656L350.351 276.59L340.697 269.046L335.598 263.644L334.176 257.538L334.927 252.903L337.277 249.723Z",
    fill: "#F4EFE9"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M311.8 240.548L330.564 250.825L323.707 265.786L323.036 274.305L323.851 279.819L326.264 282.504H330.564L326.936 288.801L327.463 297.257L330.564 319.553L331.091 342.904L330.02 350.017L331.091 377.923L329.125 382.495L322.636 384.908L316.866 383.022L314.996 355.787L317.138 346.916L307.74 317.459L291.773 309.739L289.759 305.456V293.916L297.942 276.59L300.356 267.736L302.641 257.938L307.676 248.108L311.8 240.548Z",
    fill: "#428AA8"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M337.165 242.067L331.906 242.978L326.424 248.572L327.207 251.625L329.748 250.378L334.176 245.887L338.171 244.88L339.994 245.999L337.165 242.067Z",
    fill: "#428AA8"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M312.359 240.868L315.827 235.194L319.152 232.509H323.979L319.823 236.073L315.428 242.93L313.446 244.88L312.359 240.868Z",
    fill: "#428AA8"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M643.737 377.236V367.375L655.805 360.39H672.875L684.958 367.375V377.236L672.875 384.189H655.805L643.737 377.236Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M676.167 365.105V365.92L674.553 369.74L671.868 369.053L672.219 361.972L676.167 365.105Z",
    fill: "#C7AE87"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M660.424 369.42L654.894 371.37L648.692 372.281L647.525 376.085V376.917L650.258 378.946L656.652 380.177H663.109L667.728 381.152H671.964L673.802 377.108V376.277L660.424 369.42Z",
    fill: "#C7AE87"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M675.784 360.917L676.167 365.105L674.553 368.909L671.868 368.238L672.219 361.141L675.784 360.917Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M674.841 315.461L675.752 321.711L678.629 332.675L677.574 359.271L672.619 363.826L668.448 361.349L666.929 317.795L674.841 315.461Z",
    fill: "#377691"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M660.424 368.589L654.894 370.539L648.692 371.466L647.525 373.352V376.085L650.258 378.099L656.652 379.362H663.109L667.728 380.321H671.964L673.802 376.277L673.114 371.067L660.424 368.589Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M644.728 283.127L648.244 304.369L657.499 329.271L659.576 368.781L663.62 372.425L669.758 373.352L673.801 370.619V342.569L670.797 330.198L671.324 313.735L661.798 275.823L649.155 275.04L644.728 283.127Z",
    fill: "#428AA8"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M694.66 230.511L702.875 238.135L699.871 247.309L694.117 252.168L679.844 260.367L675.976 263.74L672.891 263.116L673.882 257.347L676.615 257.586L686.94 244.912L689.37 241.603L686.972 239.765L688.459 233.388L694.66 230.511Z",
    fill: "#F0C6B4"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M673.53 220.777L676.855 219.259H681.41L686.445 221.72L689.034 224.869L694.66 229.999V234.219L691.335 239.318L686.317 239.845L680.371 236.968L673.53 220.777Z",
    fill: "#F4EFE9"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M668.447 214.911L671.276 220.186L671.724 222.871L667.52 227.378L661.559 227.122L655.933 224.869L655.549 220.569L654.958 218.428L653.583 213.776L664.196 211.139L668.447 214.911Z",
    fill: "#F0C6B4"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M646.71 234.091L652.224 229.967L655.74 224.869H660.136H665.714L668.447 223.798L671.276 220.186L673.53 220.777L678.724 221.257L681.457 225.268L683.807 231.614L682.528 239.541L680.578 246.478L677.254 255.652L677.046 260.575L675.687 262.653L676.167 268.79L667.664 274.465L656.524 273.873L648.996 270.053L645.271 244.432L646.71 234.091Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M681.49 306.734L681.874 311.945L680.324 314.806L676.216 317.491L668.4 320.768H655.406L651.985 318.53V315.637L681.49 306.734Z",
    fill: "#17435C"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M675.688 262.653L673.402 266.984L668.512 269.909L659.433 271.316L652.449 270.485L645.736 267.656L643.85 275.439L647.382 278.524L650.451 281.945L651.873 295.163L651.506 307.662L650.93 314.758L653.344 316.756H658.954H668.032L674.649 314.279L680.483 310.347L681.842 305.456L682.337 286.084L680.643 275.759L681.394 270.804L678.485 264.283L675.688 262.653Z",
    fill: "#2D5A78"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M647.989 200.766L647.429 205.657L648.356 207.367L647.909 209.317L651.041 217.788L652.32 218.428H654.957L655.549 215.119L658.378 211.283L652.895 199.935L647.989 200.766Z",
    fill: "#F0C6B4"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M648.692 197.681L647.909 199.935L648.292 203.755L650.45 206.68V209.221L651.537 210.004L652.32 209.221L653.199 209.029L654.67 211.954L655.245 214.799L657.786 217.533L661.51 218.428L666.305 217.053L669.614 213.729L671.276 206.68V201.102L668.447 195.348L663.556 193.094L658.857 191.528L651.537 192.119L647.909 193.382L647.429 195.939L647.909 197.506L648.692 197.681Z",
    fill: "#736656"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M660.728 196.611L659.353 198.081L650.354 197.346L660.728 196.611Z",
    fill: "#5E4439"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M655.741 257.043L650.994 259.792L646.103 259.44L642.251 257.043L643.962 251.529L655.741 253.031V257.043Z",
    fill: "#D1D1D1"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M650.994 276.654L652.225 278.508L651.585 281.193L647.909 283.063L644.872 284.534L641.756 282.472L641.196 280.57L641.995 277.677L650.994 276.654Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M655.293 256.212L652.257 270.549L651.825 275.631L650.067 279.212L646.998 281.881H644.393L641.196 277.773L641.756 272.307L643.018 267.927L643.45 256.052L643.546 252.488L647.318 250.793L654.574 252.488L655.293 256.212Z",
    fill: "#F0C6B4"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M650.259 233.388L655.054 235.05L657.499 241.603V247.645L655.741 257.043L651.33 254.31L646.055 253.91L642.251 257.043L642.187 247.853L641.756 242.179L643.226 237.384L645.864 234.267L650.259 233.388Z",
    fill: "#F4EFE9"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M689.37 241.603L696.914 244.304L695.987 246.478L689.37 241.603Z",
    fill: "#C7A495"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M478.328 513.844V502.097L463.959 493.801H443.613L429.228 502.097V513.844L443.613 522.14H463.959L478.328 513.844Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M460.827 516.769V517.696L462.713 520.046L466.692 519.454L470.209 515.81L474.652 511.335L474.876 508.57V507.643L469.234 504.015L460.827 516.769Z",
    fill: "#362C29"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M438.498 498.389L436.1 500.291V501.218L438.689 508.218L440.943 512.022L442.509 513.013H444.555L446.425 512.022V511.095L438.498 498.389Z",
    fill: "#362C29"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M460.827 508.985V516.769L462.713 519.119L466.692 518.527L470.209 514.883L474.652 510.424L474.876 507.643L471.919 503.599L469.234 503.072L460.827 508.985Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M438.498 497.462L436.452 498.436L436.1 500.291L438.689 507.291L440.943 511.095L442.509 512.07H444.555L446.425 511.095V504.158L438.498 497.462Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M434.358 406.214L435.893 405.367L440.656 404.312L441.583 407.732L440.592 410.385L436.612 411.616L434.358 411.552L432.344 411.952L430.97 410.577L431.305 407.732L434.358 406.214Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M417.145 385.755L409.792 393.491L411.407 401.259L417.145 405.223L430.97 410.577H433.719L435.078 408.291L434.359 406.214L422.435 394.93L425.088 392.772L423.938 386.714L417.145 385.755Z",
    fill: "#F0C6B4"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M439.873 368.334L433.719 367.646L428.333 370.284L425.296 374.407L422.563 378.994L416.985 385.404L418.455 389.064L422.659 392.388L427.646 393.171L434.039 386.347L438.306 380.401L439.873 368.334Z",
    fill: "#F4EFE9"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M448.568 358.999L448.232 362.26L446.49 365.92L447.193 369.117L456.447 371.067L459.82 369.5L461.674 365.92V362.02L462.409 358.999L463.576 356.57L452.835 355.579L448.568 358.999Z",
    fill: "#F0C6B4"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M488.989 338.541L487.63 337.918L484.993 335.824L481.876 334.689H479.622L479.255 333.203L480.949 332.675L485.392 332.931L486.863 330.501L487.438 319.921L488.989 319.537L489.74 325.738L493.656 327.353L496.437 330.342L496.053 337.614L495.574 338.813L492.92 339.676L488.989 338.541Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M481.876 363.315L484.434 359.91L485.473 353.022L488.989 338.541L490.523 336.975H494.024L495.574 338.813L496.054 357.385L493.688 365.92L490.395 370.747L486.128 370.156L481.876 363.315Z",
    fill: "#F0C6B4"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M472.735 371.067L477.13 365.92L481.573 362.596L487.391 363.938L490.524 368.334L490.172 374.727L481.445 385.755L475.372 390.326L469.89 387.961L472.735 371.067Z",
    fill: "#F4EFE9"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M446.49 365.92L449.847 367.742L454.258 368.334L458.653 367.742L461.674 365.92L463.704 368.334L465.686 371.466L469.218 370.459L472.735 371.067L475.1 375.654L475.372 390.326L472.047 398.542L471.088 407.588L469.634 409.506L442.702 409.986L439.873 408.036L438.994 400.012L434.247 390.007L433.72 380.545L436.645 371.466L439.873 368.334H441.344L443.182 369.404L446.49 365.92Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M439.393 383.486L454.257 384.365L470.672 383.486L469.201 400.108L469.633 406.949L471.647 407.844L474.875 425.537L474.188 448.425L471.359 468.948L471.551 480.983L470.576 506.508L468.13 510.424H462.552L459.452 507.835L457.134 482.933L458.157 472.959L455.712 454.083L454.433 437.365L452.978 450.679L449.75 468.756L450.629 479.225L448.967 504.063L445.53 506.3L440.064 505.725L438.114 501.617L437.139 476.683L438.114 463.274L435.956 441.664L435.461 420.055L439.089 408.132L440.943 406.853V399.229L439.872 389.943L439.393 383.486Z",
    fill: "#428AA8"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M464.566 350.033L465.094 351.056L464.566 356.266L463.048 356.698L460.315 351.439L464.566 350.033Z",
    fill: "#F0C6B4"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M445.531 343.208L446.905 339.388L447.593 340.075L451.413 335.68L458.941 334.689L457.854 335.472L463.815 339.036L465.094 344.183V348.866L463.736 351.903L463.432 356.011L461.386 359.735L458.062 360.997L453.075 361.477L449.367 360.022L446.522 356.394L445.051 350.816V346.628L445.531 343.208Z",
    fill: "#362C29"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M463.704 368.334V375.254L463.112 385.404L469.266 385.755L469.633 375.878L469.218 370.459L463.704 368.334Z",
    fill: "#428AA8"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M446.49 365.92L445.051 373.352L446.426 385.404L440.752 385.292L439.873 374.727L441.343 368.334L446.49 365.92Z",
    fill: "#428AA8"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M444.764 435.639L465.59 438.18L446.218 437.493L444.764 435.639Z",
    fill: "#377691"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M469.889 424.978L465.846 425.793H462.138L457.694 424.978V423.348L462.058 424.163H465.846L469.889 423.348V424.978Z",
    fill: "#377691"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M459.596 421.989L461.737 421.142L463.959 421.797H465.909L467.875 422.453L468.642 424.003L468.003 427.391L468.067 433.513L465.845 434.951L463.895 434.232L460.107 435.479L458.685 433.657L459.452 424.786L459.596 421.989Z",
    fill: "#F4EFE9"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M422.435 394.93L418.887 398.67H415.946L422.435 394.93Z",
    fill: "#C7A495"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M485.393 359.191L492.042 360.901L489.692 361.924L485.393 359.191Z",
    fill: "#C7A495"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M268.948 321.903L267.446 321.039L248.57 331.956L239.939 326.953L256.769 317.235V314.966L253.972 313.352H250.024L233.21 323.069L225.25 318.466L153.79 359.703L185.452 377.987L256.913 336.751L250.104 332.819L268.98 321.903H268.948ZM251.239 315.573L252.869 316.548L249.081 318.738L247.435 317.795L251.223 315.589L251.239 315.573Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M240.162 325.259L231.739 320.4L225.809 310.123L225.793 300.405L231.739 296.953L240.162 301.812L246.108 312.137V321.839L240.162 325.259Z",
    fill: "#574943"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M257.44 305.584L251.479 295.291L240.163 301.812L246.108 312.137L257.44 305.584Z",
    fill: "#211A1A"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M257.44 315.286V305.584L246.108 312.137V321.839L257.44 315.286Z",
    fill: "#0A0808"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M243.071 290.4L251.478 295.291L240.162 301.812L231.739 296.953L243.071 290.4Z",
    fill: "#574943"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M247.339 324.108L248.858 322.19L266.023 312.249L268.005 308.86L266.95 305.008L266.023 304.497L246.412 315.813V323.565L247.339 324.108ZM260.925 312.233V310.331L264.713 308.141V310.043L260.925 312.233Z",
    fill: "#D8D1C7"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M266.95 312.792L268.932 309.372V306.159L266.95 305.008L247.339 316.324V324.108L266.95 312.792ZM261.852 312.792V310.89L265.64 308.7V310.602L261.852 312.792Z",
    fill: "#A39C95"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M250.615 322.254L247.339 324.108V316.324L249.241 314.167L249.688 313.911L250.615 314.438V322.254Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M230.38 295.802L237.141 299.718L256.752 288.386V287.299L253.955 284.486H250.007L232.841 294.396L230.396 294.747V295.818L230.38 295.802ZM251.238 286.724L252.868 287.651L249.08 289.856L247.434 288.913L251.222 286.724H251.238Z",
    fill: "#A39C95"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M230.38 294.747L237.141 298.631L256.752 287.315V285.045L253.955 283.431H250.007L230.396 294.747H230.38ZM251.238 285.669L252.868 286.612L249.08 288.801L247.434 287.858L251.222 285.669H251.238Z",
    fill: "#D8D1C7"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M240.625 296.617V297.704L238.483 298.919L237.125 298.631L230.38 294.747L233.864 292.733L240.625 296.617Z",
    fill: "black"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M219.528 343.911L207.701 337.071L199.341 322.59V308.94L207.701 304.113L219.528 310.922L227.887 325.403L227.871 339.052L219.528 343.911Z",
    fill: "#E6E1DD"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M241.242 298.398L219.538 310.929L227.897 325.407L249.601 312.876L241.242 298.398Z",
    fill: "#B5AFA7"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M249.608 326.522V312.872L227.887 325.403L227.871 339.052L249.608 326.522Z",
    fill: "#A39C95"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M232.25 333.458L244.621 326.33V319.137L243.279 319.953L239.155 324.923L232.25 331.908V333.458Z",
    fill: "#D8D1C7"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M232.25 331.908L243.279 325.579V319.953L232.25 326.266V331.908Z",
    fill: "#362C29"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M229.421 291.551L241.233 298.391L219.528 310.922L207.7 304.113L229.421 291.551Z",
    fill: "#E6E1DD"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M199.725 356.97L187.082 349.665L178.132 334.146V319.553L187.082 314.374L199.725 321.695L208.676 337.198V351.791L199.725 356.97Z",
    fill: "#CFDB77"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M228.91 325.515L219.975 310.011L199.725 321.695L208.675 337.198L228.91 325.515Z",
    fill: "#87A15F"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M228.91 340.123V325.515L208.675 337.198V351.791L228.91 340.123Z",
    fill: "#6B874F"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M207.333 302.707L219.975 310.011L199.725 321.695L187.082 314.374L207.333 302.707Z",
    fill: "#CFDB77"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M210.274 337.454L200.301 320.176L188.681 313.447L192.213 311.434L203.817 318.131L213.791 335.408L213.807 348.834L210.274 350.864V337.454Z",
    fill: "black"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M198.527 360.534L184.446 352.366L174.456 335.089V318.802L184.446 313.048L198.527 321.215L208.5 338.461V354.748L198.527 360.534Z",
    fill: "#9FB366"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M212.049 336.447L202.076 319.137L198.527 321.215L208.501 338.461L212.049 336.447Z",
    fill: "#87A15F"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M212.048 352.702V336.447L208.5 338.461V354.748L212.048 352.702Z",
    fill: "#6B874F"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M187.962 311.018L202.075 319.137L198.527 321.215L184.446 313.048L187.962 311.018Z",
    fill: "#CFDB77"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M181.121 366.048L169.293 359.255L160.934 344.774V331.125L169.293 326.298L181.121 333.107L189.464 347.587V361.253L181.121 366.048Z",
    fill: "#574943"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M205.367 338.397L197.024 323.948L181.121 333.107L189.464 347.587L205.367 338.397Z",
    fill: "#211A1A"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M205.384 352.079L205.368 338.397L189.464 347.587V361.253L205.384 352.079Z",
    fill: "#0A0808"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M185.197 317.108L197.024 323.948L181.121 333.107L169.293 326.298L185.197 317.108Z",
    fill: "#362C29"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M180.018 331.045L190.695 349.601V360.534L194.499 358.344V347.428L183.79 328.855L174.328 323.389L170.524 325.579L180.018 331.045Z",
    fill: "black"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M178.467 374.152L163.331 365.409L152.623 346.852V329.367L163.331 323.229L178.467 331.956L189.16 350.464V367.934L178.467 374.152Z",
    fill: "#362C29"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M177.092 334.977L164.689 327.816L155.931 332.867V347.172L164.689 362.34L177.076 369.5L185.835 364.45V350.145L177.092 334.977ZM183.965 363.363L177.076 367.327L166.08 360.981L157.817 346.66V333.954L164.689 329.99L175.702 336.367L183.965 350.624V363.347V363.363Z",
    fill: "#F4EFE9"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M165.777 348.307L179.379 356.154V351.471L165.777 343.624V348.307Z",
    fill: "#F4EFE9"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M161.589 345.925L164.386 347.54V342.824L162.98 342.025L161.589 341.21V345.925Z",
    fill: "#F4EFE9"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M165.121 335.92L162.772 332.643L163.955 335.376L160.47 338.077L162.98 342.025V339.084L165.121 335.92Z",
    fill: "#F4EFE9"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M182.246 329.766L178.469 331.951L189.178 350.462L192.955 348.277L182.246 329.766Z",
    fill: "#211A1A"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M192.948 365.76V348.291L189.16 350.464V367.934L192.948 365.76Z",
    fill: "#0A0808"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M167.104 321.039L182.24 329.782L178.468 331.956L163.332 323.229L167.104 321.039Z",
    fill: "#574943"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M251.479 541.847L198.958 533.711L160.071 511.255L145.462 479.752L160.087 448.249L198.974 425.793L251.495 417.674L304.015 425.793L342.902 448.249L357.527 479.752L342.902 511.255L304.015 533.711L251.495 541.847H251.479ZM212.176 517.648L251.479 523.738L290.797 517.648L319.135 501.281L329.125 479.768L319.135 458.255L290.797 441.888L251.495 435.814L212.192 441.888L183.854 458.255L173.864 479.768L183.838 501.281L212.192 517.648H212.176Z",
    fill: "black"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M181.281 446.044L211.393 432.394V439.666L182.064 456.609L171.307 479.768V472.48L181.281 446.044Z",
    fill: "#D66B24"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M321.693 446.044L291.564 432.394V439.666L320.894 456.609L331.65 479.752V472.48L321.693 446.044Z",
    fill: "#EF8F2D"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M251.479 422.373L211.393 432.394V439.666L251.479 433.465L291.565 439.666V432.394L251.479 422.373Z",
    fill: "#DE822B"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M251.047 529.188L198.878 521.388L199.741 531.506L251.478 539.513L303.232 531.506V524.217L251.047 529.188Z",
    fill: "#DE822B"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M167.967 497.509L147.988 472.48V479.752L161.846 509.625L199.742 531.506V524.217L167.967 497.509Z",
    fill: "#EF8F2D"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M335.022 497.509L354.985 472.48V479.752L341.112 509.625L303.232 531.506V524.217L335.022 497.509Z",
    fill: "#D66B24"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M199.742 524.217L161.846 502.352L147.988 472.48L161.862 442.607L199.742 420.726L251.479 412.735L303.217 420.726L341.097 442.607L354.97 472.48L341.097 502.352L303.217 524.217L251.463 532.225L199.726 524.217H199.742ZM182.048 495.623L211.393 512.566L251.479 518.767L291.565 512.566L320.91 495.623L331.651 472.48L320.91 449.336L291.565 432.394L251.479 426.193L211.393 432.394L182.048 449.336L171.308 472.48L182.048 495.623Z",
    fill: "#FDBD6F"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M323.291 418.776L335.038 444.094V472.48L323.291 447.163L292.603 429.437V401.067L323.291 418.776Z",
    fill: "#E3BD5E"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M179.682 418.776L167.935 444.094V472.48L179.682 447.163L210.37 429.453V401.067L179.682 418.776Z",
    fill: "#CC934C"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M251.479 394.706L210.37 401.067V429.453L251.479 423.156V423.092L292.603 429.437V401.067L251.479 394.706Z",
    fill: "#D6A950"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.29 418.776L321.772 417.913V446.284L323.29 447.163L325.672 452.293V423.923L323.29 418.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.584 411.44V439.826L314.484 442.08V413.71L310.584 411.44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.039 444.094L332.945 439.603V467.989L335.039 472.48V444.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.412 404.999V433.369L303.312 435.639V407.253L299.412 404.999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.224 400.396V428.766L292.124 429.373V400.987L288.224 400.396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.879 396.928V425.314L269.779 425.921V397.535L265.879 396.928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.935 444.094V472.48L169.149 469.843V441.457L167.935 444.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.052 398.654V427.04L280.952 427.647V399.261L277.052 398.654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.331 397.663V426.097L236.231 425.489V397.071L232.331 397.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.143 399.405V427.791L225.059 427.2V398.798L221.143 399.405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.682 418.776L176.438 425.761V454.147L179.682 447.163L180.337 446.795V418.409L179.682 418.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.591 395.809L254.691 395.201V423.587L258.591 424.179V395.809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.52 395.937V424.371L247.419 423.779V395.329L243.52 395.937Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61 414.205V442.591L191.51 440.338V411.952L187.61 414.205Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.798 407.748V436.134L202.698 433.881V405.494L198.798 407.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.369 401.067L209.97 401.291V429.677L210.369 429.453L213.87 428.91V400.524L210.369 401.067Z",
    fill: "black"
  }))), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M351.597 444.094L338.731 416.379L302.177 395.281L251.479 387.434L200.78 395.281L164.243 416.379L151.392 444.078L164.243 471.793L200.796 492.89L251.511 500.738L302.225 492.89L338.763 471.793L351.613 444.094H351.597ZM323.291 469.411L292.619 487.12L251.495 493.482L210.37 487.12L179.682 469.395L167.935 444.094L179.682 418.776L210.37 401.067L251.495 394.706L292.619 401.067L323.307 418.776L335.055 444.094L323.307 469.411H323.291Z",
    fill: "#FBE979"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M251.479 500.754L200.781 492.906V521.292L251.479 529.188V529.124L302.21 521.292V492.906L251.479 500.754Z",
    fill: "#D6A950"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M338.747 471.809L302.209 492.906V521.292L338.747 500.243V500.179L351.597 472.48V444.094L338.747 471.809Z",
    fill: "#CC934C"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M164.227 471.809L200.78 492.906V521.292L164.227 500.243L151.376 472.48V444.094L164.227 471.809Z",
    fill: "#E3BD5E"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.124 522.843V494.457L288.224 495.064V523.434L292.124 522.843Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.88 526.903L269.78 526.295V497.925L265.88 498.516V526.903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.21 521.292L303.313 520.637V492.251L302.21 492.906L299.413 493.338V521.708L302.21 521.292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.845 501.33V472.895L332.945 475.149V503.567L336.845 501.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.484 514.196V485.81L310.584 488.047V516.45L314.484 514.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.034 480.168V451.782L344.134 460.189V488.575L348.034 480.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.591 528.037V499.635L254.691 500.243V528.629L258.591 528.037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.672 507.755V479.353L321.772 481.59V510.008L325.672 507.755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.952 524.569V496.183L277.052 496.806V525.176L280.952 524.569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.51 487.552L187.61 485.298V513.7L191.51 515.938V487.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.338 481.095L176.438 478.857V507.259L180.338 509.513V481.095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.698 521.58V493.194L200.78 492.906L198.798 491.756V520.142L200.78 521.292L202.698 521.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.871 494.92L209.971 494.329V522.715L213.871 523.322V494.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.231 526.807V498.389L232.331 497.781V526.199L236.231 526.807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.15 474.638L165.25 472.4V500.834L169.15 503.072V474.638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.419 528.549V500.115L243.52 499.507V527.941L247.419 528.549Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.143 524.457L225.059 525.064V496.662L221.143 496.055V524.457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.977 458.319L154.077 449.912V478.314L157.977 486.737V458.319Z",
    fill: "black"
  }))), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M181.281 410.385L211.393 396.72V404.008L182.064 420.95L171.307 444.094V436.821L181.281 410.385Z",
    fill: "#D66B24"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M321.693 410.369L291.564 396.72V404.008L320.894 420.95L331.65 444.094V436.821L321.693 410.369Z",
    fill: "#EF8F2D"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M251.479 386.714L211.393 396.72V404.008L251.479 397.823L291.565 404.008V396.72L251.479 386.714Z",
    fill: "#DE822B"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M251.047 493.53L198.878 485.73L199.741 495.847L251.478 503.855L303.232 495.847V488.559L251.047 493.53Z",
    fill: "#DE822B"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M167.967 461.851L147.988 436.821V444.094L161.846 473.966L199.742 495.847V488.559L167.967 461.851Z",
    fill: "#EF8F2D"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M335.022 461.851L354.985 436.821V444.094L341.112 473.966L303.232 495.847V488.559L335.022 461.851Z",
    fill: "#D66B24"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M199.742 488.559L161.846 466.694L147.988 436.821L161.862 406.949L199.742 385.068L251.479 377.06L303.217 385.068L341.097 406.949L354.97 436.821L341.097 466.694L303.217 488.559L251.463 496.567L199.726 488.559H199.742ZM182.048 459.949L211.393 476.891L251.479 483.093L291.565 476.891L320.91 459.949L331.651 436.805L320.91 413.662L291.565 396.72L251.479 390.518L211.393 396.72L182.048 413.662L171.308 436.805L182.048 459.933V459.949Z",
    fill: "#FDBD6F"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M674.425 483.396L568.217 544.724L550.092 534.255L656.3 472.943L674.425 483.396Z",
    fill: "black"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M581.452 512.422V523.13L577.872 529.316L565.676 536.365L562.096 534.303V523.61L565.676 517.409L577.872 510.36L581.452 512.422Z",
    fill: "#D8D1C7"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M553.647 510.429L550.065 516.63L562.065 523.561L565.646 517.36L553.647 510.429Z",
    fill: "#D8D1C7"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M565.868 503.439L553.673 510.472L565.676 517.409L577.871 510.36L565.868 503.439Z",
    fill: "#E6E1DD"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M550.092 527.366V516.673L562.096 523.61V534.303L550.092 527.366Z",
    fill: "#B5AFA7"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M667.68 462.65V473.343L664.1 479.544L640.733 493.034L637.152 490.956V480.264L640.733 474.062L664.1 460.572L667.68 462.65Z",
    fill: "#D8D1C7"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M628.709 467.113L625.129 473.315L637.131 480.241L640.711 474.04L628.709 467.113Z",
    fill: "#D8D1C7"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M652.097 453.652L628.729 467.141L640.733 474.062L664.1 460.572L652.097 453.652Z",
    fill: "#E6E1DD"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M625.149 484.036V473.343L637.153 480.264V490.956L625.149 484.036Z",
    fill: "#B5AFA7"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M674.49 466.582V477.275L670.91 483.476L572.485 540.296L568.905 538.235V527.542L572.485 521.34L670.91 464.52L674.49 466.582Z",
    fill: "#A39C95"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M647.19 497.174L646.407 497.621V478.665L647.19 478.202V497.174Z",
    fill: "#574943"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M565.687 517.43L562.107 523.631L568.917 527.563L572.497 521.362L565.687 517.43Z",
    fill: "#D8D1C7"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M664.1 460.572L565.676 517.409L572.485 521.34L670.909 464.52L664.1 460.572Z",
    fill: "#E6E1DD"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M562.096 534.303V523.61L568.905 527.542V538.235L562.096 534.303Z",
    fill: "#B5AFA7"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M667.695 475.325V481.175L664.115 487.376L659.048 490.285L655.468 488.223V482.389L659.048 476.188L664.115 473.263L667.695 475.325Z",
    fill: "#87817C"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M662.629 476.588L662.022 476.236L661.143 476.731L660.535 477.802V486.961L661.143 487.312L662.022 486.817L662.629 485.762V476.588Z",
    fill: "#211A1A"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M657.182 475.071L653.603 481.273L655.458 482.343L659.037 476.142L657.182 475.071Z",
    fill: "#D8D1C7"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M662.261 472.192L657.194 475.117L659.048 476.188L664.115 473.263L662.261 472.192Z",
    fill: "#E6E1DD"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M653.614 487.152V481.303L655.468 482.389V488.223L653.614 487.152Z",
    fill: "#B5AFA7"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M520.38 439.331C513.955 443.039 508.728 452.037 508.728 459.422C508.728 462.986 509.943 465.527 511.925 466.774C512.692 467.253 515.505 468.868 515.505 468.868C515.505 468.868 522.122 470.786 524.248 469.555C530.673 465.847 537.274 458.319 537.274 450.935C537.274 449.049 531.68 442.495 531.072 441.233C529.282 437.509 525.175 436.566 520.38 439.331ZM520.38 463.881C517.567 465.495 515.041 465.607 513.267 464.44C511.637 463.385 512.74 461.643 512.74 458.686C512.74 452.501 514.993 444.621 520.38 441.505C525.766 438.404 530.129 440.881 530.129 447.067C530.129 453.252 525.766 460.78 520.38 463.881Z",
    fill: "url(#paint0_linear_46_6883)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M532.191 440.577L528.93 438.691L519.101 440.753L511.429 449.96L508.983 456.449L511.365 457.823L511.653 463.929L514.418 468.228L515.505 468.868L514.45 466.262L513.267 459.15L516.4 449.033L525.158 441.457L532.191 440.577Z",
    fill: "url(#paint1_linear_46_6883)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M535.979 440.865L545.92 446.619L542.484 448.601L532.526 442.847L535.979 440.865Z",
    fill: "#D4D4D8"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M508.983 456.449L511.365 457.823L507.145 460.253L504.78 458.878L508.983 456.449Z",
    fill: "#D4D4D8"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M543.555 445.245L545.921 446.619L541.717 449.049L539.335 447.674L543.555 445.245Z",
    fill: "#D4D4D8"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M527.955 443.71C521.53 447.418 516.304 456.417 516.304 463.801C516.304 467.365 517.518 469.907 519.5 471.153C520.268 471.633 523.081 473.247 523.081 473.247C523.081 473.247 527.204 473.567 529.33 472.336C535.755 468.628 542.356 461.1 542.356 453.716C542.356 451.83 539.255 446.891 538.648 445.612C536.858 441.888 532.75 440.945 527.955 443.71ZM527.955 468.26C525.142 469.875 522.617 469.986 520.843 468.82C519.213 467.765 520.315 466.023 520.315 463.066C520.315 456.88 522.569 449.001 527.955 445.884C533.342 442.783 537.705 445.261 537.705 451.446C537.705 457.632 533.342 465.16 527.955 468.26Z",
    fill: "url(#paint2_linear_46_6883)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M524.647 441.792C518.222 445.5 512.995 454.499 512.995 461.883C512.995 465.447 514.21 467.989 516.192 469.235C516.959 469.715 519.772 471.329 519.772 471.329C519.772 471.329 523.896 471.649 526.021 470.418C532.447 466.71 539.048 459.182 539.048 451.798C539.048 449.912 535.947 444.973 535.34 443.694C533.549 439.97 529.442 439.027 524.647 441.792ZM524.647 466.342C521.834 467.957 519.308 468.069 517.534 466.902C515.904 465.847 517.007 464.105 517.007 461.148C517.007 454.962 521.466 450.439 526.837 447.322C530.113 445.42 530.832 442.256 532.59 444.094C533.725 445.261 534.381 447.115 534.381 449.528C534.381 455.714 530.017 463.242 524.631 466.342H524.647Z",
    fill: "url(#paint3_linear_46_6883)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M518.941 461.276L517.343 464.872L520.172 471.745L523.081 473.247L518.941 461.276Z",
    fill: "#A5A7B3"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M536.507 443.071L528.931 438.691L519.117 443.454L516.576 460.828L528.755 446.012L536.507 443.071Z",
    fill: "url(#paint4_linear_46_6883)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M506.778 463.274V476.156L516.735 481.894L518.414 476.364L524.775 480.04L524.168 475.693L516.735 469.028L506.778 463.274Z",
    fill: "#9698A6"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M532.559 435.655L534.173 372.681L530.848 370.763L527.876 372.473V440.434C527.876 440.434 527.812 440.45 527.764 440.466C527.876 440.434 531.184 442.352 531.184 442.352L540.103 438.596L536.778 436.678L532.527 435.639L532.559 435.655Z",
    fill: "#BDBDC6"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M532.462 434.999L534.172 437.157L540.118 438.612L534.907 435.607L532.462 434.999Z",
    fill: "#D4D4D8"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M541.717 449.049C541.892 449.864 541.972 450.759 541.972 451.718C541.972 459.102 536.762 468.101 530.321 471.809C523.895 475.517 518.669 472.544 518.669 465.176C518.669 464.201 518.765 463.21 518.925 462.203L514.705 464.632V470.178L516.703 469.027V481.91L523.752 477.834L524.742 480.04L535.867 473.615L536.858 470.258L543.906 466.182V453.3L545.904 452.149V446.587L541.685 449.017L541.717 449.049Z",
    fill: "#B4B5BF"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M527.875 372.489L521.402 376.229V444.19C521.402 444.19 521.466 444.126 521.498 444.094C521.562 444.03 521.626 443.982 521.69 443.918C521.769 443.838 521.865 443.774 521.945 443.694C522.009 443.646 522.073 443.598 522.121 443.534C522.249 443.423 522.393 443.311 522.521 443.215C522.569 443.183 522.601 443.151 522.649 443.119C522.776 443.023 522.888 442.927 523.016 442.847C523.08 442.799 523.128 442.767 523.192 442.719C523.288 442.639 523.4 442.575 523.496 442.511C523.56 442.463 523.608 442.432 523.671 442.4C523.783 442.336 523.879 442.256 523.991 442.192C524.039 442.16 524.087 442.128 524.151 442.096C524.311 442 524.471 441.904 524.63 441.808C524.79 441.712 524.95 441.632 525.11 441.552C525.158 441.52 525.206 441.505 525.27 441.473C525.382 441.425 525.478 441.361 525.589 441.313C525.653 441.281 525.701 441.249 525.765 441.233C525.861 441.185 525.973 441.137 526.069 441.089C526.133 441.057 526.181 441.041 526.245 441.009C526.373 440.961 526.485 440.913 526.612 440.865C526.66 440.849 526.692 440.833 526.74 440.817C526.868 440.769 527.012 440.721 527.14 440.673C527.204 440.657 527.268 440.641 527.316 440.609C527.412 440.577 527.491 440.562 527.571 440.53C527.635 440.514 527.699 440.498 527.763 440.482C527.795 440.482 527.827 440.466 527.875 440.45V372.489Z",
    fill: "#A5A7B3"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M528.435 443.454C528.275 443.534 528.115 443.63 527.956 443.71C528.115 443.614 528.275 443.534 528.435 443.454Z",
    fill: "#BEBEC6"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M526.838 444.429C526.742 444.494 526.63 444.574 526.534 444.638C526.63 444.558 526.742 444.494 526.838 444.429Z",
    fill: "#BEBEC6"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M526.357 444.765C526.229 444.861 526.117 444.941 525.989 445.037C526.117 444.941 526.229 444.845 526.357 444.765Z",
    fill: "#BEBEC6"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M530.898 442.448C530.818 442.48 530.721 442.496 530.641 442.528C530.737 442.496 530.818 442.48 530.898 442.448Z",
    fill: "#BEBEC6"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M519.516 375.126L516.543 376.837V441.313L510.598 449.64V458.255L515.808 461.26C516.719 455.873 518.669 448.601 522.809 444.893C522.777 444.925 524.775 378.099 524.743 378.131L519.532 375.126H519.516Z",
    fill: "#9698A6"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M524.727 378.147L521.754 379.857V444.334L515.809 452.661V461.276L516.576 460.828C517.487 455.442 520.699 449.72 524.823 446.012C524.791 446.044 524.759 446.076 524.727 446.108V378.147Z",
    fill: "#B4B5BF"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M525.287 445.612C525.191 445.692 525.11 445.757 525.03 445.837C525.11 445.757 525.207 445.692 525.287 445.612Z",
    fill: "#BEBEC6"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M525.861 445.133C525.734 445.245 525.59 445.34 525.462 445.452C525.59 445.34 525.734 445.229 525.861 445.133Z",
    fill: "#BEBEC6"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M534.173 437.157V372.681L531.2 374.391V442.352C531.2 442.352 531.136 442.368 531.104 442.384C535.244 441.313 538.441 443.343 539.352 447.674L540.119 447.227V438.612L534.173 437.157Z",
    fill: "#B4B5BF"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M529.555 442.911C529.555 442.911 529.443 442.959 529.378 442.991C529.443 442.959 529.491 442.943 529.555 442.911Z",
    fill: "#818175"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M531.089 442.4C531.089 442.4 530.961 442.432 530.897 442.448C530.961 442.432 531.025 442.416 531.089 442.4Z",
    fill: "#818175"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M530.625 442.527C530.625 442.527 530.497 442.56 530.449 442.592C530.513 442.576 530.577 442.56 530.625 442.527Z",
    fill: "#818175"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M530.05 442.719C530.05 442.719 529.969 442.751 529.921 442.767C529.969 442.751 530.002 442.735 530.05 442.719Z",
    fill: "#818175"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M525.015 445.836C525.015 445.836 524.887 445.948 524.823 446.012C524.887 445.948 524.951 445.9 525.015 445.836Z",
    fill: "#818175"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M527.013 444.302C527.013 444.302 526.901 444.382 526.837 444.414C526.901 444.382 526.949 444.334 527.013 444.302Z",
    fill: "#818175"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M529.091 443.135C529.091 443.135 528.979 443.183 528.915 443.215C528.979 443.183 529.027 443.167 529.091 443.135Z",
    fill: "#818175"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M527.477 443.998C527.477 443.998 527.381 444.062 527.316 444.094C527.365 444.062 527.413 444.03 527.477 443.998Z",
    fill: "#818175"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M525.99 445.037C525.99 445.037 525.909 445.101 525.861 445.133C525.909 445.101 525.942 445.069 525.99 445.037Z",
    fill: "#818175"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M528.579 443.375C528.579 443.375 528.483 443.423 528.419 443.455C528.467 443.423 528.515 443.407 528.579 443.375Z",
    fill: "#818175"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M525.463 445.468C525.463 445.468 525.334 445.565 525.286 445.629C525.35 445.581 525.414 445.532 525.463 445.468Z",
    fill: "#818175"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M526.533 444.637C526.533 444.637 526.421 444.717 526.357 444.765C526.405 444.717 526.469 444.685 526.533 444.637Z",
    fill: "#818175"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M539.767 444.941L536.507 443.071L526.677 445.133L519.021 454.339L516.576 460.828L518.941 462.203L519.229 468.308L521.994 472.608L523.081 473.247L522.042 470.642L520.859 463.529L523.976 453.412L532.751 445.836L539.767 444.941Z",
    fill: "url(#paint5_linear_46_6883)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M531.28 445.628C524.855 449.336 519.628 458.335 519.628 465.719C519.628 473.103 524.839 476.076 531.28 472.352C537.721 468.628 542.932 459.645 542.932 452.261C542.932 444.877 537.721 441.904 531.28 445.628ZM531.28 470.178C525.894 473.279 521.53 470.802 521.53 464.616C521.53 458.431 525.894 450.903 531.28 447.802C536.666 444.701 541.03 447.179 541.03 453.364C541.03 459.55 536.666 467.078 531.28 470.178Z",
    fill: "#D3D3D6"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M516.576 460.828L518.941 462.203L514.737 464.632L512.356 463.258L516.576 460.828Z",
    fill: "#D4D4D8"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M508.216 456.896L518.174 462.65L514.737 464.632L504.78 458.878L508.216 456.896Z",
    fill: "#D4D4D8"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M516.527 441.313L521.754 444.334L515.792 452.661L510.582 449.64L516.527 441.313Z",
    fill: "#D4D4D8"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M504.78 464.44L514.737 470.178V464.632L504.78 458.878V464.44Z",
    fill: "#A5A7B3"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M538.569 394.114C531.057 398.334 519.037 398.206 511.733 393.843C504.429 389.479 504.605 382.527 512.117 378.307C519.629 374.088 531.648 374.215 538.952 378.579C546.257 382.942 546.081 389.895 538.569 394.114ZM537.13 393.251C543.827 389.495 543.987 383.294 537.466 379.394C530.961 375.494 520.252 375.398 513.539 379.154C506.826 382.91 506.682 389.112 513.203 393.012C519.709 396.912 530.417 397.007 537.13 393.251Z",
    fill: "#DDDDDE"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M537.129 392.34C530.432 396.096 519.724 395.984 513.202 392.101C510.006 390.183 508.407 387.721 508.423 385.244V386.155C508.423 388.616 510.006 391.094 513.202 393.012C519.708 396.911 530.416 397.007 537.129 393.251C540.534 391.333 542.244 388.792 542.26 386.251V385.34C542.26 387.881 540.534 390.422 537.129 392.34Z",
    fill: "#BEBEC6"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M538.441 374.871C535.804 373.304 532.543 372.297 529.107 371.866C529.011 371.866 528.931 371.85 528.835 371.834C532.016 372.233 535.053 373.161 537.482 374.615C543.987 378.515 543.843 384.716 537.146 388.472C530.449 392.228 519.741 392.117 513.22 388.233C506.714 384.333 506.858 378.131 513.555 374.375C515.953 373.033 518.862 372.186 521.914 371.818C521.819 371.818 521.739 371.834 521.643 371.85C518.35 372.234 515.201 373.161 512.612 374.615C505.388 378.675 505.212 385.372 512.245 389.575C519.277 393.779 530.833 393.891 538.073 389.831C545.298 385.771 545.474 379.074 538.441 374.871Z",
    fill: "#D4D4D8"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M537.146 387.977C530.449 391.733 519.74 391.621 513.219 387.737C510.022 385.819 508.424 383.358 508.44 380.88V381.376C508.44 383.837 510.022 386.315 513.219 388.233C519.724 392.133 530.433 392.228 537.146 388.472C540.55 386.554 542.26 384.013 542.276 381.472V380.976C542.276 383.518 540.55 386.059 537.146 387.977Z",
    fill: "#A5A7B3"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M538.456 371.722C535.851 370.172 532.622 369.165 529.234 368.733C529.138 368.733 529.042 368.717 528.946 368.701C532.095 369.101 535.084 370.028 537.497 371.466C544.002 375.366 543.858 381.568 537.161 385.324C530.465 389.08 519.756 388.968 513.235 385.084C506.73 381.184 506.873 374.983 513.57 371.227C515.936 369.9 518.813 369.053 521.834 368.685C521.738 368.685 521.642 368.701 521.546 368.717C518.285 369.117 515.185 370.028 512.627 371.466C505.403 375.526 505.227 382.223 512.26 386.427C519.292 390.63 530.848 390.742 538.088 386.682C545.313 382.623 545.489 375.926 538.456 371.722Z",
    fill: "#D4D4D8"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M537.161 384.812C530.464 388.568 519.756 388.456 513.235 384.572C510.038 382.655 508.44 380.193 508.456 377.716V378.211C508.456 380.673 510.038 383.15 513.235 385.068C519.74 388.968 530.448 389.064 537.161 385.308C540.566 383.39 542.276 380.848 542.292 378.307V377.812C542.292 380.353 540.566 382.894 537.161 384.812Z",
    fill: "#A5A7B3"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M538.456 368.557C535.851 367.007 532.622 366 529.234 365.569C529.138 365.569 529.042 365.553 528.946 365.537C532.095 365.936 535.084 366.863 537.497 368.302C544.002 372.202 543.858 378.403 537.161 382.159C530.465 385.915 519.756 385.803 513.235 381.919C506.73 378.019 506.873 371.818 513.57 368.062C515.936 366.735 518.813 365.888 521.834 365.521C521.738 365.521 521.642 365.537 521.546 365.553C518.285 365.952 515.185 366.863 512.627 368.302C505.403 372.361 505.227 379.058 512.26 383.262C519.292 387.465 530.848 387.577 538.073 383.518C545.297 379.458 545.473 372.761 538.44 368.557H538.456Z",
    fill: "#D4D4D8"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M537.161 381.664C530.464 385.42 519.756 385.308 513.235 381.424C510.038 379.506 508.44 377.044 508.456 374.567V375.063C508.456 377.524 510.038 380.001 513.235 381.919C519.74 385.819 530.448 385.915 537.161 382.159C540.566 380.241 542.276 377.7 542.292 375.158V374.663C542.292 377.204 540.566 379.746 537.161 381.664Z",
    fill: "#A5A7B3"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M538.472 365.409C535.866 363.858 532.638 362.851 529.249 362.42C529.154 362.42 529.058 362.404 528.962 362.388C532.11 362.787 535.099 363.715 537.513 365.153C544.018 369.053 543.874 375.254 537.177 379.01C530.48 382.766 519.771 382.655 513.25 378.771C506.745 374.871 506.889 368.669 513.586 364.913C515.951 363.587 518.828 362.74 521.849 362.372C521.753 362.372 521.657 362.388 521.562 362.404C518.301 362.803 515.2 363.715 512.643 365.153C505.419 369.213 505.243 375.91 512.275 380.113C519.308 384.317 530.864 384.429 538.088 380.369C545.313 376.309 545.488 369.612 538.456 365.409H538.472Z",
    fill: "#D4D4D8"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M538.568 394.114C531.056 398.334 519.037 398.206 511.732 393.843C508.136 391.701 506.362 388.92 506.362 386.155L506.314 403.257C506.314 406.022 508.088 408.803 511.684 410.945C518.989 415.308 530.992 415.436 538.52 411.216C542.34 409.075 544.258 406.23 544.274 403.369L544.322 386.267C544.322 389.128 542.388 391.973 538.568 394.114Z",
    fill: "url(#paint6_linear_46_6883)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M538.073 389.815C530.848 393.875 519.276 393.763 512.244 389.559C508.791 387.497 507.065 384.828 507.081 382.159V383.23C507.081 385.899 508.791 388.568 512.244 390.63C519.276 394.834 530.832 394.946 538.073 390.886C541.749 388.824 543.603 386.075 543.603 383.326V382.255C543.603 385.004 541.749 387.753 538.073 389.815Z",
    fill: "#BEBEC6"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M538.104 383.518C530.88 387.577 519.308 387.465 512.292 383.262C508.839 381.2 507.113 378.531 507.129 375.862V376.933C507.129 379.602 508.839 382.271 512.292 384.333C519.324 388.536 530.88 388.648 538.104 384.589C541.781 382.527 543.635 379.778 543.635 377.028V375.958C543.635 378.707 541.781 381.456 538.104 383.518Z",
    fill: "#BEBEC6"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M538.104 380.369C530.88 384.429 519.308 384.317 512.292 380.113C508.839 378.051 507.113 375.382 507.129 372.713V373.784C507.129 376.453 508.839 379.122 512.292 381.184C519.324 385.388 530.88 385.5 538.104 381.44C541.781 379.378 543.635 376.629 543.635 373.88V372.809C543.635 375.558 541.781 378.307 538.104 380.369Z",
    fill: "#BEBEC6"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M538.632 370.124C531.12 374.343 519.1 374.215 511.796 369.852C508.2 367.71 506.426 364.929 506.426 362.164L506.394 371.227C506.394 373.992 508.168 376.773 511.764 378.914C519.068 383.278 531.072 383.406 538.6 379.186C542.42 377.044 544.338 374.199 544.354 371.338L544.386 362.276C544.386 365.137 542.452 367.982 538.632 370.124Z",
    fill: "url(#paint7_linear_46_6883)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M538.633 370.124C531.121 374.343 519.101 374.215 511.797 369.852C504.493 365.489 504.669 358.536 512.181 354.316C519.693 350.097 531.712 350.225 539.016 354.588C546.321 358.952 546.145 365.904 538.633 370.124ZM534.157 367.455C539.128 364.658 539.24 360.054 534.413 357.177C529.586 354.284 521.627 354.205 516.656 357.002C511.685 359.799 511.573 364.402 516.4 367.279C521.227 370.172 529.187 370.252 534.157 367.455Z",
    fill: "url(#paint8_linear_46_6883)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M538.073 390.886C530.848 394.946 519.276 394.834 512.244 390.63C510.598 389.639 509.335 388.52 508.488 387.322L509.719 389.048C510.518 390.151 511.668 391.19 513.203 392.117C519.708 396.016 530.417 396.112 537.13 392.356C538.808 391.413 540.071 390.31 540.934 389.144C541.349 388.568 541.765 388.009 542.18 387.433C541.253 388.696 539.895 389.879 538.073 390.902V390.886Z",
    fill: "#9698A6"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M538.089 386.666C530.864 390.726 519.292 390.614 512.26 386.411C508.807 384.349 507.081 381.68 507.097 379.01V380.081C507.097 382.75 508.807 385.42 512.26 387.481C519.292 391.685 530.848 391.797 538.073 387.737C541.749 385.675 543.603 382.926 543.603 380.177V379.106C543.603 381.855 541.749 384.604 538.073 386.666H538.089Z",
    fill: "#BEBEC6"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M536.074 358.408C535.291 357.673 534.492 356.938 533.709 356.202C536.09 358.424 535.579 361.365 532.222 363.235C528.354 365.409 522.169 365.345 518.413 363.091C515.216 361.173 514.8 358.296 517.134 356.138C516.335 356.874 515.552 357.593 514.753 358.328C511.748 361.093 512.275 364.801 516.399 367.263C521.226 370.156 529.185 370.236 534.156 367.439C538.472 365.025 539.127 361.237 536.074 358.392V358.408Z",
    fill: "url(#paint9_linear_46_6883)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M532.223 363.235C528.355 365.409 522.169 365.345 518.413 363.091C514.657 360.838 514.737 357.257 518.605 355.1C522.473 352.926 528.659 352.99 532.415 355.243C536.171 357.497 536.091 361.077 532.223 363.235Z",
    fill: "url(#paint10_linear_46_6883)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M543.331 399.9C543.331 402.953 541.173 406.677 538.52 408.212C535.867 409.746 533.709 408.515 533.709 405.463C533.709 402.41 535.867 398.686 538.52 397.151C541.173 395.617 543.331 396.848 543.331 399.9Z",
    fill: "#DDDDDE"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M541.142 396.528C541.621 397.103 541.909 397.966 541.909 399.069C541.909 402.122 539.751 405.846 537.098 407.38C536.123 407.94 535.228 408.132 534.477 408.004C535.34 409.043 536.826 409.187 538.536 408.212C541.19 406.677 543.347 402.953 543.347 399.9C543.347 397.966 542.468 396.752 541.158 396.528H541.142Z",
    fill: "url(#paint11_linear_46_6883)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M413.724 279.387L416.649 284.502L432.887 275.12C433.271 274.896 433.511 274.433 433.511 273.761C433.511 272.435 432.584 270.82 431.433 270.149C430.858 269.813 430.33 269.781 429.963 270.005L413.74 279.371L413.724 279.387Z",
    fill: "url(#paint12_linear_46_6883)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M413.5 319.01L416.425 324.124L432.664 314.742C433.047 314.518 433.287 314.055 433.287 313.384C433.287 312.057 432.36 310.443 431.209 309.771C430.634 309.436 430.107 309.404 429.739 309.627L413.516 318.994L413.5 319.01Z",
    fill: "url(#paint13_linear_46_6883)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M381.39 283.863L384.315 288.977L400.553 279.595C400.937 279.371 401.177 278.908 401.177 278.237C401.177 276.91 400.25 275.296 399.099 274.624C398.524 274.289 397.996 274.257 397.629 274.481L381.406 283.847L381.39 283.863Z",
    fill: "#8F9584"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M383.243 265.674L384.123 267.208C382.237 270.309 381.182 274.465 381.182 279.515C381.182 296.298 392.881 316.644 407.314 324.987C411.646 327.481 415.721 328.615 419.317 328.52L420.165 330.006L423.745 327.928C428.476 325.163 431.401 319.265 431.401 310.874C431.401 294.108 419.701 273.745 405.268 265.402C398.06 261.23 391.523 260.863 386.792 263.628L383.227 265.674H383.243Z",
    fill: "url(#paint14_linear_46_6883)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M420.065 330.06C430.333 324.206 430.434 305.038 420.291 287.247C410.147 269.456 393.601 259.78 383.333 265.634C373.065 271.489 372.964 290.657 383.107 308.447C393.251 326.238 409.797 335.914 420.065 330.06Z",
    fill: "url(#paint15_linear_46_6883)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M370.025 294.22L388.854 327.161L411.086 314.327C413.548 312.92 415.066 309.899 415.066 305.568C415.066 296.985 409.072 286.58 401.688 282.312C397.98 280.17 394.623 279.995 392.21 281.417L370.025 294.22Z",
    fill: "url(#paint16_linear_46_6883)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M404.79 323.821C404.854 324.764 405.174 325.834 405.765 326.873C406.34 327.88 407.092 328.695 407.859 329.223L408.722 330.725L410.576 329.654C411.902 328.871 411.902 326.378 410.576 324.076C409.249 321.775 407.108 320.544 405.781 321.295L403.943 322.35L404.774 323.821H404.79Z",
    fill: "url(#paint17_linear_46_6883)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M403.942 327.944C405.269 330.246 407.427 331.492 408.753 330.725C410.08 329.942 410.08 327.449 408.753 325.147C407.427 322.846 405.269 321.599 403.942 322.366C402.616 323.149 402.616 325.643 403.942 327.944Z",
    fill: "#C3C3CA"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M409.409 281.689C409.473 282.632 409.793 283.703 410.384 284.742C410.959 285.749 411.711 286.564 412.478 287.091L413.341 288.594L415.195 287.523C416.522 286.74 416.522 284.246 415.195 281.945C413.868 279.643 411.727 278.412 410.4 279.164L408.562 280.218L409.393 281.689H409.409Z",
    fill: "url(#paint18_linear_46_6883)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M408.562 285.797C409.888 288.098 412.046 289.345 413.373 288.578C414.699 287.794 414.699 285.301 413.373 283C412.046 280.698 409.888 279.451 408.562 280.218C407.235 281.002 407.235 283.495 408.562 285.797Z",
    fill: "#C3C3CA"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M376.995 286.18C377.058 287.123 377.378 288.194 377.97 289.233C378.545 290.24 379.296 291.055 380.063 291.582L380.926 293.085L382.78 292.014C384.107 291.231 384.107 288.737 382.78 286.436C381.454 284.134 379.312 282.904 377.986 283.655L376.147 284.71L376.979 286.18H376.995Z",
    fill: "#BEC3C9"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M376.147 290.304C377.474 292.605 379.632 293.852 380.958 293.085C382.285 292.302 382.285 289.808 380.958 287.507C379.632 285.205 377.474 283.959 376.147 284.726C374.821 285.509 374.821 288.002 376.147 290.304Z",
    fill: "#C3C3CA"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M361.363 290.432L398.492 339.676L402.392 337.422C403.175 336.975 403.687 336.016 403.687 334.561V293.357C403.687 289.457 400.058 284.902 397.134 285.157L366.19 287.89C365.823 287.922 365.503 288.034 365.231 288.194L361.363 290.432Z",
    fill: "url(#paint19_linear_46_6883)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M399.771 336.831V295.626C399.771 291.726 396.142 287.171 393.217 287.427L362.274 290.16C359.333 290.416 359.333 295.339 362.274 298.983L393.217 337.454C396.142 341.082 399.771 340.731 399.771 336.831Z",
    fill: "url(#paint20_linear_46_6883)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M360.1 299.942L378.929 332.883L394.177 324.076C396.638 322.67 398.156 319.649 398.156 315.317C398.156 306.735 392.163 296.329 384.778 292.062C381.07 289.92 377.714 289.744 375.3 291.167L360.084 299.942H360.1Z",
    fill: "url(#paint21_linear_46_6883)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M394.879 330.102C396.333 330.933 397.516 332.995 397.516 334.673C397.516 336.351 396.333 337.055 394.879 336.207C393.424 335.376 392.242 333.314 392.242 331.636C392.242 329.958 393.424 329.255 394.879 330.102Z",
    fill: "#C8C8CF"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M394.879 296.729C396.333 297.56 397.516 296.873 397.516 295.195C397.516 293.516 396.333 291.455 394.879 290.624C393.424 289.792 392.242 290.48 392.242 292.158C392.242 293.836 393.424 295.898 394.879 296.729Z",
    fill: "#C8C8CF"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M367.804 296.218C367.085 294.332 365.47 292.893 364.208 293.005C362.945 293.117 362.514 294.731 363.233 296.617C363.952 298.503 365.566 299.942 366.829 299.83C368.092 299.718 368.523 298.104 367.804 296.218Z",
    fill: "#C8C8CF"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M396.031 335.552C394.576 334.721 393.394 332.659 393.394 330.981C393.394 330.47 393.505 330.07 393.697 329.766C392.85 329.766 392.259 330.454 392.259 331.652C392.259 333.347 393.442 335.392 394.896 336.223C395.919 336.815 396.782 336.639 397.23 335.904C396.878 335.904 396.478 335.808 396.047 335.568L396.031 335.552Z",
    fill: "#A5A7B3"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M396.031 296.074C394.576 295.243 393.394 293.181 393.394 291.503C393.394 290.991 393.505 290.592 393.697 290.288C392.85 290.288 392.259 290.975 392.259 292.174C392.259 293.868 393.442 295.914 394.896 296.745C395.919 297.336 396.782 297.161 397.23 296.425C396.878 296.425 396.478 296.329 396.047 296.09L396.031 296.074Z",
    fill: "#A5A7B3"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M364.384 295.962C363.92 294.763 363.936 293.676 364.32 293.021C364.288 293.021 364.24 293.021 364.208 293.021C362.945 293.133 362.514 294.747 363.233 296.633C363.952 298.519 365.566 299.958 366.829 299.846C367.293 299.798 367.644 299.558 367.868 299.174C366.621 299.19 365.087 297.8 364.384 295.978V295.962Z",
    fill: "#A5A7B3"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M369.514 300.885C376.898 305.152 382.892 315.557 382.892 324.14C382.892 332.723 376.898 336.223 369.514 331.956C362.13 327.688 356.136 317.283 356.136 308.7C356.136 300.117 362.13 296.617 369.514 300.885Z",
    fill: "#EFF1F3"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M369.515 302.627C376.068 306.415 381.374 315.653 381.374 323.261C381.374 330.869 376.068 333.986 369.515 330.198C362.962 326.41 357.655 317.172 357.655 309.564C357.655 301.956 362.962 298.839 369.515 302.627Z",
    fill: "#43474A"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M369.514 304.465C375.188 307.741 379.808 315.749 379.808 322.35C379.808 328.951 375.204 331.636 369.514 328.36C363.84 325.083 359.221 317.076 359.221 310.475C359.221 303.874 363.824 301.188 369.514 304.465Z",
    fill: "#EFF1F3"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M369.515 305.951C374.486 308.828 378.514 315.829 378.514 321.615C378.514 327.401 374.486 329.75 369.515 326.873C364.544 323.996 360.517 316.996 360.517 311.21C360.517 305.424 364.544 303.074 369.515 305.951Z",
    fill: "url(#paint22_linear_46_6883)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M375.908 324.987L378.353 323.581C378.465 322.973 378.529 322.334 378.529 321.631C378.529 315.845 374.501 308.844 369.53 305.967C368.939 305.632 368.364 305.36 367.804 305.168L365.359 306.575L369.435 313.703C370.042 315.19 370.857 316.612 371.832 317.875L375.908 324.987Z",
    fill: "#A8ADA0"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M363.185 311.434C363.185 316.229 366.542 322.062 370.665 324.444C374.789 326.825 378.145 324.875 378.145 320.064C378.145 318.866 377.938 317.619 377.57 316.356C376.739 313.975 375.444 311.657 373.846 309.707C372.887 308.621 371.816 307.71 370.681 307.054C366.558 304.673 363.201 306.623 363.201 311.434H363.185Z",
    fill: "#EFF1F3"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M370.665 308.94C373.91 310.81 376.531 315.381 376.531 319.153C376.531 322.925 373.91 324.46 370.665 322.59C367.421 320.72 364.799 316.149 364.799 312.377C364.799 308.605 367.421 307.07 370.665 308.94Z",
    fill: "#43474A"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M306.429 365.553L310.169 363.395C310.424 362.612 310.568 362.212 310.84 361.445C310.217 358.408 309.641 355.419 309.114 352.414C307.899 351.264 307.276 350.704 306.029 349.585C302.529 350.608 299.252 351.967 296.183 353.677L292.443 355.835L306.413 365.553H306.429Z",
    fill: "#F4D144"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M286.946 360.486C292.476 355.307 298.742 351.727 306.046 349.601C307.293 350.72 304.176 353.437 305.391 354.588C305.918 357.593 306.493 360.582 307.117 363.619C306.829 364.386 306.701 364.785 306.446 365.569C301.523 367.311 297.175 369.804 293.18 373.129C292.364 372.953 291.949 372.873 291.134 372.729C288.8 370.667 286.483 368.669 284.133 366.703C283.749 365.089 287.298 362.116 286.962 360.486H286.946Z",
    fill: "#AC6E14"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M343.094 415.58C342.87 396.975 329.668 374.647 313.621 365.712C297.574 356.778 284.756 364.594 284.979 383.198C285.203 401.802 298.405 424.131 314.452 433.065C330.499 442 343.318 434.184 343.094 415.58ZM314.245 412.623C308.011 409.027 302.961 400.3 302.961 393.155C302.961 386.011 308.011 383.118 314.245 386.714C320.478 390.31 325.529 399.037 325.529 406.182C325.529 413.326 320.478 416.219 314.245 412.623Z",
    fill: "url(#paint23_linear_46_6883)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M344.58 414.717C344.357 396.112 331.154 373.784 315.107 364.849C307.212 360.454 300.099 360.118 294.937 363.107L293.45 363.97C298.613 360.965 305.725 361.317 313.621 365.712C329.668 374.647 342.854 396.975 343.094 415.58C343.206 425.026 339.961 431.707 334.623 434.808L336.109 433.945C341.448 430.844 344.708 424.179 344.58 414.717Z",
    fill: "url(#paint24_linear_46_6883)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M313.285 370.491C313.285 371.051 313.684 371.738 314.164 372.026C314.659 372.313 315.043 372.09 315.043 371.514C315.043 370.939 314.643 370.268 314.164 369.98C313.668 369.692 313.285 369.916 313.285 370.491Z",
    fill: "#666863"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M316.146 377.812C316.146 378.371 316.546 379.058 317.025 379.346C317.521 379.634 317.904 379.41 317.904 378.835C317.904 378.259 317.505 377.588 317.025 377.3C316.53 377.012 316.146 377.236 316.146 377.812Z",
    fill: "#666863"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M317.952 385.803C317.952 386.363 318.351 387.05 318.831 387.338C319.31 387.625 319.71 387.402 319.71 386.826C319.71 386.251 319.31 385.579 318.831 385.292C318.335 385.004 317.952 385.228 317.952 385.803Z",
    fill: "#666863"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M318.432 393.171C318.432 393.731 318.831 394.418 319.311 394.706C319.79 394.994 320.19 394.77 320.19 394.194C320.19 393.619 319.79 392.948 319.311 392.66C318.815 392.372 318.432 392.596 318.432 393.171Z",
    fill: "#666863"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M339.178 412.959C338.682 412.671 338.299 412.895 338.299 413.47C338.299 414.045 338.698 414.717 339.178 415.004C339.673 415.292 340.057 415.068 340.057 414.493C340.057 413.918 339.657 413.246 339.178 412.959Z",
    fill: "#666863"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M334.256 413.406C333.76 413.118 333.376 413.342 333.376 413.918C333.376 414.493 333.776 415.164 334.256 415.452C334.751 415.74 335.135 415.516 335.135 414.941C335.135 414.365 334.735 413.694 334.256 413.406Z",
    fill: "#666863"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M328.197 411.968C327.702 411.68 327.318 411.904 327.318 412.479C327.318 413.055 327.718 413.726 328.197 414.013C328.693 414.301 329.077 414.077 329.077 413.502C329.077 412.927 328.677 412.255 328.197 411.968Z",
    fill: "#666863"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M322.011 408.947C321.516 408.659 321.132 408.883 321.132 409.458C321.132 410.034 321.532 410.705 322.011 410.993C322.507 411.28 322.89 411.057 322.89 410.481C322.89 409.906 322.491 409.235 322.011 408.947Z",
    fill: "#666863"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M315.203 428.846C315.203 428.286 314.803 427.599 314.324 427.311C313.844 427.024 313.445 427.248 313.445 427.823C313.445 428.398 313.844 429.07 314.324 429.357C314.803 429.645 315.203 429.421 315.203 428.846Z",
    fill: "#666863"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M312.342 421.526C312.342 420.966 311.942 420.279 311.463 419.991C310.967 419.703 310.583 419.927 310.583 420.503C310.583 421.078 310.983 421.749 311.463 422.037C311.958 422.325 312.342 422.101 312.342 421.526Z",
    fill: "#666863"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M310.536 413.534C310.536 412.975 310.136 412.287 309.657 412C309.161 411.712 308.778 411.936 308.778 412.511C308.778 413.086 309.177 413.758 309.657 414.045C310.152 414.333 310.536 414.109 310.536 413.534Z",
    fill: "#666863"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M310.073 406.166C310.073 405.606 309.673 404.919 309.194 404.631C308.698 404.344 308.314 404.567 308.314 405.143C308.314 405.718 308.714 406.39 309.194 406.677C309.689 406.965 310.073 406.741 310.073 406.166Z",
    fill: "#666863"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M295.927 369.644C296.279 370.236 296.838 370.571 297.174 370.363C297.526 370.172 297.526 369.516 297.174 368.925C296.822 368.334 296.263 367.998 295.927 368.206C295.576 368.398 295.576 369.053 295.927 369.644Z",
    fill: "#666863"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M301.441 374.503C301.793 375.094 302.352 375.43 302.688 375.222C303.04 375.031 303.04 374.375 302.688 373.784C302.337 373.192 301.777 372.857 301.441 373.065C301.09 373.256 301.09 373.912 301.441 374.503Z",
    fill: "#666863"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M307.004 381.168C307.356 381.759 307.915 382.095 308.251 381.887C308.602 381.696 308.602 381.04 308.251 380.449C307.899 379.857 307.34 379.522 307.004 379.73C306.652 379.921 306.652 380.577 307.004 381.168Z",
    fill: "#666863"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M311.702 388.504C312.054 389.096 312.613 389.431 312.949 389.224C313.3 389.032 313.3 388.377 312.949 387.785C312.597 387.194 312.038 386.858 311.702 387.066C311.366 387.274 311.35 387.913 311.702 388.504Z",
    fill: "#666863"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M331.202 388.44C330.85 388.632 330.85 389.288 331.202 389.879C331.553 390.47 332.113 390.806 332.448 390.598C332.8 390.406 332.8 389.751 332.448 389.16C332.097 388.568 331.537 388.233 331.202 388.44Z",
    fill: "#666863"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M329.748 393.923C329.396 394.114 329.396 394.77 329.748 395.361C330.099 395.953 330.659 396.288 330.994 396.08C331.346 395.889 331.346 395.233 330.994 394.642C330.643 394.051 330.083 393.715 329.748 393.923Z",
    fill: "#666863"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M326.727 398.558C326.375 398.75 326.375 399.405 326.727 399.996C327.079 400.588 327.638 400.923 327.974 400.716C328.325 400.524 328.325 399.868 327.974 399.277C327.622 398.686 327.063 398.35 326.727 398.558Z",
    fill: "#666863"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M322.699 401.627C322.347 401.818 322.347 402.474 322.699 403.065C323.05 403.656 323.61 403.992 323.945 403.784C324.281 403.577 324.297 402.937 323.945 402.346C323.594 401.754 323.034 401.419 322.699 401.627Z",
    fill: "#666863"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M332.561 429.693C332.209 429.102 331.65 428.766 331.314 428.974C330.962 429.166 330.962 429.821 331.314 430.412C331.666 431.004 332.225 431.339 332.561 431.131C332.896 430.924 332.912 430.284 332.561 429.693Z",
    fill: "#666863"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M327.046 424.834C326.695 424.243 326.135 423.907 325.8 424.115C325.464 424.323 325.448 424.962 325.8 425.553C326.151 426.145 326.711 426.48 327.046 426.273C327.382 426.065 327.398 425.425 327.046 424.834Z",
    fill: "#666863"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M321.485 418.169C321.133 417.578 320.573 417.242 320.238 417.45C319.886 417.642 319.886 418.297 320.238 418.888C320.589 419.48 321.149 419.815 321.485 419.608C321.836 419.416 321.836 418.76 321.485 418.169Z",
    fill: "#666863"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M316.785 410.833C316.434 410.241 315.874 409.906 315.539 410.114C315.203 410.321 315.187 410.961 315.539 411.552C315.89 412.143 316.45 412.479 316.785 412.271C317.121 412.064 317.137 411.424 316.785 410.833Z",
    fill: "#666863"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M297.302 410.897C297.654 410.705 297.654 410.05 297.302 409.458C296.95 408.867 296.391 408.531 296.055 408.739C295.704 408.931 295.704 409.586 296.055 410.178C296.407 410.769 296.966 411.105 297.302 410.897Z",
    fill: "#666863"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M298.74 405.415C299.092 405.223 299.092 404.567 298.74 403.976C298.389 403.385 297.829 403.049 297.494 403.257C297.142 403.449 297.142 404.104 297.494 404.695C297.845 405.287 298.405 405.622 298.74 405.415Z",
    fill: "#666863"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M301.761 400.779C302.113 400.588 302.113 399.932 301.761 399.341C301.41 398.75 300.85 398.414 300.515 398.622C300.179 398.829 300.163 399.469 300.515 400.06C300.866 400.652 301.426 400.987 301.761 400.779Z",
    fill: "#666863"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M305.805 397.711C306.156 397.519 306.156 396.864 305.805 396.272C305.453 395.681 304.894 395.345 304.558 395.553C304.207 395.745 304.207 396.4 304.558 396.991C304.91 397.583 305.469 397.918 305.805 397.711Z",
    fill: "#666863"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M289.31 386.379C289.806 386.666 290.189 386.443 290.189 385.867C290.189 385.292 289.79 384.62 289.31 384.333C288.815 384.045 288.431 384.269 288.431 384.844C288.431 385.42 288.831 386.091 289.31 386.379Z",
    fill: "#666863"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M294.233 385.931C294.729 386.219 295.112 385.995 295.112 385.42C295.112 384.844 294.713 384.173 294.233 383.885C293.754 383.598 293.354 383.821 293.354 384.397C293.354 384.972 293.754 385.643 294.233 385.931Z",
    fill: "#666863"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M300.307 387.37C300.802 387.657 301.186 387.433 301.186 386.858C301.186 386.283 300.786 385.611 300.307 385.324C299.811 385.036 299.428 385.26 299.428 385.835C299.428 386.411 299.827 387.082 300.307 387.37Z",
    fill: "#666863"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M306.476 390.39C306.972 390.678 307.355 390.454 307.355 389.879C307.355 389.304 306.956 388.632 306.476 388.345C305.981 388.057 305.597 388.281 305.597 388.856C305.597 389.431 305.997 390.103 306.476 390.39Z",
    fill: "#666863"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M317.042 406.805L311.432 410.066C310.425 410.641 309.05 410.577 307.516 409.73C304.399 408.004 301.842 403.672 301.81 400.06C301.794 398.222 302.417 396.927 303.456 396.336L309.066 393.076C308.027 393.683 307.404 394.978 307.42 396.8C307.468 400.412 310.025 404.727 313.126 406.469C314.66 407.317 316.035 407.38 317.042 406.805Z",
    fill: "#62635F"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M323.003 408.643L326.471 406.629C326.519 410.769 325.097 413.678 322.763 415.036L319.295 417.05C321.628 415.692 323.051 412.783 323.003 408.643Z",
    fill: "#7C7D7A"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M301.298 386.091L304.767 384.077C307.02 382.766 310.137 382.91 313.589 384.844C320.606 388.76 326.376 398.51 326.472 406.645L323.003 408.659C322.908 400.524 317.138 390.774 310.121 386.858C306.669 384.94 303.568 384.78 301.298 386.091Z",
    fill: "#7C7D7A"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M308.411 362.915C308.411 362.915 308.411 362.883 308.395 362.867C307.723 361.317 306.349 360.23 305.374 360.47C297.031 362.5 289.982 366.512 284.004 372.649C283.301 373.368 283.557 375.094 284.58 376.453L284.612 376.501C285.203 377.284 282.102 379.953 282.71 380.049L281.958 380.816L287.265 377.748C287.361 377.7 287.441 377.636 287.521 377.556C291.964 372.985 297.015 369.66 302.801 367.503L302.769 368.941L308.059 365.888C308.762 365.473 308.97 364.242 308.411 362.931V362.915Z",
    fill: "#31312D"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M278.762 375.67C284.74 369.532 291.772 365.521 300.132 363.491C301.123 363.251 302.497 364.354 303.152 365.888C303.152 365.904 303.152 365.92 303.168 365.936C303.808 367.407 303.552 368.733 302.625 368.957C294.665 370.891 287.968 374.711 282.278 380.561C281.607 381.248 280.329 380.785 279.37 379.506C279.37 379.506 279.354 379.474 279.338 379.458C278.331 378.115 278.059 376.389 278.762 375.654V375.67Z",
    fill: "#464643"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M332.642 421.621C332.418 403.017 319.216 380.689 303.169 371.754C287.122 362.819 274.304 370.635 274.527 389.24C274.751 407.844 287.953 430.172 304 439.107C320.047 448.042 332.866 440.226 332.642 421.621ZM303.792 418.665C297.559 415.068 292.508 406.342 292.508 399.197C292.508 392.053 297.559 389.16 303.792 392.756C310.026 396.352 315.077 405.079 315.077 412.223C315.077 419.368 310.026 422.261 303.792 418.665Z",
    fill: "url(#paint25_linear_46_6883)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M334.128 420.758C333.904 402.154 320.702 379.826 304.655 370.891C296.76 366.496 289.647 366.16 284.484 369.149L282.998 370.012C288.161 367.007 295.273 367.359 303.169 371.754C319.216 380.689 332.402 403.017 332.642 421.621C332.754 431.068 329.509 437.749 324.171 440.849L325.657 439.986C330.995 436.885 334.256 430.22 334.128 420.758Z",
    fill: "url(#paint26_linear_46_6883)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M302.817 376.533C302.817 377.092 303.216 377.78 303.696 378.067C304.175 378.355 304.575 378.131 304.575 377.556C304.575 376.98 304.175 376.309 303.696 376.022C303.216 375.734 302.817 375.958 302.817 376.533Z",
    fill: "#666863"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M305.693 383.853C305.693 384.413 306.093 385.1 306.572 385.388C307.068 385.675 307.452 385.452 307.452 384.876C307.452 384.301 307.052 383.629 306.572 383.342C306.093 383.054 305.693 383.278 305.693 383.853Z",
    fill: "#666863"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M307.484 391.845C307.484 392.404 307.883 393.092 308.363 393.379C308.858 393.667 309.242 393.443 309.242 392.868C309.242 392.292 308.842 391.621 308.363 391.333C307.867 391.046 307.484 391.269 307.484 391.845Z",
    fill: "#666863"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M307.963 399.213C307.963 399.772 308.363 400.46 308.842 400.747C309.338 401.035 309.722 400.811 309.722 400.236C309.722 399.661 309.322 398.989 308.842 398.702C308.347 398.414 307.963 398.638 307.963 399.213Z",
    fill: "#666863"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M328.726 419C328.23 418.713 327.847 418.936 327.847 419.512C327.847 420.087 328.246 420.758 328.726 421.046C329.205 421.334 329.605 421.11 329.605 420.535C329.605 419.959 329.205 419.288 328.726 419Z",
    fill: "#666863"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M323.803 419.448C323.307 419.16 322.924 419.384 322.924 419.959C322.924 420.535 323.323 421.206 323.803 421.494C324.298 421.781 324.682 421.558 324.682 420.982C324.682 420.407 324.282 419.735 323.803 419.448Z",
    fill: "#666863"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M317.729 418.009C317.233 417.722 316.85 417.945 316.85 418.521C316.85 419.096 317.249 419.767 317.729 420.055C318.224 420.343 318.608 420.119 318.608 419.544C318.608 418.968 318.208 418.297 317.729 418.009Z",
    fill: "#666863"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M311.559 414.988C311.064 414.701 310.68 414.925 310.68 415.5C310.68 416.075 311.08 416.747 311.559 417.034C312.055 417.322 312.438 417.098 312.438 416.523C312.438 415.947 312.039 415.276 311.559 414.988Z",
    fill: "#666863"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M304.752 434.887C304.752 434.328 304.352 433.641 303.873 433.353C303.377 433.065 302.994 433.289 302.994 433.865C302.994 434.44 303.393 435.111 303.873 435.399C304.368 435.687 304.752 435.463 304.752 434.887Z",
    fill: "#666863"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M301.874 427.567C301.874 427.008 301.475 426.321 300.995 426.033C300.5 425.745 300.116 425.969 300.116 426.544C300.116 427.12 300.516 427.791 300.995 428.079C301.491 428.366 301.874 428.143 301.874 427.567Z",
    fill: "#666863"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M300.083 419.576C300.083 419.016 299.684 418.329 299.204 418.041C298.709 417.754 298.325 417.977 298.325 418.553C298.325 419.128 298.725 419.799 299.204 420.087C299.7 420.375 300.083 420.151 300.083 419.576Z",
    fill: "#666863"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M299.604 412.207C299.604 411.648 299.205 410.961 298.725 410.673C298.23 410.385 297.846 410.609 297.846 411.184C297.846 411.76 298.246 412.431 298.725 412.719C299.221 413.007 299.604 412.783 299.604 412.207Z",
    fill: "#666863"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M285.475 375.686C285.827 376.277 286.386 376.613 286.722 376.405C287.057 376.197 287.073 375.558 286.722 374.967C286.37 374.375 285.811 374.04 285.475 374.247C285.124 374.439 285.124 375.094 285.475 375.686Z",
    fill: "#666863"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M290.989 380.545C291.34 381.136 291.9 381.472 292.235 381.264C292.571 381.056 292.587 380.417 292.235 379.825C291.884 379.234 291.324 378.898 290.989 379.106C290.653 379.314 290.637 379.953 290.989 380.545Z",
    fill: "#666863"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M296.551 387.21C296.903 387.801 297.462 388.137 297.798 387.929C298.15 387.737 298.15 387.082 297.798 386.49C297.446 385.899 296.887 385.563 296.551 385.771C296.216 385.979 296.2 386.618 296.551 387.21Z",
    fill: "#666863"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M301.25 394.546C301.602 395.137 302.161 395.473 302.497 395.265C302.832 395.057 302.848 394.418 302.497 393.827C302.145 393.235 301.586 392.9 301.25 393.107C300.914 393.315 300.898 393.955 301.25 394.546Z",
    fill: "#666863"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M320.733 394.482C320.382 394.674 320.382 395.329 320.733 395.921C321.085 396.512 321.644 396.848 321.98 396.64C322.332 396.448 322.332 395.793 321.98 395.201C321.629 394.61 321.069 394.274 320.733 394.482Z",
    fill: "#666863"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M319.28 399.98C318.928 400.172 318.928 400.827 319.28 401.419C319.631 402.01 320.191 402.346 320.527 402.138C320.878 401.946 320.878 401.291 320.527 400.699C320.175 400.108 319.615 399.772 319.28 399.98Z",
    fill: "#666863"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M316.259 404.599C315.907 404.791 315.907 405.447 316.259 406.038C316.61 406.629 317.17 406.965 317.506 406.757C317.857 406.565 317.857 405.91 317.506 405.319C317.154 404.727 316.594 404.392 316.259 404.599Z",
    fill: "#666863"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M312.231 407.684C311.879 407.876 311.879 408.531 312.231 409.123C312.583 409.714 313.142 410.05 313.478 409.842C313.829 409.65 313.829 408.995 313.478 408.403C313.126 407.812 312.567 407.476 312.231 407.684Z",
    fill: "#666863"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M322.108 435.735C321.756 435.143 321.197 434.808 320.861 435.015C320.51 435.207 320.51 435.862 320.861 436.454C321.213 437.045 321.772 437.381 322.108 437.173C322.46 436.981 322.46 436.326 322.108 435.735Z",
    fill: "#666863"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M316.594 430.892C316.242 430.3 315.683 429.965 315.347 430.172C314.996 430.364 314.996 431.02 315.347 431.611C315.699 432.202 316.258 432.538 316.594 432.33C316.946 432.138 316.946 431.483 316.594 430.892Z",
    fill: "#666863"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M311.032 424.211C310.68 423.619 310.121 423.284 309.785 423.491C309.449 423.699 309.433 424.339 309.785 424.93C310.137 425.521 310.696 425.857 311.032 425.649C311.383 425.457 311.383 424.802 311.032 424.211Z",
    fill: "#666863"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M306.333 416.874C305.981 416.283 305.422 415.947 305.086 416.155C304.734 416.347 304.734 417.002 305.086 417.594C305.438 418.185 305.997 418.521 306.333 418.313C306.684 418.121 306.684 417.466 306.333 416.874Z",
    fill: "#666863"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M286.834 416.938C287.185 416.747 287.185 416.091 286.834 415.5C286.482 414.909 285.923 414.573 285.587 414.781C285.251 414.988 285.235 415.628 285.587 416.219C285.938 416.811 286.498 417.146 286.834 416.938Z",
    fill: "#666863"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M288.288 411.456C288.639 411.264 288.639 410.609 288.288 410.018C287.936 409.426 287.377 409.091 287.041 409.298C286.689 409.49 286.689 410.146 287.041 410.737C287.393 411.328 287.952 411.664 288.288 411.456Z",
    fill: "#666863"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M291.309 406.821C291.66 406.629 291.66 405.974 291.309 405.383C290.957 404.791 290.398 404.456 290.062 404.663C289.726 404.871 289.71 405.51 290.062 406.102C290.414 406.693 290.973 407.029 291.309 406.821Z",
    fill: "#666863"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M295.336 403.752C295.688 403.561 295.688 402.905 295.336 402.314C294.984 401.722 294.425 401.387 294.089 401.595C293.754 401.802 293.738 402.442 294.089 403.033C294.441 403.624 295 403.96 295.336 403.752Z",
    fill: "#666863"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M278.858 392.42C279.354 392.708 279.737 392.484 279.737 391.909C279.737 391.333 279.338 390.662 278.858 390.374C278.363 390.087 277.979 390.31 277.979 390.886C277.979 391.461 278.379 392.133 278.858 392.42Z",
    fill: "#666863"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M283.781 391.973C284.276 392.26 284.66 392.037 284.66 391.461C284.66 390.886 284.26 390.215 283.781 389.927C283.285 389.639 282.902 389.863 282.902 390.438C282.902 391.014 283.301 391.685 283.781 391.973Z",
    fill: "#666863"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M289.839 393.411C290.334 393.699 290.718 393.475 290.718 392.9C290.718 392.324 290.318 391.653 289.839 391.365C289.359 391.078 288.959 391.301 288.959 391.877C288.959 392.452 289.359 393.123 289.839 393.411Z",
    fill: "#666863"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M296.024 396.432C296.52 396.72 296.903 396.496 296.903 395.921C296.903 395.345 296.504 394.674 296.024 394.386C295.529 394.098 295.145 394.322 295.145 394.898C295.145 395.473 295.545 396.144 296.024 396.432Z",
    fill: "#666863"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M307.948 412.08L302.338 415.34C301.331 415.915 299.956 415.852 298.422 415.004C295.305 413.278 292.748 408.947 292.716 405.335C292.7 403.497 293.323 402.202 294.362 401.611L299.972 398.35C298.934 398.957 298.31 400.252 298.326 402.074C298.374 405.686 300.931 410.002 304.032 411.744C305.567 412.591 306.941 412.655 307.948 412.08Z",
    fill: "url(#paint27_linear_46_6883)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M303.121 390.87C299.668 388.952 296.568 388.792 294.298 390.103L289.343 392.98C291.597 391.669 294.714 391.813 298.166 393.747C305.183 397.663 310.952 407.412 311.048 415.548C311.096 419.688 309.674 422.596 307.34 423.955L312.295 421.078C314.629 419.719 316.051 416.811 316.003 412.671C315.907 404.535 310.137 394.786 303.121 390.87Z",
    fill: "url(#paint28_linear_46_6883)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M311.048 415.548C311.144 423.683 305.534 427.104 298.534 423.188C291.517 419.272 285.747 409.522 285.651 401.387C285.555 393.251 291.165 389.831 298.166 393.747C305.183 397.663 310.952 407.412 311.048 415.548ZM303.984 411.616C303.936 408.004 301.379 403.688 298.278 401.946C295.161 400.22 292.684 401.738 292.732 405.335C292.78 408.947 295.337 413.262 298.438 415.004C301.554 416.731 304.032 415.212 303.984 411.616Z",
    fill: "url(#paint29_linear_46_6883)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M273.249 368.398C278.779 363.219 285.044 359.639 292.348 357.513C293.595 358.632 294.202 359.191 295.433 360.342C295.961 363.347 296.536 366.336 297.159 369.373C296.872 370.14 296.744 370.539 296.488 371.322C291.565 373.065 287.218 375.558 283.222 378.883C282.407 378.707 281.991 378.627 281.176 378.483C278.843 376.421 276.525 374.423 274.176 372.457C273.792 370.843 273.6 370.028 273.265 368.398H273.249Z",
    fill: "#4A191C"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M292.732 373.464L296.472 371.306C296.728 370.523 296.855 370.124 297.143 369.357C296.52 366.32 295.944 363.331 295.417 360.326C294.202 359.175 293.579 358.616 292.332 357.497C288.832 358.52 285.555 359.879 282.487 361.589L278.747 363.746L292.716 373.464H292.732Z",
    fill: "#F4D144"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M278.762 363.762L288.607 359.655L306.045 349.601L296.199 353.693L278.762 363.762Z",
    fill: "#AC6E14"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M279.466 381.04L283.206 378.882C285.092 377.3 287.058 375.926 289.135 374.711L281.783 362.02C280.664 362.676 279.114 363.427 278.043 364.178C276.221 365.457 274.942 366.815 273.264 368.398C273.616 370.028 273.792 370.843 274.175 372.457C276.525 374.423 277.148 378.978 279.482 381.04H279.466Z",
    fill: "#AC6E14"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M286.115 376.453C288.209 375.286 290.398 374.295 292.732 373.48C292.988 372.697 293.115 372.297 293.403 371.53C292.78 368.493 292.204 365.505 291.677 362.5C290.462 361.349 289.839 360.79 288.592 359.671C285.092 360.694 281.815 362.052 278.747 363.762L286.099 376.453H286.115Z",
    fill: "#D39623"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M277.42 380.641C278.235 380.784 278.651 380.864 279.466 381.04C281.352 379.458 283.318 378.083 285.396 376.869L278.043 364.178C275.007 365.936 272.178 368.062 269.524 370.555C269.876 372.186 270.052 373.001 270.435 374.615C272.785 376.581 275.103 378.579 277.436 380.641H277.42Z",
    fill: "#D39623"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M291.677 362.484L288.608 359.655L306.046 349.601L309.13 352.414L291.677 362.484Z",
    fill: "#F2C636"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M291.676 362.484L292.443 366.751L309.897 356.682L309.13 352.414L291.676 362.484Z",
    fill: "#F4D144"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M355.369 498.133C355.817 497.989 356.264 497.861 356.696 497.717C355.417 498.117 354.442 497.366 354.41 495.783C354.378 493.929 355.673 491.644 357.303 490.669C358.726 489.822 359.94 490.253 360.244 491.628C360.196 491.404 360.148 491.18 360.1 490.94C360.052 490.717 360.004 490.493 359.956 490.253C359.557 488.495 358.007 487.92 356.168 489.022C354.059 490.285 352.396 493.242 352.444 495.639C352.476 497.669 353.739 498.644 355.385 498.133H355.369Z",
    fill: "#B0B1B7"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M348.72 495.224L353.531 498.021C352.86 497.637 352.444 496.822 352.428 495.655C352.38 493.258 354.058 490.301 356.152 489.038C357.239 488.399 358.214 488.319 358.933 488.735L354.122 485.938C353.419 485.522 352.428 485.602 351.341 486.241C349.232 487.504 347.569 490.461 347.617 492.858C347.633 494.025 348.065 494.84 348.72 495.224Z",
    fill: "url(#paint30_linear_46_6883)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M355.29 497.637L356.696 498.452C356.185 498.149 355.849 497.525 355.833 496.614C355.801 494.76 357.096 492.475 358.726 491.5C359.557 491.004 360.325 490.94 360.884 491.26L359.478 490.445C358.934 490.125 358.167 490.173 357.32 490.685C355.69 491.66 354.395 493.945 354.427 495.799C354.443 496.694 354.763 497.334 355.29 497.637Z",
    fill: "#6C6D79"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M355.897 497.238C355.897 497.238 355.897 497.302 355.913 497.334C355.913 497.334 355.913 497.366 355.913 497.382C355.913 497.414 355.913 497.446 355.929 497.478C355.945 497.51 355.929 497.541 355.945 497.573C355.945 497.573 355.945 497.605 355.945 497.621C355.945 497.653 355.945 497.685 355.961 497.717C355.961 497.749 355.961 497.781 355.977 497.813C355.977 497.813 355.977 497.845 355.977 497.861C355.977 497.893 355.977 497.925 355.993 497.957C355.993 497.989 355.993 498.021 356.009 498.053C356.009 498.053 356.009 498.085 356.009 498.101C356.009 498.133 356.009 498.165 356.025 498.197C355.977 497.957 355.945 497.701 355.945 497.43C355.897 495.176 357.479 492.379 359.461 491.196C359.765 491.02 360.052 490.892 360.324 490.797C359.988 490.892 359.669 491.004 359.333 491.1C359.109 491.164 358.87 491.276 358.63 491.42C357 492.395 355.705 494.681 355.737 496.535C355.737 496.758 355.769 496.966 355.801 497.158L355.897 497.238Z",
    fill: "#6C6D79"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M357.079 499.715L363.44 503.439C362.817 503.072 367.868 494.297 368.523 494.68L362.162 490.956C361.49 490.573 360.563 490.637 359.54 491.244C357.558 492.427 355.976 495.224 356.024 497.478C356.04 498.58 356.44 499.348 357.063 499.715H357.079Z",
    fill: "url(#paint31_linear_46_6883)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M377.363 512.278C374.022 514.276 371.257 512.805 371.193 509.001C371.129 505.197 373.766 500.498 377.107 498.516C380.447 496.519 383.212 497.989 383.276 501.793C383.34 505.597 380.703 510.296 377.363 512.278ZM382.509 502.241C382.445 498.916 380.032 497.637 377.123 499.38C374.214 501.122 371.896 505.213 371.96 508.538C372.024 511.862 374.438 513.141 377.347 511.399C380.255 509.657 382.573 505.565 382.509 502.241Z",
    fill: "#C7CAD0"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M373.495 511.83L376.947 513.844C376.02 513.301 375.445 512.182 375.413 510.568C375.349 507.243 377.666 503.152 380.575 501.409C382.078 500.514 383.436 500.418 384.427 500.994L380.975 498.98C380 498.405 378.625 498.5 377.123 499.396C374.214 501.138 371.896 505.229 371.96 508.554C371.992 510.168 372.568 511.287 373.495 511.83Z",
    fill: "#979DA8"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M363.76 507.419L372.951 512.757C371.896 512.134 371.225 510.839 371.193 509.001C371.129 505.197 373.766 500.498 377.106 498.516C378.817 497.494 380.383 497.382 381.518 498.037L372.327 492.699C371.209 492.043 369.642 492.155 367.916 493.178C364.576 495.176 361.922 499.875 362.002 503.663C362.034 505.501 362.706 506.796 363.76 507.419Z",
    fill: "url(#paint32_linear_46_6883)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M384.266 516.306C380.926 518.304 378.161 516.833 378.097 513.029C378.033 509.225 380.67 504.526 384.011 502.544C387.351 500.562 390.116 502.017 390.18 505.821C390.244 509.625 387.607 514.324 384.266 516.306ZM389.413 506.268C389.349 502.944 386.936 501.665 384.027 503.407C381.118 505.149 378.8 509.241 378.864 512.566C378.928 515.89 381.341 517.169 384.25 515.427C387.159 513.684 389.477 509.593 389.413 506.268Z",
    fill: "#C7CAD0"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M380.415 515.842L383.867 517.856C382.94 517.313 382.365 516.194 382.333 514.579C382.269 511.255 384.586 507.163 387.495 505.421C388.998 504.526 390.356 504.43 391.347 505.006L387.895 502.992C386.92 502.416 385.545 502.512 384.043 503.407C381.134 505.149 378.816 509.241 378.88 512.566C378.912 514.18 379.488 515.299 380.415 515.842Z",
    fill: "#979DA8"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M376.403 514.771L379.856 516.785C378.801 516.162 378.13 514.867 378.098 513.029C378.034 509.225 380.671 504.526 384.011 502.544C385.722 501.521 387.288 501.409 388.423 502.065L384.97 500.051C383.852 499.395 382.285 499.507 380.559 500.53C377.219 502.528 374.565 507.227 374.645 511.015C374.677 512.853 375.349 514.148 376.403 514.771Z",
    fill: "url(#paint33_linear_46_6883)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M391.187 520.317C387.847 522.315 385.082 520.845 385.018 517.041C384.954 513.237 387.591 508.538 390.932 506.556C394.272 504.558 397.037 506.029 397.101 509.833C397.165 513.637 394.528 518.336 391.187 520.317ZM396.334 510.28C396.27 506.956 393.856 505.677 390.948 507.419C388.039 509.161 385.721 513.253 385.785 516.577C385.849 519.902 388.262 521.181 391.171 519.438C394.08 517.696 396.398 513.605 396.334 510.28Z",
    fill: "#C7CAD0"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M383.324 518.799L386.776 520.813C385.721 520.19 385.05 518.895 385.018 517.057C384.954 513.253 387.591 508.554 390.932 506.572C392.642 505.549 394.208 505.437 395.343 506.092L391.891 504.079C390.772 503.423 389.206 503.535 387.479 504.558C384.139 506.556 381.486 511.255 381.566 515.043C381.598 516.881 382.269 518.176 383.324 518.799Z",
    fill: "url(#paint34_linear_46_6883)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M387.32 519.87L390.772 521.884C389.845 521.34 389.27 520.222 389.238 518.607C389.174 515.283 391.491 511.191 394.4 509.449C395.903 508.554 397.261 508.458 398.252 509.033L394.8 507.02C393.825 506.444 392.45 506.54 390.948 507.435C388.039 509.177 385.722 513.269 385.785 516.593C385.817 518.208 386.393 519.326 387.32 519.87Z",
    fill: "#979DA8"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M390.244 522.811L404.933 531.346C403.878 530.723 403.207 529.428 403.175 527.59C403.111 523.786 405.748 519.087 409.088 517.105C410.799 516.082 412.365 515.97 413.5 516.625L398.811 508.09C397.692 507.435 396.126 507.547 394.4 508.57C391.059 510.568 388.406 515.267 388.486 519.055C388.518 520.893 389.189 522.187 390.244 522.811Z",
    fill: "url(#paint35_linear_46_6883)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M412.493 537.691C406.675 541.175 401.848 538.618 401.736 531.985C401.609 525.352 406.244 517.153 412.062 513.668C417.879 510.184 422.706 512.741 422.818 519.374C422.946 526.007 418.311 534.207 412.493 537.691ZM418.95 521.692C418.87 517.488 415.818 515.874 412.141 518.08C408.449 520.285 405.524 525.464 405.604 529.668C405.684 533.871 408.737 535.485 412.413 533.28C416.105 531.074 419.03 525.896 418.95 521.692Z",
    fill: "#D0D3D7"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M407.555 533.823L410.943 535.789C409.776 535.102 409.041 533.679 408.993 531.65C408.913 527.446 411.838 522.267 415.53 520.062C417.432 518.927 419.158 518.815 420.389 519.534L417.001 517.568C415.754 516.849 414.028 516.961 412.142 518.096C408.45 520.302 405.525 525.48 405.605 529.684C405.637 531.713 406.372 533.152 407.555 533.823Z",
    fill: "#A4A9B2"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M399.931 535.709L404.806 538.538C402.952 537.467 401.785 535.198 401.737 531.985C401.609 525.352 406.244 517.153 412.062 513.668C415.067 511.878 417.784 511.687 419.75 512.821L414.875 509.992C412.909 508.858 410.176 509.049 407.187 510.839C401.369 514.324 396.734 522.523 396.862 529.156C396.926 532.369 398.093 534.638 399.931 535.709Z",
    fill: "url(#paint36_linear_46_6883)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M425.727 539.753C425.727 539.753 425.759 539.721 425.775 539.705C425.775 539.705 425.791 539.689 425.807 539.673C425.823 539.657 425.839 539.641 425.855 539.625C425.871 539.609 425.887 539.593 425.903 539.577L425.935 539.545C425.935 539.545 425.967 539.513 425.983 539.497C425.999 539.481 426.015 539.465 426.031 539.449C426.031 539.449 426.047 539.433 426.063 539.417C426.079 539.401 426.095 539.385 426.111 539.369C426.127 539.353 426.143 539.337 426.159 539.321C426.159 539.321 426.175 539.306 426.191 539.29C426.207 539.274 426.223 539.258 426.239 539.242C425.424 540.073 424.529 540.776 423.601 541.335C419.19 543.973 415.53 542.039 415.45 537.004C415.354 531.969 418.87 525.768 423.282 523.131C427.693 520.493 431.353 522.427 431.433 527.462L431.721 526.119C431.609 520.286 427.374 518.032 422.259 521.101C417.144 524.153 413.069 531.362 413.18 537.196C413.292 543.03 417.528 545.283 422.642 542.214C423.713 541.575 424.736 540.744 425.695 539.801L425.727 539.753Z",
    fill: "#D0D3D7"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M423.633 541.287C419.222 543.925 415.562 541.991 415.482 536.956C415.386 531.921 418.902 525.72 423.314 523.083C427.725 520.445 431.385 522.379 431.465 527.414C431.561 532.449 428.045 538.65 423.633 541.287ZM429.579 528.533C429.515 524.681 426.718 523.21 423.346 525.224C419.973 527.238 417.288 532.001 417.352 535.837C417.416 539.689 420.213 541.159 423.585 539.146C426.958 537.132 429.643 532.369 429.579 528.533Z",
    fill: "#D0D3D7"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M409.105 538.954L415.914 542.918C414.283 541.975 413.26 539.993 413.212 537.148C413.101 531.314 417.176 524.106 422.291 521.053C424.928 519.47 427.326 519.311 429.052 520.317L422.243 516.354C420.517 515.347 418.119 515.523 415.482 517.089C410.367 520.142 406.292 527.35 406.404 533.184C406.452 536.013 407.474 537.995 409.105 538.954Z",
    fill: "url(#paint37_linear_46_6883)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M440.432 546.322C438.338 547.569 436.612 546.658 436.58 544.276C436.532 541.895 438.194 538.954 440.288 537.707C442.382 536.46 444.108 537.371 444.14 539.753C444.188 542.134 442.526 545.075 440.432 546.322ZM443.549 540.105C443.517 538.091 442.046 537.308 440.288 538.378C438.514 539.433 437.124 541.927 437.156 543.941C437.187 545.954 438.658 546.738 440.416 545.667C442.19 544.612 443.581 542.118 443.549 540.105Z",
    fill: "#D9DBDF"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M439.745 548.128C440.624 547.585 441.263 547.057 442.046 546.242C442.654 545.587 443.309 544.692 443.789 543.829C444.524 542.534 444.859 541.431 444.939 541.112C444.987 540.936 445.051 540.696 445.099 540.52C445.163 540.185 445.243 539.737 445.291 539.401C445.291 539.305 445.371 538.826 445.355 538.139C445.355 538.762 444.7 539.417 444.14 539.753C444.188 542.134 442.526 545.075 440.432 546.322C438.338 547.569 436.612 546.658 436.58 544.276C436.532 541.895 438.195 538.954 440.288 537.707C442.382 536.46 444.108 537.372 444.14 539.753C444.7 539.417 445.371 538.762 445.355 538.139C445.355 537.835 445.323 537.419 445.275 537.116C445.211 536.652 445.131 536.381 445.051 536.141C445.003 536.013 444.955 535.837 444.891 535.709C444.812 535.533 444.7 535.31 444.62 535.134C444.524 534.958 444.364 534.734 444.252 534.574C443.149 533.136 441.167 532.928 438.914 534.271C435.541 536.285 432.856 541.048 432.92 544.884C432.968 547.345 434.119 548.831 435.829 549.055C436.037 549.071 436.308 549.103 436.516 549.103C436.644 549.103 436.82 549.103 436.948 549.087C437.156 549.071 437.411 549.039 437.619 548.991C437.923 548.911 438.242 548.847 438.706 548.656C439.265 548.432 439.745 548.128 439.761 548.128H439.745Z",
    fill: "#D0D3D7"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M441.134 546.082C439.36 547.137 437.906 546.37 437.874 544.356C437.842 542.342 439.232 539.849 441.006 538.794C442.78 537.739 444.235 538.506 444.267 540.52C444.299 542.534 442.892 545.027 441.134 546.082ZM442.988 541.287C442.972 540.073 442.093 539.609 441.022 540.248C439.967 540.888 439.12 542.374 439.136 543.589C439.152 544.804 440.031 545.267 441.102 544.628C442.157 543.989 443.004 542.502 442.988 541.287Z",
    fill: "#B0B1B7"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M439.713 544.772L440.464 545.203C440.129 545.011 439.921 544.596 439.905 544.005C439.889 542.79 440.72 541.303 441.791 540.664C442.334 540.344 442.83 540.296 443.197 540.504L442.446 540.073C442.094 539.865 441.599 539.897 441.04 540.233C439.985 540.872 439.138 542.358 439.154 543.573C439.154 544.164 439.377 544.564 439.713 544.772Z",
    fill: "url(#paint38_linear_46_6883)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M441.008 545.347C441.439 545.347 441.871 545.315 442.302 545.299C441.839 545.315 441.503 544.963 441.487 544.34C441.487 543.461 442.078 542.374 442.862 541.911C443.437 541.575 443.932 541.671 444.156 542.102C443.948 541.719 443.757 541.335 443.549 540.952C443.245 540.36 442.558 540.232 441.759 540.696C440.704 541.335 439.857 542.822 439.873 544.036C439.873 544.9 440.336 545.379 440.976 545.363L441.008 545.347Z",
    fill: "url(#paint39_linear_46_6883)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M444.3 542.662C444.284 541.783 443.644 541.447 442.877 541.911C442.11 542.374 441.487 543.461 441.503 544.34C441.519 545.219 442.158 545.555 442.925 545.091C443.692 544.628 444.316 543.541 444.3 542.662Z",
    fill: "#323A3D"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M438.082 545.923L438.802 546.338C438.242 546.018 437.891 545.331 437.875 544.356C437.843 542.342 439.233 539.849 441.007 538.794C441.918 538.251 442.749 538.187 443.341 538.538L442.622 538.123C442.03 537.771 441.199 537.835 440.288 538.378C438.514 539.433 437.123 541.927 437.155 543.941C437.171 544.916 437.523 545.603 438.082 545.923Z",
    fill: "#6C6D79"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M419.143 539.641L434.695 548.704C433.624 548.08 432.952 546.77 432.92 544.9C432.856 541.048 435.526 536.301 438.914 534.287C440.656 533.248 442.239 533.136 443.373 533.791L427.822 524.729C426.687 524.074 425.105 524.185 423.362 525.224C419.99 527.238 417.305 532.001 417.369 535.837C417.401 537.707 418.072 539.018 419.143 539.641Z",
    fill: "url(#paint40_linear_46_6883)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M549.148 334.194L561.008 341.578C569.447 346.82 583.64 339.979 593.63 325.467C594.477 324.236 595.276 322.973 596.011 321.727L584.152 314.342C583.416 315.605 582.617 316.852 581.77 318.083C571.781 332.579 557.572 339.436 549.148 334.194Z",
    fill: "#20201C"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M584.152 314.342L596.012 321.727C604.387 307.374 605.362 291.694 597.818 285.365C597.418 285.029 597.003 284.726 596.571 284.454L584.712 277.07C585.143 277.341 585.559 277.645 585.958 277.981C593.502 284.31 592.528 300.006 584.152 314.342Z",
    fill: "#20201C"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M554.631 323.709L556.757 325.035C562.111 328.36 571.11 324.012 577.455 314.822C577.999 314.039 578.494 313.24 578.974 312.44L576.848 311.114C576.384 311.913 575.873 312.712 575.33 313.495C568.984 322.702 559.986 327.049 554.631 323.709Z",
    fill: "#2A2A26"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M576.832 311.114L578.957 312.44C584.28 303.33 584.887 293.389 580.108 289.361C579.852 289.153 579.597 288.961 579.309 288.785L577.183 287.459C577.455 287.635 577.727 287.826 577.982 288.034C582.761 292.046 582.154 302.003 576.832 311.114Z",
    fill: "#2A2A26"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M551.674 332.883C559.186 339.196 573.092 332.963 582.73 318.994C592.367 305.024 594.078 288.578 586.566 282.264C579.054 275.951 565.148 282.168 555.51 296.154C545.872 310.123 544.162 326.57 551.674 332.883ZM558.611 298.983C565.292 289.297 574.914 284.981 580.124 289.361C585.335 293.74 584.136 305.12 577.471 314.806C570.79 324.492 561.168 328.807 555.958 324.428C550.747 320.064 551.946 308.668 558.611 298.983Z",
    fill: "#181815"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M567.497 331.125L569.623 332.451C574.977 335.776 583.976 331.428 590.321 322.238C590.864 321.455 591.36 320.656 591.839 319.857L589.714 318.53C589.25 319.329 588.739 320.128 588.195 320.912C581.85 330.118 572.851 334.465 567.497 331.125Z",
    fill: "#2A2A26"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M589.698 318.53L591.824 319.857C597.146 310.746 597.753 300.805 592.974 296.777C592.719 296.569 592.463 296.377 592.175 296.202L590.049 294.875C590.321 295.051 590.593 295.243 590.849 295.45C595.628 299.462 595.02 309.42 589.698 318.53Z",
    fill: "#2A2A26"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M568.808 331.86L566.523 337.422C573.188 343.016 585.495 337.502 594.03 325.115C602.565 312.728 604.083 298.168 597.434 292.573C590.769 286.979 578.462 292.493 569.927 304.88C561.392 317.267 559.874 331.828 566.523 337.422L568.808 331.86C563.598 327.497 564.796 316.101 571.461 306.415C578.142 296.729 587.764 292.414 592.975 296.793C598.185 301.156 596.987 312.552 590.322 322.238C583.641 331.924 574.019 336.239 568.808 331.86Z",
    fill: "#20201C"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M558.595 303.506C559.57 301.812 560.625 300.133 561.776 298.471C574.69 279.723 593.343 271.396 603.412 279.851C607.456 283.239 609.502 288.817 609.678 295.482L609.741 297.864C609.582 291.63 607.664 286.404 603.876 283.239C594.446 275.328 576.992 283.127 564.893 300.677C563.822 302.227 562.831 303.81 561.92 305.392C552.506 321.775 551.483 339.564 560.082 346.788L560.37 347.028C565.133 350.8 571.861 350.72 578.878 347.492L576.72 348.482C569.224 351.935 562.048 352.031 556.949 347.987L556.645 347.731C547.455 340.027 548.558 321.023 558.611 303.522L558.595 303.506Z",
    fill: "#20201C"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M564.893 300.661C576.992 283.111 594.446 275.312 603.876 283.223C613.306 291.135 611.148 311.785 599.065 329.335C586.965 346.884 569.512 354.684 560.082 346.772C550.652 338.861 552.809 318.21 564.893 300.661ZM566.523 337.422C573.188 343.016 585.495 337.502 594.03 325.115C602.565 312.728 604.083 298.168 597.434 292.573C590.769 286.979 578.462 292.494 569.927 304.88C561.392 317.267 559.874 331.828 566.523 337.422Z",
    fill: "#181815"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M601.829 278.7L587.988 270.085C577.631 263.644 560.193 272.051 547.934 289.856C546.895 291.375 545.92 292.909 545.009 294.459L558.851 303.074C559.762 301.524 560.737 299.99 561.776 298.471C574.051 280.666 591.472 272.259 601.829 278.7Z",
    fill: "#2A2A26"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M558.851 303.074L545.009 294.459C534.716 312.073 533.533 331.333 542.788 339.116L556.629 347.731C547.359 339.963 548.558 320.704 558.851 303.074Z",
    fill: "#2A2A26"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M599.864 277.485L599.912 277.517C599.113 277.022 598.314 276.526 597.531 276.031L597.419 275.951L599.864 277.485Z",
    fill: "#313131"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M595.996 275.072L597.115 275.791C596.907 275.743 596.907 275.743 596.763 275.743L595.229 274.576L595.293 274.608L596.012 275.056L595.996 275.072Z",
    fill: "#313131"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M597.179 275.807L597.275 275.871L597.147 275.807L596.268 275.232L597.179 275.807Z",
    fill: "#313131"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M591.921 272.531L592.032 272.61C591.233 272.115 590.434 271.62 589.651 271.124L589.475 271.012L591.921 272.531Z",
    fill: "#313131"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M594.078 273.873L594.606 274.209L596.14 275.376C594.669 274.337 594.59 274.273 593.663 273.649L593.359 273.426L594.078 273.873Z",
    fill: "#313131"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M593.087 273.25L593.327 273.426L592.256 272.738L592.16 272.69L593.087 273.25Z",
    fill: "#313131"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M599.56 277.31L599.88 277.469L597.434 275.935L595.884 275.104C596.683 275.599 597.482 276.095 598.265 276.59L599.56 277.294V277.31Z",
    fill: "#313131"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M599.8 277.469L600.247 277.741L599.848 277.597L598.537 276.958L598.089 276.686L598.489 276.766L599.8 277.469Z",
    fill: "#313131"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M595.996 275.072L595.261 274.624L595.373 274.688L595.996 275.072Z",
    fill: "#313131"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M597.179 275.807L596.252 275.232L595.389 274.72C595.389 274.72 595.549 274.896 595.596 274.976L597.163 275.823L597.179 275.807Z",
    fill: "#313131"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M591.921 272.531L589.475 271.012L588.389 270.357L588.005 270.213C588.804 270.708 589.603 271.204 590.386 271.699L591.937 272.531H591.921Z",
    fill: "#313131"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M586.438 269.43L587.765 270.069L588.148 270.213L587.701 269.941L586.55 269.318C586.55 269.318 586.422 269.254 586.342 269.222L585.975 269.158L586.422 269.43H586.438Z",
    fill: "#313131"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M594.078 273.873L593.359 273.426L593.183 273.33L594.078 273.873Z",
    fill: "#313131"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M592.846 273.122L593.086 273.25L592.159 272.674L590.593 271.827C591.264 272.211 592.159 272.722 592.846 273.106V273.122Z",
    fill: "#313131"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M595.196 274.832C595.995 275.328 596.795 275.823 597.578 276.319L597.146 276.287L595.772 275.743C594.973 275.248 594.173 274.752 593.39 274.257L595.196 274.832Z",
    fill: "#313131"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M597.387 276.43L597.834 276.718L597.371 276.75L595.98 276.255L595.533 275.983L596.012 275.903L597.387 276.43Z",
    fill: "#313131"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M594.573 274.193C594.733 274.337 594.733 274.353 594.813 274.481C594.27 274.209 593.535 273.857 592.975 273.601C592.943 273.537 592.911 273.442 592.863 273.362L594.557 274.193H594.573Z",
    fill: "#313131"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M594.845 274.528L594.925 274.688L593.119 274.113C593.087 273.985 593.039 273.793 592.991 273.665C593.55 273.921 594.397 274.097 594.829 274.528H594.845Z",
    fill: "#313131"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M587.317 269.941C588.116 270.437 588.915 270.932 589.698 271.428L587.892 270.852C587.093 270.357 586.31 269.861 585.511 269.366L585.974 269.334L587.317 269.941Z",
    fill: "#313131"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M583.881 268.727L585.272 269.206L585.735 269.174L585.288 268.902L584.073 268.423C584.073 268.423 583.929 268.391 583.849 268.375L583.417 268.455L583.865 268.727H583.881Z",
    fill: "#313131"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M593.966 273.825L592.272 272.994C591.824 272.77 591.233 272.467 590.801 272.243C590.977 272.275 591.201 272.291 591.377 272.339C592.927 273.202 593.023 273.266 593.966 273.825Z",
    fill: "#313131"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M591.025 272.147C590.849 272.115 590.626 272.083 590.45 272.067C589.746 271.731 588.819 271.3 588.116 270.98L589.922 271.556L591.041 272.147H591.025Z",
    fill: "#313131"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M592.672 274.097C593.087 274.353 593.646 274.704 594.062 274.96C594.366 275.152 594.765 275.392 595.069 275.583L594.574 275.711L593.151 275.328C592.352 274.832 591.553 274.337 590.77 273.841L592.687 274.097H592.672Z",
    fill: "#313131"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M594.797 275.855L595.245 276.143L594.718 276.319L593.279 275.999L592.832 275.711L593.359 275.471L594.797 275.855Z",
    fill: "#313131"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M592.192 273.106C592.288 273.394 592.288 273.41 592.336 273.617C591.761 273.426 590.993 273.154 590.402 272.962C590.386 272.85 590.37 272.706 590.354 272.594L592.192 273.09V273.106Z",
    fill: "#313131"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M592.352 273.697L592.4 273.953L590.482 273.697C590.482 273.506 590.45 273.25 590.434 273.058C591.009 273.25 591.793 273.49 592.368 273.697H592.352Z",
    fill: "#313131"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M584.793 269.206C585.592 269.702 586.391 270.197 587.174 270.692L585.256 270.437C584.457 269.941 583.658 269.446 582.875 268.95L583.386 268.759L584.793 269.206Z",
    fill: "#313131"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M581.179 268.471L582.634 268.806L583.145 268.615L582.698 268.343L581.435 268.007C581.435 268.007 581.275 268.007 581.211 267.991L580.732 268.199L581.179 268.471Z",
    fill: "#313131"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M591.584 272.738L589.746 272.243C589.283 272.051 588.675 271.795 588.212 271.62C588.404 271.572 588.675 271.508 588.883 271.492C590.498 272.227 590.593 272.275 591.584 272.754V272.738Z",
    fill: "#313131"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M588.531 271.316C588.323 271.364 588.052 271.412 587.86 271.46C587.141 271.188 586.182 270.836 585.462 270.565L587.38 270.82L588.531 271.316Z",
    fill: "#313131"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M589.97 273.809C590.386 274.065 590.945 274.417 591.361 274.672C591.664 274.864 592.064 275.104 592.368 275.296L591.824 275.583L590.354 275.36C589.554 274.864 588.755 274.369 587.972 273.873L590.002 273.825L589.97 273.809Z",
    fill: "#313131"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M592.048 275.727L592.496 275.999L591.92 276.335L590.434 276.159L589.986 275.887L590.562 275.487L592.048 275.727Z",
    fill: "#313131"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M589.619 272.483C589.667 272.914 589.667 272.93 589.683 273.218C589.076 273.09 588.276 272.898 587.685 272.786C587.685 272.642 587.685 272.451 587.685 272.307L589.635 272.499L589.619 272.483Z",
    fill: "#313131"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M589.699 273.314V273.665L587.685 273.713C587.685 273.474 587.685 273.138 587.685 272.882C588.292 273.01 589.092 273.17 589.699 273.298V273.314Z",
    fill: "#313131"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M582.09 268.902C582.89 269.398 583.689 269.893 584.472 270.389L582.442 270.437C581.643 269.941 580.844 269.446 580.061 268.95L580.62 268.615L582.074 268.902H582.09Z",
    fill: "#313131"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M578.335 268.631L579.837 268.806L580.397 268.471L579.949 268.199L578.638 267.991C578.559 267.991 578.479 267.991 578.399 268.007L577.887 268.359L578.335 268.631Z",
    fill: "#313131"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M589.011 272.099L587.061 271.907C586.598 271.747 585.959 271.556 585.495 271.396C585.719 271.284 586.007 271.14 586.246 271.044C587.909 271.651 588.005 271.683 589.027 272.083L589.011 272.099Z",
    fill: "#313131"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M585.863 270.932C585.639 271.044 585.336 271.172 585.112 271.3C584.377 271.076 583.386 270.804 582.65 270.597L584.68 270.549L585.863 270.948V270.932Z",
    fill: "#313131"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M587.125 273.937C587.541 274.193 588.1 274.544 588.516 274.8C588.819 274.992 589.219 275.232 589.523 275.424L588.931 275.855L587.413 275.775C586.614 275.28 585.814 274.784 585.031 274.289L587.141 273.937H587.125Z",
    fill: "#313131"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M589.155 275.999L589.603 276.287L588.995 276.766L587.477 276.734L587.029 276.462L587.637 275.919L589.155 275.999Z",
    fill: "#313131"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M586.886 272.275C586.886 272.658 586.886 272.973 586.886 273.218C586.262 273.154 585.431 273.042 584.824 272.994C584.824 272.818 584.84 272.579 584.856 272.403L586.902 272.275H586.886Z",
    fill: "#313131"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M586.886 273.362V273.793L584.76 274.145C584.776 273.841 584.792 273.442 584.808 273.138C585.431 273.202 586.262 273.266 586.886 273.346V273.362Z",
    fill: "#313131"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M579.246 269.03C580.045 269.526 580.828 270.021 581.627 270.517L579.517 270.868C578.718 270.373 577.919 269.877 577.136 269.382L577.743 268.902L579.246 269.03Z",
    fill: "#313131"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M575.378 269.206L576.912 269.238L577.519 268.759L577.072 268.487L575.729 268.407C575.649 268.423 575.569 268.439 575.474 268.455L574.93 268.934L575.378 269.206Z",
    fill: "#313131"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M586.279 271.907L584.233 272.035C583.753 271.923 583.114 271.763 582.619 271.651C582.858 271.476 583.178 271.252 583.434 271.092C585.176 271.572 585.24 271.588 586.279 271.907Z",
    fill: "#313131"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M583.05 270.98C582.81 271.156 582.474 271.38 582.234 271.556C581.483 271.396 580.476 271.188 579.725 271.028L581.835 270.677L583.05 270.98Z",
    fill: "#313131"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M584.185 274.481C584.984 274.976 585.783 275.471 586.566 275.967L585.943 276.542L584.393 276.606C583.594 276.111 582.794 275.615 582.011 275.12L584.185 274.481Z",
    fill: "#313131"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M586.182 276.702L586.63 276.974L585.99 277.613L584.424 277.725L583.977 277.437L584.632 276.766L586.182 276.702Z",
    fill: "#313131"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M584.024 272.499C584.003 272.967 583.982 273.351 583.96 273.649C583.321 273.649 582.474 273.617 581.834 273.633C581.834 273.426 581.866 273.138 581.882 272.914L584.008 272.499H584.024Z",
    fill: "#313131"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M583.944 273.825L583.912 274.353L581.738 274.992C581.77 274.64 581.802 274.161 581.834 273.809C582.474 273.809 583.321 273.809 583.96 273.809L583.944 273.825Z",
    fill: "#313131"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M576.304 269.574C577.103 270.069 577.902 270.565 578.686 271.06L576.512 271.699C575.713 271.204 574.914 270.708 574.13 270.213L574.77 269.574H576.304Z",
    fill: "#313131"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M572.325 270.197L573.891 270.085L574.531 269.446L574.083 269.174L572.725 269.222C572.645 269.254 572.549 269.286 572.469 269.302L571.894 269.909L572.341 270.181L572.325 270.197Z",
    fill: "#313131"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M583.417 272.131L581.291 272.547C580.795 272.467 580.14 272.355 579.661 272.275C579.916 272.051 580.252 271.731 580.524 271.508C582.266 271.859 582.362 271.875 583.433 272.115L583.417 272.131Z",
    fill: "#313131"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M580.125 271.444C579.869 271.667 579.518 271.987 579.262 272.211C578.495 272.099 577.472 271.955 576.721 271.859L578.894 271.22L580.125 271.444Z",
    fill: "#313131"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M581.148 275.44C581.947 275.935 582.746 276.43 583.529 276.926L582.874 277.645L581.308 277.853C580.509 277.358 579.709 276.862 578.926 276.367L581.148 275.44Z",
    fill: "#313131"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M583.113 277.789L583.561 278.061L582.905 278.844L581.339 279.1L580.892 278.812L581.547 277.997L583.113 277.789Z",
    fill: "#313131"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M581.052 273.138C581.02 273.585 580.988 274.049 580.94 274.497C580.301 274.544 579.438 274.608 578.782 274.672C578.798 274.433 578.83 274.097 578.846 273.841L581.036 273.138H581.052Z",
    fill: "#313131"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M580.924 274.688L580.876 275.296L578.654 276.223C578.686 275.823 578.734 275.28 578.766 274.88C579.406 274.816 580.269 274.736 580.924 274.688Z",
    fill: "#313131"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M573.268 270.533C574.067 271.028 574.866 271.524 575.649 272.019L573.427 272.946C572.628 272.451 571.845 271.955 571.046 271.46L571.701 270.693L573.268 270.533Z",
    fill: "#313131"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M569.24 271.556L570.823 271.3L571.478 270.533L571.031 270.261L569.64 270.437C569.56 270.469 569.464 270.517 569.384 270.565L568.793 271.3L569.24 271.572V271.556Z",
    fill: "#313131"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M580.444 272.77L578.254 273.474C577.759 273.426 577.103 273.362 576.608 273.314C576.88 273.026 577.231 272.642 577.503 272.355C579.293 272.595 579.373 272.595 580.46 272.77H580.444Z",
    fill: "#313131"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M577.104 272.307C576.832 272.594 576.48 272.978 576.209 273.282C575.441 273.218 574.402 273.154 573.635 273.106L575.857 272.179L577.104 272.323V272.307Z",
    fill: "#313131"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M578.046 276.766C578.462 277.022 579.021 277.373 579.437 277.629C579.74 277.821 580.14 278.061 580.444 278.253L579.772 279.116L578.19 279.451C577.391 278.956 576.592 278.46 575.809 277.965L578.046 276.766Z",
    fill: "#313131"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M580.013 279.259L580.46 279.547L579.789 280.458L578.207 280.842L577.759 280.554L578.431 279.611L580.013 279.259Z",
    fill: "#313131"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M577.999 274.177C577.951 274.688 577.903 275.216 577.871 275.727C577.216 275.839 576.353 275.967 575.697 276.095C575.729 275.823 575.761 275.439 575.777 275.168L577.999 274.177Z",
    fill: "#313131"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M577.855 275.951L577.791 276.638L575.537 277.837C575.569 277.389 575.633 276.782 575.665 276.319C576.32 276.207 577.183 276.047 577.839 275.935L577.855 275.951Z",
    fill: "#313131"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M570.183 271.875C570.599 272.131 571.158 272.483 571.574 272.738C571.877 272.93 572.277 273.17 572.581 273.362L570.343 274.56C569.544 274.065 568.745 273.569 567.961 273.074L568.633 272.163L570.215 271.875H570.183Z",
    fill: "#313131"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M566.108 273.314L567.69 272.93L568.361 272.019L567.914 271.747L566.523 272.051C566.427 272.099 566.347 272.147 566.252 272.211L565.66 273.058L566.108 273.33V273.314Z",
    fill: "#313131"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M577.391 273.809L575.17 274.8C574.674 274.784 574.003 274.752 573.507 274.752C573.779 274.401 574.147 273.937 574.418 273.601C576.224 273.713 576.304 273.713 577.391 273.809Z",
    fill: "#313131"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M574.019 273.569C573.747 273.921 573.38 274.385 573.108 274.736C572.325 274.736 571.302 274.736 570.519 274.736L572.772 273.538L574.019 273.585V273.569Z",
    fill: "#313131"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M574.93 278.492C575.346 278.748 575.905 279.1 576.321 279.355C576.624 279.547 577.024 279.787 577.327 279.979L576.656 280.97L575.074 281.449C574.275 280.954 573.476 280.458 572.692 279.963L574.946 278.492H574.93Z",
    fill: "#313131"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M576.896 281.114L577.343 281.401L576.672 282.44L575.09 282.952L574.642 282.68L575.313 281.593L576.896 281.114Z",
    fill: "#313131"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M574.898 275.615C574.85 276.191 574.802 276.782 574.754 277.357C574.099 277.517 573.219 277.725 572.58 277.901C572.612 277.597 572.644 277.182 572.66 276.862L574.898 275.599V275.615Z",
    fill: "#313131"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M574.738 277.597L574.675 278.364L572.421 279.835C572.453 279.339 572.517 278.668 572.549 278.157C573.204 277.981 574.067 277.757 574.722 277.597H574.738Z",
    fill: "#313131"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M567.051 273.585C567.85 274.081 568.633 274.576 569.432 275.072L567.179 276.542C566.38 276.047 565.581 275.551 564.797 275.056L565.469 274.017L567.051 273.585Z",
    fill: "#313131"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M562.991 275.424L564.573 274.912L565.245 273.873L564.797 273.601L563.407 274.017C563.311 274.081 563.231 274.145 563.135 274.193L562.543 275.152L562.991 275.424Z",
    fill: "#313131"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M574.291 275.232L572.053 276.494C571.558 276.494 570.887 276.526 570.391 276.542C570.663 276.143 571.03 275.599 571.318 275.216C573.14 275.216 573.204 275.216 574.307 275.232H574.291Z",
    fill: "#313131"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M570.902 275.216C570.63 275.615 570.247 276.159 569.975 276.558C569.192 276.59 568.169 276.654 567.386 276.702L569.639 275.232H570.902V275.216Z",
    fill: "#313131"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M571.813 280.57C572.613 281.066 573.412 281.561 574.195 282.057L573.54 283.175L571.973 283.783C571.174 283.287 570.375 282.792 569.592 282.296L571.829 280.57H571.813Z",
    fill: "#313131"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M573.779 283.335L574.227 283.607L573.555 284.774L572.005 285.413L571.542 285.141L572.197 283.927L573.779 283.335Z",
    fill: "#313131"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M571.781 277.421C571.733 278.061 571.685 278.716 571.621 279.355C570.966 279.579 570.103 279.851 569.448 280.091C569.48 279.755 569.512 279.291 569.528 278.956L571.765 277.437L571.781 277.421Z",
    fill: "#313131"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M571.606 279.611L571.542 280.458L569.304 282.184C569.336 281.641 569.384 280.906 569.432 280.362C570.087 280.139 570.95 279.835 571.606 279.627V279.611Z",
    fill: "#313131"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M563.934 275.679C564.734 276.175 565.533 276.67 566.316 277.166L564.078 278.892C563.279 278.396 562.496 277.901 561.697 277.405L562.352 276.239L563.934 275.679Z",
    fill: "#313131"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M559.906 277.885L561.472 277.246L562.128 276.079L561.68 275.807L560.29 276.335C560.21 276.398 560.114 276.478 560.034 276.542L559.458 277.613L559.906 277.885Z",
    fill: "#313131"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M571.174 277.038L568.936 278.556C568.441 278.604 567.769 278.652 567.274 278.716C567.546 278.269 567.913 277.661 568.185 277.198C569.975 277.086 570.071 277.086 571.174 277.038Z",
    fill: "#313131"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M567.786 277.23C567.514 277.693 567.146 278.301 566.875 278.748C566.107 278.828 565.068 278.956 564.301 279.052L566.539 277.326L567.802 277.23H567.786Z",
    fill: "#313131"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M568.712 283.016C569.512 283.511 570.311 284.006 571.094 284.502L570.439 285.749L568.888 286.468C568.089 285.972 567.29 285.477 566.507 284.981L568.712 283.016Z",
    fill: "#313131"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M570.695 285.892L571.142 286.18L570.503 287.459L568.968 288.226L568.505 287.938L569.144 286.612L570.695 285.892Z",
    fill: "#313131"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M568.665 279.579C568.617 280.282 568.569 280.986 568.521 281.689C567.866 281.961 567.003 282.312 566.363 282.584C566.379 282.216 566.411 281.721 566.427 281.353L568.649 279.579H568.665Z",
    fill: "#313131"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M568.505 281.977L568.457 282.904L566.268 284.87C566.3 284.278 566.332 283.479 566.364 282.888C567.003 282.616 567.866 282.232 568.521 281.977H568.505Z",
    fill: "#313131"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M560.832 278.109C561.631 278.604 562.415 279.1 563.214 279.595L561.008 281.561C560.209 281.066 559.426 280.57 558.626 280.075L559.266 278.78L560.832 278.109Z",
    fill: "#313131"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M556.869 280.698L558.404 279.931L559.043 278.636L558.595 278.364L557.221 279.004C557.141 279.084 557.045 279.164 556.965 279.243L556.406 280.426L556.853 280.698H556.869Z",
    fill: "#313131"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M568.057 279.212L565.836 280.986C565.34 281.066 564.685 281.161 564.189 281.225C564.461 280.714 564.813 280.043 565.085 279.547C566.859 279.323 566.971 279.323 568.073 279.212H568.057Z",
    fill: "#313131"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M564.685 279.595C564.414 280.107 564.046 280.778 563.79 281.289C563.023 281.417 562 281.593 561.233 281.737L563.423 279.771L564.669 279.595H564.685Z",
    fill: "#313131"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M565.676 285.797C566.091 286.052 566.651 286.404 567.066 286.66C567.37 286.851 567.769 287.091 568.073 287.283L567.45 288.642L565.931 289.489C565.132 288.993 564.333 288.498 563.55 288.002L565.692 285.797H565.676Z",
    fill: "#313131"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M567.674 288.785L568.122 289.073L567.514 290.48L566.012 291.359L565.564 291.087L566.156 289.633L567.674 288.785Z",
    fill: "#313131"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M565.58 282.104C565.548 282.872 565.5 283.623 565.468 284.39C564.829 284.71 563.982 285.125 563.342 285.461C563.342 285.061 563.374 284.534 563.39 284.134L565.58 282.104Z",
    fill: "#313131"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M565.453 284.678L565.405 285.669L563.263 287.874C563.279 287.235 563.311 286.388 563.327 285.749C563.966 285.429 564.814 284.981 565.453 284.678Z",
    fill: "#313131"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M557.796 280.89C558.595 281.385 559.394 281.881 560.178 282.376L558.036 284.582C557.237 284.086 556.453 283.591 555.654 283.095L556.262 281.689L557.796 280.89Z",
    fill: "#313131"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M553.912 283.831L555.415 282.952L556.022 281.545L555.575 281.273L554.232 282.009C554.152 282.104 554.072 282.184 553.976 282.28L553.449 283.559L553.896 283.831H553.912Z",
    fill: "#313131"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M564.972 281.721L562.783 283.751C562.287 283.847 561.648 283.99 561.152 284.086C561.408 283.527 561.744 282.792 562.015 282.232C563.806 281.913 563.885 281.897 564.972 281.721Z",
    fill: "#313131"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M561.617 282.312C561.361 282.872 561.009 283.607 560.754 284.182C560.002 284.358 558.995 284.598 558.244 284.774L560.386 282.568L561.617 282.328V282.312Z",
    fill: "#313131"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M562.702 288.897C563.502 289.393 564.301 289.888 565.084 290.384L564.492 291.87L563.006 292.829C562.207 292.334 561.408 291.838 560.625 291.343L562.686 288.913L562.702 288.897Z",
    fill: "#313131"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M564.749 292.014L565.196 292.302L564.621 293.82L563.166 294.811L562.719 294.523L563.262 292.973L564.749 292.014Z",
    fill: "#313131"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M562.543 284.949C562.495 286.196 562.495 286.5 562.463 287.395C561.84 287.763 561.009 288.242 560.385 288.626C560.385 288.194 560.385 287.635 560.401 287.203L562.527 284.949H562.543Z",
    fill: "#313131"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M562.463 287.731V288.785L560.37 291.215C560.37 290.544 560.37 289.633 560.37 288.961C560.993 288.594 561.808 288.082 562.447 287.731H562.463Z",
    fill: "#313131"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M554.84 283.991C555.639 284.486 556.438 284.981 557.221 285.477L555.159 287.906C554.36 287.411 553.561 286.915 552.778 286.42L553.353 284.902L554.856 283.991H554.84Z",
    fill: "#313131"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M551.067 287.283L552.537 286.292L553.113 284.774L552.665 284.502L551.355 285.333C551.275 285.429 551.195 285.525 551.115 285.621L550.635 286.995L551.083 287.267L551.067 287.283Z",
    fill: "#313131"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M561.935 284.582L559.81 286.836C559.33 286.963 558.691 287.139 558.211 287.267C558.451 286.66 558.771 285.861 559.027 285.253C560.769 284.838 560.865 284.806 561.935 284.582Z",
    fill: "#313131"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M558.644 285.349C558.404 285.956 558.068 286.756 557.828 287.379C557.093 287.587 556.102 287.89 555.351 288.114L557.413 285.685L558.628 285.365L558.644 285.349Z",
    fill: "#313131"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M559.858 292.334C560.657 292.829 561.456 293.325 562.24 293.82L561.696 295.402L560.274 296.457C559.474 295.962 558.675 295.466 557.892 294.971L559.858 292.318V292.334Z",
    fill: "#313131"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M561.936 295.546L562.383 295.834L561.872 297.464L560.449 298.551L560.002 298.279L560.513 296.617L561.936 295.546Z",
    fill: "#313131"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M559.603 288.13C559.603 289.265 559.587 289.776 559.587 290.735C558.979 291.151 558.164 291.694 557.573 292.11C557.573 291.662 557.573 291.055 557.573 290.608L559.619 288.114L559.603 288.13Z",
    fill: "#313131"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M559.587 291.087V292.222L557.621 294.875C557.621 294.156 557.589 293.197 557.573 292.494C558.18 292.078 558.979 291.503 559.587 291.103V291.087Z",
    fill: "#313131"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M551.979 287.427C552.778 287.922 553.577 288.418 554.36 288.913L552.394 291.567C551.595 291.071 550.812 290.576 550.013 290.08L550.524 288.45L551.979 287.427Z",
    fill: "#313131"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M548.366 291.023L549.773 289.92L550.284 288.29L549.836 288.018L548.574 288.945C548.494 289.057 548.43 289.153 548.35 289.265L547.918 290.735L548.366 291.007V291.023Z",
    fill: "#313131"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M558.995 287.763L556.949 290.256C556.485 290.416 555.846 290.607 555.382 290.767C555.606 290.112 555.91 289.249 556.134 288.594C557.796 288.098 557.94 288.05 558.995 287.763Z",
    fill: "#313131"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M555.766 288.706C555.542 289.361 555.238 290.224 555.015 290.879C554.295 291.135 553.32 291.471 552.601 291.742L554.567 289.089L555.766 288.706Z",
    fill: "#313131"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M557.141 296.058C557.94 296.553 558.739 297.049 559.522 297.544L559.059 299.222L557.716 300.341C557.301 300.086 556.741 299.734 556.326 299.478C556.022 299.286 555.623 299.047 555.319 298.855L557.125 296.058H557.141Z",
    fill: "#313131"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M559.282 299.366L559.73 299.654L559.298 301.332L558.004 302.467L557.556 302.179L557.94 300.485L559.282 299.366Z",
    fill: "#313131"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M556.773 291.63C556.789 293.037 556.805 293.373 556.821 294.396C556.246 294.843 555.463 295.45 554.887 295.914C554.871 295.434 554.839 294.811 554.823 294.332L556.773 291.63Z",
    fill: "#313131"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M556.837 294.763L556.869 295.946L555.063 298.743C555.015 298.008 554.951 297.017 554.919 296.282C555.495 295.818 556.262 295.211 556.853 294.763H556.837Z",
    fill: "#313131"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M549.261 291.151C550.06 291.646 550.859 292.142 551.642 292.637L549.836 295.434C549.42 295.179 548.861 294.827 548.445 294.571C548.142 294.38 547.742 294.14 547.438 293.948L547.87 292.254L549.261 291.151Z",
    fill: "#313131"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M545.904 294.939L547.215 293.804L547.646 292.11L547.199 291.838L546.016 292.829C545.952 292.941 545.872 293.053 545.808 293.165L545.473 294.667L545.92 294.939H545.904Z",
    fill: "#313131"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M556.166 291.247L554.216 293.948C553.752 294.124 553.145 294.364 552.697 294.539C552.905 293.852 553.161 292.925 553.369 292.238C555.063 291.63 555.127 291.598 556.166 291.247Z",
    fill: "#313131"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M553.017 292.382C552.81 293.069 552.538 293.996 552.346 294.683C551.659 294.955 550.732 295.339 550.044 295.61L551.851 292.813L553.017 292.366V292.382Z",
    fill: "#313131"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M554.663 299.958C555.462 300.453 556.262 300.949 557.045 301.444L556.677 303.138L555.446 304.273C554.647 303.778 553.848 303.282 553.065 302.787L554.663 299.942V299.958Z",
    fill: "#313131"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M556.917 303.298L557.364 303.57L557.045 305.28L555.846 306.431L555.398 306.143L555.686 304.433L556.917 303.298Z",
    fill: "#313131"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M554.104 295.418C554.2 297.145 554.2 297.209 554.28 298.263C553.737 298.727 553.017 299.35 552.49 299.83C552.442 299.35 552.378 298.711 552.346 298.232L554.12 295.418H554.104Z",
    fill: "#313131"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M554.296 298.647L554.392 299.862L552.794 302.707C552.698 301.956 552.586 300.965 552.506 300.229C553.033 299.766 553.753 299.127 554.28 298.663L554.296 298.647Z",
    fill: "#313131"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M546.784 295.051C547.199 295.307 547.759 295.658 548.174 295.914C548.478 296.106 548.877 296.345 549.181 296.537L547.583 299.382C546.784 298.887 545.984 298.391 545.201 297.896L545.521 296.186L546.799 295.051H546.784Z",
    fill: "#313131"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M543.747 298.887L544.946 297.736L545.266 296.026L544.818 295.754L543.731 296.761C543.668 296.873 543.62 296.985 543.556 297.097L543.316 298.615L543.763 298.887H543.747Z",
    fill: "#313131"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M553.497 295.035L551.723 297.848C551.291 298.024 550.716 298.279 550.284 298.455C550.444 297.752 550.652 296.809 550.812 296.106C552.234 295.53 552.49 295.418 553.481 295.019L553.497 295.035Z",
    fill: "#313131"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M550.476 296.266C550.316 296.969 550.108 297.912 549.948 298.615C549.293 298.903 548.43 299.286 547.774 299.574L549.373 296.729L550.476 296.266Z",
    fill: "#313131"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M552.474 303.921C553.273 304.417 554.072 304.912 554.855 305.408L554.599 307.118L553.481 308.269C552.681 307.773 551.882 307.278 551.099 306.782L552.474 303.921Z",
    fill: "#313131"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M554.855 307.262L555.302 307.534L555.078 309.26L554.008 310.411L553.56 310.123L553.72 308.413L554.855 307.262Z",
    fill: "#313131"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M551.69 299.334C551.866 301.076 551.882 301.156 552.01 302.211C551.514 302.691 550.859 303.314 550.363 303.794C550.3 303.314 550.204 302.675 550.14 302.179L551.69 299.318V299.334Z",
    fill: "#313131"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M552.058 302.595L552.218 303.81L550.843 306.671C550.715 305.919 550.54 304.928 550.428 304.177C550.923 303.698 551.563 303.058 552.058 302.595Z",
    fill: "#313131"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M544.61 299.015C545.409 299.51 546.192 300.006 546.991 300.501L545.617 303.362C544.818 302.867 544.019 302.371 543.235 301.876L543.443 300.165L544.61 299.015Z",
    fill: "#313131"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M541.909 302.883L542.996 301.732L543.204 300.022L542.757 299.75L541.766 300.757C541.718 300.869 541.67 300.981 541.606 301.092L541.462 302.611L541.909 302.883Z",
    fill: "#313131"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M551.083 298.951L549.532 301.812C549.133 302.004 548.589 302.243 548.174 302.435C548.286 301.716 548.43 300.773 548.557 300.07C549.996 299.43 550.14 299.366 551.083 298.967V298.951Z",
    fill: "#313131"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M548.239 300.213C548.127 300.917 547.967 301.876 547.871 302.579C547.264 302.867 546.449 303.25 545.825 303.538L547.2 300.677L548.239 300.197V300.213Z",
    fill: "#313131"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M550.603 307.901C551.403 308.397 552.202 308.892 552.985 309.388L552.841 311.098L551.834 312.249C551.035 311.753 550.236 311.258 549.453 310.762L550.603 307.901Z",
    fill: "#313131"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M553.098 311.242L553.545 311.529L553.433 313.24L552.474 314.374L552.011 314.103L552.075 312.393L553.098 311.242Z",
    fill: "#313131"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M549.581 303.298C549.853 305.056 549.869 305.12 550.06 306.191C549.613 306.671 549.022 307.294 548.574 307.773C548.478 307.294 548.35 306.639 548.254 306.159L549.581 303.298Z",
    fill: "#313131"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M550.124 306.575L550.348 307.789L549.197 310.65C549.021 309.899 548.814 308.908 548.654 308.157C549.101 307.678 549.677 307.038 550.124 306.575Z",
    fill: "#313131"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M542.741 302.994C543.54 303.49 544.323 303.985 545.122 304.481L543.971 307.342C543.172 306.846 542.389 306.351 541.59 305.855L541.686 304.145L542.741 302.994Z",
    fill: "#313131"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M540.374 306.846L541.349 305.712L541.445 304.001L540.998 303.73L540.103 304.737C540.055 304.849 540.023 304.96 539.975 305.072L539.927 306.575L540.374 306.846Z",
    fill: "#313131"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M548.974 302.931L547.647 305.792C547.263 305.983 546.768 306.223 546.384 306.415C546.448 305.696 546.528 304.753 546.608 304.033C547.599 303.565 548.387 303.192 548.974 302.915V302.931Z",
    fill: "#313131"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M546.304 304.193C546.24 304.896 546.144 305.855 546.096 306.559C545.521 306.846 544.754 307.23 544.194 307.518L545.345 304.657L546.304 304.193Z",
    fill: "#313131"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M549.053 311.865C549.853 312.361 550.652 312.856 551.435 313.352L551.403 315.062L550.508 316.197C549.709 315.701 548.91 315.206 548.126 314.71L549.053 311.881V311.865Z",
    fill: "#313131"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M551.643 315.206L552.09 315.493L552.106 317.187L551.243 318.322L550.796 318.035L550.748 316.34L551.643 315.206Z",
    fill: "#313131"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M547.79 307.278C548.142 308.972 548.174 309.1 548.43 310.171C548.03 310.65 547.487 311.274 547.103 311.753C546.975 311.274 546.815 310.634 546.704 310.155L547.806 307.294L547.79 307.278Z",
    fill: "#313131"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M548.511 310.555L548.798 311.769L547.871 314.614C547.664 313.879 547.392 312.888 547.184 312.137C547.584 311.657 548.095 311.034 548.511 310.57V310.555Z",
    fill: "#313131"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M541.173 306.974C541.972 307.47 542.771 307.965 543.555 308.461L542.628 311.29C541.828 310.794 541.045 310.299 540.246 309.803V308.109L541.173 306.974Z",
    fill: "#313131"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M539.143 310.778L540.007 309.659V307.965L539.543 307.694L538.744 308.684C538.712 308.796 538.68 308.908 538.648 309.02L538.696 310.523L539.143 310.794V310.778Z",
    fill: "#313131"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M547.184 306.91L546.081 309.771C545.729 309.963 545.25 310.203 544.898 310.395C544.914 309.691 544.93 308.748 544.962 308.029C546.145 307.422 546.352 307.326 547.168 306.91H547.184Z",
    fill: "#313131"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M544.674 308.173C544.658 308.876 544.626 309.819 544.61 310.523C544.083 310.81 543.363 311.178 542.836 311.466L543.763 308.621L544.658 308.157L544.674 308.173Z",
    fill: "#313131"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M547.807 315.813C548.606 316.308 549.405 316.804 550.188 317.299L550.268 318.978L549.485 320.08C548.686 319.585 547.887 319.089 547.104 318.594L547.807 315.813Z",
    fill: "#313131"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M550.508 319.121L550.955 319.409L551.083 321.071L550.332 322.174L549.884 321.887L549.725 320.224L550.508 319.121Z",
    fill: "#313131"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M546.288 311.258C546.735 312.936 546.767 313.08 547.071 314.119C546.719 314.582 546.24 315.19 545.904 315.669C545.76 315.19 545.553 314.566 545.409 314.087L546.288 311.258Z",
    fill: "#313131"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M547.199 314.502L547.567 315.701L546.863 318.498C546.608 317.763 546.288 316.788 546.032 316.053C546.384 315.589 546.847 314.966 547.199 314.502Z",
    fill: "#313131"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M539.927 310.906C540.727 311.402 541.51 311.897 542.309 312.393L541.606 315.174C540.806 314.678 540.007 314.183 539.224 313.687L539.096 312.009L539.927 310.89V310.906Z",
    fill: "#313131"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M538.233 314.646L538.984 313.543L538.856 311.865L538.409 311.593L537.705 312.568C537.673 312.68 537.657 312.792 537.625 312.888L537.769 314.358L538.217 314.63L538.233 314.646Z",
    fill: "#313131"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M545.681 310.874L544.802 313.703C544.482 313.879 544.035 314.119 543.715 314.311C543.683 313.607 543.651 312.68 543.635 311.977C544.594 311.45 544.93 311.274 545.681 310.874Z",
    fill: "#313131"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M543.363 312.121C543.395 312.824 543.427 313.751 543.459 314.454C542.964 314.726 542.309 315.094 541.829 315.365L542.532 312.568L543.363 312.121Z",
    fill: "#313131"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M546.864 319.665C547.663 320.16 548.462 320.656 549.245 321.151L549.437 322.798L548.766 323.868C547.967 323.373 547.167 322.877 546.384 322.382L546.864 319.665Z",
    fill: "#313131"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M549.693 322.957L550.14 323.229L550.38 324.859L549.741 325.914L549.293 325.643L549.021 324.012L549.693 322.957Z",
    fill: "#313131"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M545.122 315.174C545.665 316.836 545.713 316.964 546.065 318.003C545.761 318.45 545.345 319.058 545.042 319.505C544.866 319.042 544.626 318.418 544.466 317.939L545.122 315.174Z",
    fill: "#313131"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M546.192 318.37L546.624 319.553L546.16 322.27C545.872 321.551 545.489 320.592 545.201 319.873C545.505 319.425 545.904 318.818 546.208 318.37H546.192Z",
    fill: "#313131"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M538.984 314.774C539.783 315.27 540.566 315.765 541.365 316.26L540.886 318.978C540.087 318.482 539.288 317.987 538.504 317.491L538.265 315.861L538.984 314.774Z",
    fill: "#313131"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M537.658 318.386L538.281 317.331L538.041 315.701L537.594 315.429L537.003 316.372C537.003 316.484 536.971 316.58 536.955 316.692L537.21 318.115L537.658 318.386Z",
    fill: "#313131"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M544.514 314.79L543.859 317.555C543.555 317.731 543.156 317.955 542.852 318.131C542.772 317.443 542.676 316.532 542.612 315.845C543.427 315.381 543.811 315.174 544.498 314.79H544.514Z",
    fill: "#313131"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M542.372 316.005C542.452 316.692 542.532 317.603 542.628 318.29C542.18 318.546 541.589 318.898 541.141 319.153L541.605 316.436L542.372 316.005Z",
    fill: "#313131"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M546.257 323.421C547.056 323.916 547.855 324.412 548.638 324.907L548.958 326.506L548.399 327.529C547.599 327.033 546.8 326.538 546.017 326.042L546.257 323.421Z",
    fill: "#313131"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M549.197 326.666L549.645 326.937L549.996 328.52L549.485 329.527L549.037 329.239L548.638 327.688L549.197 326.666Z",
    fill: "#313131"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M544.258 319.01C544.913 320.704 544.945 320.768 545.361 321.791C545.105 322.222 544.754 322.798 544.498 323.229C544.29 322.766 544.018 322.158 543.827 321.695L544.242 318.994L544.258 319.01Z",
    fill: "#313131"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M545.521 322.158L546.016 323.309L545.777 325.93C545.441 325.227 544.993 324.3 544.674 323.597C544.93 323.165 545.265 322.59 545.521 322.158Z",
    fill: "#313131"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M538.377 318.53C539.176 319.026 539.975 319.521 540.758 320.017L540.518 322.638C539.719 322.142 538.92 321.647 538.137 321.151L537.785 319.569L538.377 318.53Z",
    fill: "#313131"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M537.385 321.998L537.897 321.007L537.545 319.425L537.097 319.153L536.602 320.048C536.602 320.144 536.602 320.256 536.586 320.352L536.938 321.727L537.385 321.998Z",
    fill: "#313131"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M543.651 318.642L543.235 321.343C542.964 321.503 542.596 321.727 542.324 321.887C542.197 321.215 542.037 320.336 541.925 319.665C542.5 319.329 543.076 318.994 543.651 318.658V318.642Z",
    fill: "#313131"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M541.702 319.777C541.83 320.448 541.974 321.327 542.117 321.998C541.718 322.238 541.174 322.558 540.759 322.814L540.999 320.192L541.702 319.777Z",
    fill: "#313131"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M545.969 327.049C546.768 327.545 547.567 328.04 548.351 328.536L548.782 330.086L548.351 331.045C547.935 330.789 547.376 330.438 546.96 330.182C546.656 329.99 546.257 329.75 545.953 329.558V327.049H545.969Z",
    fill: "#313131"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M549.021 330.23L549.469 330.501L549.948 332.02L549.549 332.963L549.101 332.675L548.59 331.189L549.021 330.23Z",
    fill: "#313131"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M543.715 322.75C544.45 324.332 544.498 324.476 544.994 325.467C544.786 325.882 544.498 326.426 544.291 326.841C544.067 326.394 543.747 325.802 543.523 325.355L543.715 322.766V322.75Z",
    fill: "#313131"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M545.17 325.802L545.73 326.937V329.431C545.346 328.759 544.851 327.848 544.483 327.161C544.691 326.745 544.962 326.202 545.17 325.802Z",
    fill: "#313131"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M538.089 322.142C538.888 322.638 539.672 323.133 540.471 323.629V326.138C539.672 325.643 538.872 325.147 538.073 324.652L537.594 323.133L538.073 322.158L538.089 322.142Z",
    fill: "#313131"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M537.45 325.419L537.849 324.492L537.37 322.973L536.922 322.702L536.539 323.549C536.539 323.645 536.539 323.741 536.539 323.837L537.002 325.163L537.45 325.435V325.419Z",
    fill: "#313131"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M543.107 322.366L542.916 324.955C542.676 325.099 542.34 325.307 542.1 325.451C541.925 324.811 541.701 323.948 541.541 323.293C542.068 322.973 542.58 322.67 543.107 322.35V322.366Z",
    fill: "#313131"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M541.334 323.421C541.51 324.06 541.717 324.923 541.909 325.563C541.541 325.786 541.062 326.074 540.694 326.298V323.805L541.334 323.421Z",
    fill: "#313131"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M546 330.501C546.8 330.997 547.599 331.492 548.382 331.988L548.925 333.458L548.606 334.337C547.807 333.842 547.007 333.346 546.224 332.851L546 330.485V330.501Z",
    fill: "#313131"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M549.181 333.602L549.628 333.89L550.219 335.328L549.948 336.191L549.484 335.904L548.861 334.481L549.181 333.602Z",
    fill: "#313131"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M543.507 326.33C544.354 327.896 544.402 327.992 544.946 328.951C544.786 329.335 544.562 329.846 544.418 330.23C544.163 329.798 543.811 329.239 543.555 328.807L543.507 326.33Z",
    fill: "#313131"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M545.137 329.287L545.777 330.374L546.017 332.723C545.601 332.068 545.042 331.205 544.626 330.549C544.786 330.166 544.978 329.654 545.153 329.287H545.137Z",
    fill: "#313131"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M538.121 325.595C538.536 325.85 539.096 326.202 539.511 326.458C539.815 326.65 540.214 326.889 540.518 327.081L540.742 329.447C539.943 328.951 539.144 328.456 538.36 327.96L537.769 326.506L538.137 325.595H538.121Z",
    fill: "#313131"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M537.849 328.647L538.121 327.8L537.53 326.346L537.082 326.074L536.794 326.857C536.794 326.953 536.826 327.033 536.826 327.129L537.386 328.376L537.833 328.647H537.849Z",
    fill: "#313131"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M542.9 325.946L542.948 328.424C542.724 328.552 542.436 328.727 542.228 328.871C542.005 328.248 541.701 327.433 541.493 326.809C541.957 326.522 542.436 326.234 542.9 325.962V325.946Z",
    fill: "#313131"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M541.318 326.905C541.541 327.529 541.829 328.344 542.053 328.951C541.733 329.143 541.302 329.399 540.982 329.606L540.742 327.257L541.302 326.905H541.318Z",
    fill: "#313131"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M546.368 333.746C547.167 334.242 547.966 334.737 548.75 335.233L549.421 336.623L549.229 337.422C548.43 336.927 547.631 336.431 546.848 335.936L546.384 333.746H546.368Z",
    fill: "#313131"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M549.661 336.767L550.108 337.055L550.827 338.413L550.667 339.18L550.22 338.893L549.469 337.566L549.661 336.767Z",
    fill: "#313131"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M543.62 329.734C544.579 331.285 544.627 331.333 545.218 332.26C545.106 332.611 544.946 333.075 544.85 333.426C544.563 333.011 544.179 332.467 543.907 332.068L543.62 329.75V329.734Z",
    fill: "#313131"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M545.441 332.579L546.144 333.618L546.624 335.808C546.16 335.185 545.537 334.353 545.089 333.73C545.201 333.378 545.329 332.915 545.441 332.579Z",
    fill: "#313131"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M538.489 328.839C539.288 329.335 540.087 329.83 540.87 330.326L541.334 332.515C540.534 332.02 539.735 331.524 538.952 331.029L538.233 329.67L538.473 328.839H538.489Z",
    fill: "#313131"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M538.568 331.636L538.728 330.869L538.009 329.511L537.561 329.239L537.385 329.942C537.401 330.022 537.433 330.102 537.449 330.198L538.12 331.365L538.568 331.636Z",
    fill: "#313131"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M543.012 329.351L543.3 331.668C543.108 331.78 542.852 331.94 542.66 332.052C542.388 331.46 542.021 330.693 541.765 330.102C542.181 329.846 542.596 329.606 543.012 329.351Z",
    fill: "#313131"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M541.605 330.198C541.877 330.789 542.228 331.556 542.516 332.148C542.244 332.308 541.877 332.531 541.589 332.691L541.109 330.501L541.605 330.198Z",
    fill: "#313131"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M547.071 336.751C547.486 337.007 548.046 337.358 548.461 337.614C548.765 337.806 549.165 338.046 549.468 338.237L550.251 339.548L550.172 340.251C549.372 339.756 548.573 339.26 547.79 338.765L547.071 336.767V336.751Z",
    fill: "#313131"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M550.492 339.692L550.94 339.963L551.771 341.226L551.739 341.897L551.291 341.61L550.412 340.379L550.492 339.692Z",
    fill: "#313131"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M544.051 332.931C545.122 334.401 545.154 334.465 545.825 335.328C545.761 335.648 545.681 336.048 545.617 336.367C545.297 335.984 544.882 335.472 544.578 335.073L544.051 332.915V332.931Z",
    fill: "#313131"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M546.065 335.648L546.848 336.639L547.567 338.637C547.055 338.062 546.384 337.278 545.889 336.687C545.937 336.383 546.017 335.968 546.081 335.648H546.065Z",
    fill: "#313131"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M539.191 331.844C539.991 332.34 540.79 332.835 541.573 333.331L542.292 335.328C541.493 334.833 540.694 334.337 539.911 333.842L539.08 332.579L539.207 331.844H539.191Z",
    fill: "#313131"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M539.639 334.369L539.671 333.714L538.839 332.451L538.392 332.18L538.312 332.803C538.312 332.803 538.376 332.947 538.408 333.027L539.191 334.114L539.639 334.385V334.369Z",
    fill: "#313131"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M543.459 332.547L543.986 334.705C543.827 334.801 543.603 334.929 543.443 335.009C543.123 334.465 542.692 333.73 542.388 333.187C542.74 332.979 543.107 332.771 543.459 332.547Z",
    fill: "#313131"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M542.245 333.267C542.564 333.81 542.98 334.545 543.316 335.089C543.076 335.217 542.772 335.392 542.548 335.52L541.829 333.522L542.245 333.283V333.267Z",
    fill: "#313131"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M548.111 339.5C548.526 339.756 549.086 340.107 549.501 340.363C549.805 340.555 550.205 340.795 550.508 340.986L551.419 342.185L551.467 342.777C550.668 342.281 549.869 341.786 549.086 341.29L548.127 339.5H548.111Z",
    fill: "#313131"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M551.643 342.329L552.09 342.601L553.049 343.768L553.129 344.311L552.681 344.023L551.691 342.92L551.643 342.329Z",
    fill: "#313131"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M544.833 335.872C545.952 337.214 546.048 337.326 546.767 338.141C546.767 338.413 546.735 338.765 546.735 339.037C546.4 338.669 545.936 338.189 545.601 337.822L544.833 335.872Z",
    fill: "#313131"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M547.039 338.445L547.886 339.372L548.845 341.162C548.286 340.619 547.567 339.884 547.023 339.34C547.023 339.068 547.023 338.717 547.039 338.445Z",
    fill: "#313131"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M540.23 334.593C541.03 335.089 541.813 335.584 542.612 336.08L543.571 337.87C542.772 337.374 541.973 336.879 541.189 336.383L540.23 335.232V334.609V334.593Z",
    fill: "#313131"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M541.046 336.783L540.966 336.239L540.007 335.089L539.56 334.817L539.592 335.344C539.592 335.344 539.671 335.472 539.719 335.552L540.598 336.527L541.046 336.799V336.783Z",
    fill: "#313131"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M544.227 335.504L544.994 337.454C544.866 337.518 544.69 337.614 544.547 337.678C544.179 337.166 543.684 336.511 543.316 336C543.678 335.797 543.977 335.632 544.211 335.504H544.227Z",
    fill: "#313131"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M543.22 336.064C543.587 336.559 544.067 337.246 544.45 337.742C544.259 337.838 544.019 337.95 543.827 338.046L542.868 336.255L543.22 336.064Z",
    fill: "#313131"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M549.485 341.929C550.284 342.425 551.083 342.92 551.866 343.416L552.905 344.503L553.081 344.966C552.282 344.471 551.483 343.975 550.7 343.48L549.501 341.929H549.485Z",
    fill: "#313131"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M553.146 344.647L553.593 344.934L554.664 345.957L554.888 346.389L554.44 346.101L553.305 345.11L553.146 344.647Z",
    fill: "#313131"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M545.953 338.557C547.216 339.852 547.28 339.916 548.063 340.667C548.095 340.891 548.143 341.194 548.207 341.402C547.839 341.066 547.344 340.619 546.976 340.283L545.969 338.541L545.953 338.557Z",
    fill: "#313131"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M548.351 340.938L549.278 341.802L550.476 343.352C549.885 342.856 549.086 342.185 548.494 341.674C548.446 341.45 548.383 341.162 548.351 340.938Z",
    fill: "#313131"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M541.605 337.023C542.404 337.518 543.204 338.014 543.987 338.509L545.185 340.059C544.77 339.804 544.21 339.452 543.795 339.196C543.491 339.005 543.092 338.765 542.788 338.573L541.701 337.534L541.573 337.023H541.605Z",
    fill: "#313131"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M542.788 338.861L542.58 338.445L541.493 337.406L541.045 337.135L541.189 337.55C541.189 337.55 541.285 337.662 541.349 337.726L542.34 338.605L542.788 338.877V338.861Z",
    fill: "#313131"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M545.345 338.173L546.352 339.916C546.24 339.964 546.112 340.011 546 340.059C545.584 339.596 545.009 339.005 544.609 338.525C545.041 338.333 545.057 338.317 545.345 338.173Z",
    fill: "#313131"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M544.513 338.557C544.929 339.021 545.488 339.628 545.92 340.075C545.776 340.123 545.584 340.187 545.44 340.219L544.242 338.669L544.513 338.557Z",
    fill: "#313131"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M554.871 346.629L554.759 346.485L553.609 345.526C552.809 345.03 552.01 344.535 551.227 344.039L552.234 344.982L554.887 346.629H554.871Z",
    fill: "#313131"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M555.942 347.3L555.43 346.9L554.983 346.629L555.111 346.772L555.942 347.3Z",
    fill: "#313131"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M547.407 340.923C548.781 342.121 548.829 342.169 549.692 342.872C549.788 343.048 549.9 343.288 549.996 343.448C549.596 343.144 549.053 342.729 548.669 342.425L547.407 340.923Z",
    fill: "#313131"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M551.978 344.838L550.987 343.927L549.996 343.144C550.092 343.32 550.204 343.544 550.316 343.704L551.371 344.471L551.994 344.854L551.978 344.838Z",
    fill: "#313131"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M546.719 341.562L545.713 340.619C544.913 340.123 544.13 339.628 543.331 339.132L543.571 339.516L544.066 339.9L546.719 341.546V341.562Z",
    fill: "#313131"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M543.843 339.756L543.347 339.372L542.9 339.1L543.012 339.244L543.843 339.756Z",
    fill: "#313131"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M546.8 340.539L548.062 342.041C548.062 342.041 547.887 342.073 547.807 342.089C547.327 341.69 546.704 341.146 546.24 340.731C546.56 340.635 546.576 340.635 546.8 340.555V340.539Z",
    fill: "#313131"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M547.583 342.089H547.758C547.279 341.69 546.64 341.162 546.176 340.747L545.968 340.795L546.959 341.706L547.583 342.089Z",
    fill: "#313131"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M550.571 343.959C550.156 343.656 549.612 343.256 549.197 342.952L549.772 343.464L550.571 343.959Z",
    fill: "#313131"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M549.165 343.08L548.59 342.569C548.59 342.569 548.43 342.569 548.366 342.569L549.165 343.064V343.08Z",
    fill: "#313131"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M586.453 332.148C586.31 344.199 594.621 349.282 605.026 343.48C615.431 337.678 623.982 323.213 624.126 311.146C624.27 299.095 615.958 294.012 605.553 299.814C595.148 305.616 586.597 320.08 586.453 332.148ZM588.947 331.86C589.075 320.784 596.938 307.47 606.496 302.147C616.054 296.825 623.694 301.476 623.566 312.568C623.423 323.645 615.575 336.959 606.017 342.281C596.459 347.603 588.819 342.952 588.947 331.86Z",
    fill: "#A5A7B3"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M606.017 342.281C615.575 336.959 623.439 323.645 623.567 312.568C623.631 306.942 621.697 302.963 618.516 301.108L629.497 307.486C630.088 307.837 630.631 308.253 631.143 308.732L632.997 309.803C636.145 311.625 638.063 315.557 638 321.135C637.872 332.1 630.088 345.254 620.626 350.528C615.975 353.118 611.787 353.325 608.734 351.551C608.271 351.28 607.839 350.976 607.424 350.608C606.545 350.417 605.73 350.097 604.962 349.665C601.67 347.747 597.274 345.206 593.982 343.288C597.051 345.078 601.302 344.87 606.001 342.249L606.017 342.281Z",
    fill: "url(#paint41_linear_46_6883)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M606.017 342.281C615.575 336.959 623.439 323.645 623.566 312.568C623.63 307.134 621.824 303.25 618.851 301.332L624.509 304.625C625.101 304.976 625.644 305.392 626.156 305.871L628.01 306.942C631.158 308.764 633.076 312.696 633.012 318.274C632.885 329.239 625.101 342.393 615.639 347.667C610.988 350.257 606.8 350.464 603.747 348.69C603.284 348.419 602.852 348.115 602.437 347.747C601.701 347.587 600.998 347.332 600.343 346.996C598.137 345.717 595.884 344.407 593.998 343.304C597.066 345.094 601.318 344.886 606.017 342.265V342.281Z",
    fill: "url(#paint42_linear_46_6883)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M623.838 323.373C625.388 323.693 627.69 322.973 629.784 321.807C630.934 321.167 632.037 320.384 632.916 319.569L634.291 320.368C633.412 321.183 632.309 321.966 631.158 322.606C628.281 324.204 625.053 324.955 623.838 323.373Z",
    fill: "url(#paint43_linear_46_6883)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M623.807 306.527C623.759 310.618 620.802 318.946 617.27 320.928C615.879 321.695 614.617 321.375 613.594 320.448C614.297 320.656 615.08 320.576 615.895 320.128C619.428 318.162 622.384 309.835 622.432 305.728C624.814 305.504 626.924 306.047 628.618 307.262C627.211 306.623 625.581 306.367 623.807 306.527Z",
    fill: "url(#paint44_linear_46_6883)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M612.746 350.209L611.371 349.41C613.193 345.558 614.328 339.084 612.794 336.847C612.937 336.847 613.081 336.863 613.209 336.911C616.038 337.726 614.855 345.733 612.73 350.209H612.746Z",
    fill: "url(#paint45_linear_46_6883)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M630.216 330.246C630.12 330.15 630.024 330.054 629.912 329.974C630.583 330.246 631.159 330.597 631.59 331.045C631.59 331.077 630.216 330.246 630.216 330.246Z",
    fill: "url(#paint46_linear_46_6883)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M598.649 338.653C599.528 338.493 600.615 338.046 601.766 337.406C604.994 335.6 608.702 332.212 609.549 328.887C610.141 326.554 609.198 324.732 607.695 323.581C609.933 324.54 611.691 326.697 610.924 329.686C610.077 333.011 606.369 336.399 603.14 338.205C601.989 338.845 600.903 339.292 600.024 339.452C600.135 341.897 600.663 343.991 601.526 345.685C601.382 345.957 601.254 346.213 601.126 346.469C599.688 344.583 598.809 341.945 598.649 338.669V338.653Z",
    fill: "url(#paint47_linear_46_6883)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M606.497 302.147C611.196 299.526 615.432 299.318 618.517 301.108L629.497 307.486C626.428 305.696 622.177 305.903 617.478 308.525C607.92 313.847 600.056 327.161 599.928 338.237C599.864 343.863 601.798 347.843 604.979 349.697L593.999 343.32C590.818 341.466 588.884 337.502 588.948 331.86C589.076 320.784 596.939 307.47 606.497 302.147Z",
    fill: "url(#paint48_linear_46_6883)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M611.004 313.655C608.335 316.372 605.985 319.649 604.147 323.149C607.488 322.542 612.075 325.195 610.924 329.702C610.077 333.027 606.369 336.415 603.14 338.221C601.989 338.861 600.903 339.308 600.023 339.468C600.183 342.745 601.062 345.382 602.501 347.268C604.131 343.831 607.919 339.084 610.86 337.438C611.755 336.943 612.554 336.735 613.21 336.911C616.039 337.726 614.856 345.733 612.73 350.209C613.817 349.921 614.936 349.489 616.102 348.914C616.102 348.914 616.118 348.914 616.134 348.898C616.198 348.866 616.262 348.834 616.31 348.802C616.342 348.786 616.39 348.77 616.422 348.738C616.438 348.738 616.47 348.722 616.486 348.706C616.55 348.674 616.598 348.642 616.662 348.61C616.678 348.61 616.694 348.594 616.71 348.578C616.774 348.546 616.838 348.514 616.902 348.467C616.966 348.435 617.03 348.387 617.093 348.355C617.093 348.355 617.125 348.339 617.141 348.323C617.205 348.291 617.269 348.259 617.317 348.211C617.333 348.211 617.349 348.195 617.381 348.179C617.429 348.147 617.461 348.131 617.509 348.099C617.557 348.067 617.605 348.051 617.637 348.019C617.669 348.003 617.685 347.987 617.717 347.971C618.884 347.268 620.002 346.437 621.089 345.51C619.059 343.352 618.052 336.559 620.929 332.563C621.601 331.636 622.416 330.949 623.311 330.454C626.268 328.807 629.976 329.367 631.542 331.029C633.045 327.497 634.004 323.836 634.243 320.336C633.364 321.167 632.261 321.934 631.111 322.574C627.882 324.38 624.206 325.099 623.423 322.67C622.384 319.393 627.083 311.561 630.455 308.429C628.681 306.926 626.38 306.255 623.742 306.495C623.694 310.586 620.738 318.914 617.205 320.896C613.673 322.862 610.892 317.731 610.94 313.623L611.004 313.655Z",
    fill: "url(#paint49_linear_46_6883)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M617.222 324.732C615.4 325.754 613.897 328.296 613.881 330.406C613.849 332.515 615.304 333.41 617.142 332.403C618.964 331.381 620.466 328.839 620.498 326.729C620.53 324.62 619.076 323.725 617.238 324.748L617.222 324.732Z",
    fill: "url(#paint50_linear_46_6883)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M616.694 325.547C617.988 324.827 619.027 325.451 619.011 326.953C618.995 328.456 617.924 330.262 616.63 330.981C615.335 331.7 614.296 331.077 614.312 329.574C614.328 328.072 615.399 326.266 616.694 325.547Z",
    fill: "url(#paint51_linear_46_6883)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M617.477 308.525C620.802 306.671 623.887 306.031 626.492 306.447C627.451 306.591 628.41 306.751 629.353 306.894C626.62 306.463 623.407 307.134 619.939 309.068C609.949 314.63 601.75 328.52 601.606 340.091C601.558 344.295 602.581 347.619 604.371 349.873C603.764 349.122 603.172 348.355 602.565 347.603C600.839 345.446 599.864 342.265 599.912 338.237C600.04 327.161 607.903 313.847 617.461 308.525H617.477Z",
    fill: "#A5A7B3"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M604.291 299.079C609.405 296.234 614.024 296.01 617.365 297.944L618.644 298.679C615.303 296.729 610.684 296.953 605.569 299.814C595.164 305.616 586.613 320.08 586.469 332.148C586.39 338.269 588.499 342.601 591.968 344.615L590.689 343.879C587.237 341.866 585.127 337.55 585.191 331.413C585.335 319.361 593.886 304.88 604.291 299.079Z",
    fill: "url(#paint52_linear_46_6883)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M619.954 308.189C625.068 305.344 629.688 305.12 633.028 307.054L634.195 307.741C630.854 305.792 626.235 306.015 621.121 308.876C610.716 314.678 602.165 329.143 602.021 341.21C601.941 347.332 604.051 351.663 607.519 353.677L606.352 352.99C602.9 350.976 600.79 346.66 600.854 340.523C600.998 328.472 609.549 313.991 619.954 308.189Z",
    fill: "url(#paint53_linear_46_6883)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M621.121 308.86C631.526 303.058 639.837 308.141 639.694 320.192C639.55 332.244 630.999 346.724 620.594 352.526C610.189 358.328 601.878 353.245 602.021 341.194C602.165 329.143 610.716 314.662 621.121 308.86ZM603.732 340.235C603.604 351.2 611.164 355.819 620.61 350.544C630.072 345.27 637.84 332.116 637.983 321.151C638.111 310.187 630.551 305.568 621.105 310.842C611.659 316.117 603.875 329.271 603.732 340.235Z",
    fill: "#E3E3E4"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M568.329 151.154L561.169 146.983C559.059 145.752 557.732 143.195 557.668 139.519C557.525 131.975 562.799 122.64 569.416 118.677C572.82 116.631 575.937 116.423 578.175 117.718L585.335 121.889C583.098 120.595 579.997 120.802 576.576 122.848C569.943 126.812 564.685 136.146 564.829 143.69C564.893 147.35 566.219 149.924 568.329 151.154Z",
    fill: "url(#paint54_linear_46_6883)"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M588.835 129.353C588.979 136.897 583.705 146.232 577.088 150.195C570.455 154.159 564.972 151.25 564.829 143.69C564.685 136.146 569.959 126.812 576.576 122.848C583.209 118.884 588.691 121.793 588.835 129.353ZM587.013 130.44C586.901 124.031 582.234 121.57 576.608 124.926C570.982 128.283 566.523 136.21 566.635 142.619C566.747 149.029 571.414 151.49 577.04 148.134C582.666 144.777 587.125 136.85 587.013 130.44Z",
    fill: "#A5A7B3"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M584.408 157.532L569.608 148.933C567.818 147.894 566.699 145.704 566.635 142.603C566.523 136.194 570.982 128.283 576.608 124.91C579.501 123.184 582.139 122.992 584.041 124.095L598.841 132.694C596.939 131.591 594.302 131.783 591.409 133.509C585.783 136.866 581.323 144.793 581.435 151.202C581.499 154.319 582.618 156.493 584.408 157.532Z",
    fill: "url(#paint55_linear_46_6883)"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M601.814 139.039C601.926 145.448 597.466 153.36 591.84 156.733C586.214 160.089 581.563 157.628 581.435 151.218C581.323 144.809 585.783 136.897 591.409 133.525C597.035 130.169 601.686 132.63 601.814 139.039ZM599.608 140.366C599.512 135.347 595.868 133.413 591.457 136.05C587.045 138.688 583.545 144.889 583.641 149.908C583.737 154.926 587.381 156.86 591.792 154.223C596.204 151.586 599.704 145.385 599.608 140.366Z",
    fill: "#A5A7B3"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M625.965 155.662C626.061 160.68 622.56 166.882 618.149 169.519C613.738 172.156 610.093 170.222 609.998 165.204C609.902 160.185 613.402 153.983 617.813 151.346C622.225 148.709 625.869 150.643 625.965 155.662Z",
    fill: "#777B77"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M612.331 170.158L585.975 154.847C584.569 154.031 583.69 152.321 583.658 149.892C583.562 144.873 587.062 138.672 591.473 136.034C593.743 134.676 595.805 134.532 597.291 135.395L623.648 150.707C622.161 149.844 620.099 149.988 617.83 151.346C613.418 153.983 609.918 160.185 610.014 165.204C610.062 167.633 610.941 169.343 612.347 170.158H612.331Z",
    fill: "url(#paint56_linear_46_6883)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M598.25 194.82L598.122 151.682C598.122 153.999 630.328 154.047 630.312 151.586L630.44 194.725C630.44 197.186 628.794 199.631 625.485 201.485C619.076 205.066 608.879 204.954 602.725 201.262C599.736 199.472 598.25 197.154 598.25 194.836V194.82Z",
    fill: "url(#paint57_linear_46_6883)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M625.773 201.406L612.81 194.133C611.308 193.286 610.365 191.448 610.285 188.731C610.125 182.817 614.169 175.017 619.315 171.309C622.096 169.295 624.638 168.896 626.412 169.903L639.374 177.175C637.6 176.184 635.075 176.584 632.278 178.582C627.131 182.29 623.087 190.089 623.247 196.003C623.327 198.72 624.27 200.558 625.773 201.406Z",
    fill: "url(#paint58_linear_46_6883)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M596.699 217.788L572.788 203.979L566.299 164.548L623.662 168.992L620.961 207.511L596.699 217.788Z",
    fill: "#373F42"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M602.277 218.3L596.699 217.788L594.989 182.497L601.174 181.986L602.277 218.3Z",
    fill: "#424A4D"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M601.174 181.986L602.277 218.3L620.961 207.511L623.663 168.992L601.174 181.986Z",
    fill: "#373F42"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M595.292 185.598L564.764 167.969C563.853 167.441 563.853 166.131 564.764 165.603L588.755 151.746C590.305 150.851 592.207 150.851 593.758 151.746L624.286 169.375C625.197 169.903 625.197 171.213 624.286 171.741L600.295 185.598C598.744 186.493 596.842 186.493 595.292 185.598Z",
    fill: "#3A4245"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M595.292 183.952L564.764 166.322C563.853 165.795 563.853 164.484 564.764 163.957L588.755 150.1C590.305 149.205 592.207 149.205 593.758 150.1L624.286 167.729C625.197 168.256 625.197 169.567 624.286 170.095L600.295 183.952C598.744 184.847 596.842 184.847 595.292 183.952Z",
    fill: "#4C5457"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M597.69 182.673L567.099 165.012L591.137 150.211L622.528 168.336L597.69 182.673Z",
    fill: "#787B79"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M596.699 176.52L570.071 161.144L592.927 147.958L619.555 163.318L596.699 176.52Z",
    fill: "#4C5457"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M596.699 176.52L570.071 161.144L567.099 165.012L597.69 182.673L596.699 176.52Z",
    fill: "#373F42"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M596.699 176.52L619.555 163.318L622.528 168.336L597.69 182.673L596.699 176.52Z",
    fill: "#424A4D"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M626.46 121.777C619.507 117.846 608.015 117.734 600.759 121.538C596.923 123.552 595.053 126.253 595.165 128.922L596.252 149.54C596.14 147.015 597.914 144.458 601.526 142.556C608.367 138.959 619.236 139.071 625.789 142.779C629.065 144.633 630.647 147.047 630.568 149.428L631.495 128.81C631.591 126.285 629.912 123.727 626.444 121.761L626.46 121.777Z",
    fill: "url(#paint59_linear_46_6883)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M602.341 130.968C602.341 139.375 608.271 149.604 615.607 153.84C622.928 158.059 628.873 154.687 628.873 146.28C628.873 137.873 622.944 127.643 615.607 123.408C608.287 119.172 602.341 122.561 602.341 130.968Z",
    fill: "#DFB152"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M623.896 155.424C629.04 152.417 628.988 142.758 623.781 133.849C618.573 124.94 610.181 120.156 605.037 123.163C599.893 126.171 599.945 135.83 605.153 144.739C610.361 153.647 618.752 158.431 623.896 155.424Z",
    fill: "#B37635"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M605.666 134.308L597.418 148.07L600.359 151.49L610.301 135.219L605.666 134.308Z",
    fill: "url(#paint60_linear_46_6883)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M609.598 133.861C608.751 133.349 607.328 133.333 606.433 133.829C605.538 134.324 605.506 135.139 606.369 135.667C607.216 136.178 608.639 136.194 609.534 135.699C610.429 135.203 610.461 134.388 609.598 133.861Z",
    fill: "url(#paint61_linear_46_6883)"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M627.85 120.946C635.538 125.565 635.266 132.934 627.259 137.393C619.251 141.852 606.529 141.724 598.857 137.105C591.169 132.486 591.441 125.118 599.448 120.659C607.456 116.199 620.178 116.327 627.85 120.946ZM626.14 121.905C619.363 117.83 608.143 117.718 601.078 121.65C594.014 125.581 593.774 132.087 600.567 136.162C607.344 140.238 618.564 140.35 625.629 136.418C632.693 132.486 632.933 125.981 626.14 121.905Z",
    fill: "#DEDEDE"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M593.343 149.396L593.263 129.082C593.263 131.975 595.133 134.868 598.857 137.105C606.545 141.724 619.252 141.852 627.259 137.393C631.383 135.091 633.445 132.023 633.445 128.97L633.525 149.285C633.525 152.353 631.463 155.422 627.339 157.708C619.332 162.167 606.609 162.039 598.937 157.42C595.213 155.182 593.359 152.289 593.343 149.396Z",
    fill: "url(#paint62_linear_46_6883)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M600.359 158.251L593.247 162.359V159.689L600.359 149.764V158.251Z",
    fill: "#D2D2D6"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M600.36 149.764L593.982 159.833L593.247 162.359L590.306 160.664L591.041 158.139L597.419 148.07L598.01 147.478C598.298 147.175 598.761 147.111 599.129 147.319L599.401 147.478C599.912 147.766 600.248 148.293 600.296 148.885L600.376 149.78L600.36 149.764Z",
    fill: "#E4E5E6"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M578.51 114.713L575.09 112.731C574.69 112.507 574.179 112.523 573.619 112.843L573.268 113.051C572.021 113.77 570.998 115.704 570.998 117.382V122.433L574.418 124.415L575.106 119.811L576.368 121.282L578.526 114.713H578.51Z",
    fill: "url(#paint63_linear_46_6883)"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M579.293 121.602L574.402 124.415V119.364C574.402 117.702 575.409 115.752 576.672 115.033L577.024 114.825C578.27 114.106 579.293 114.873 579.293 116.535V121.586V121.602Z",
    fill: "#A5A7B3"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M657.596 179.029L650.211 174.874C652.497 176.152 653.936 178.965 654.047 183.105C654.287 192.119 648.118 204.011 640.27 209.669C636.018 212.722 632.151 213.345 629.465 211.827L636.85 215.982C639.551 217.501 643.419 216.893 647.654 213.824C655.502 208.166 661.671 196.275 661.432 187.26C661.32 183.121 659.881 180.308 657.596 179.029Z",
    fill: "url(#paint64_linear_46_6883)"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M643.162 186.397C643.274 190.761 640.285 196.531 636.481 199.264C632.677 202.013 629.497 200.686 629.385 196.323C629.273 191.959 632.262 186.19 636.066 183.456C639.87 180.707 643.05 182.034 643.162 186.397Z",
    fill: "#888B9B"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M654.03 183.121C654.03 182.913 654.03 182.705 653.998 182.497C653.471 173.978 647.046 171.517 639.374 177.047C638.671 177.559 637.983 178.118 637.296 178.709L635.042 184.272C635.362 183.984 635.698 183.712 636.049 183.456C639.757 180.771 642.89 181.97 643.13 186.094C643.13 186.19 643.13 186.285 643.13 186.397C643.21 189.162 642.043 192.471 640.205 195.236C639.134 196.85 637.839 198.273 636.449 199.28C634.898 200.399 633.46 200.846 632.277 200.67L631.606 212.562C634.035 212.897 637.024 211.986 640.221 209.685C643.114 207.607 645.783 204.666 647.989 201.342C651.761 195.652 654.158 188.811 654.014 183.121H654.03Z",
    fill: "#A5A7B3"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M634.979 219.291L623.647 212.929C620.946 211.411 619.252 208.102 619.124 203.212C618.836 192.583 626.109 178.566 635.379 171.885C640.382 168.272 644.953 167.553 648.117 169.343L659.449 175.705C656.269 173.915 651.714 174.634 646.711 178.246C637.457 184.911 630.184 198.944 630.456 209.573C630.584 214.448 632.294 217.772 634.979 219.291Z",
    fill: "url(#paint65_linear_46_6883)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M663.973 185.422C664.26 196.051 656.988 210.068 647.718 216.749C638.463 223.414 630.728 220.218 630.44 209.589C630.152 198.96 637.425 184.943 646.695 178.262C655.949 171.597 663.685 174.794 663.973 185.422ZM661.431 187.26C661.191 178.246 654.638 175.529 646.775 181.187C638.927 186.845 632.757 198.736 632.997 207.751C633.237 216.765 639.79 219.482 647.654 213.824C655.501 208.166 661.671 196.275 661.431 187.26Z",
    fill: "#CBCFD0"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M582.442 155.694C582.106 155.486 581.659 155.486 581.163 155.774L580.86 155.949C579.805 156.557 578.958 158.187 578.958 159.578V163.27L582.49 165.316L585.942 157.724L582.426 155.694H582.442Z",
    fill: "url(#paint66_linear_46_6883)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M591.296 157.692H582.49V165.491C582.49 166.147 582.905 166.786 583.768 167.281C585.479 168.272 588.276 168.272 589.986 167.281C590.849 166.786 591.28 166.131 591.28 165.475V157.708L591.296 157.692Z",
    fill: "url(#paint67_linear_46_6883)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M583.769 159.498C585.479 160.489 588.276 160.489 589.986 159.498C591.713 158.507 591.713 156.892 590.002 155.901C588.292 154.911 585.495 154.911 583.785 155.901C582.059 156.892 582.059 158.507 583.769 159.498Z",
    fill: "#C2C2CA"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M584.393 158.411C585.767 159.21 588.005 159.194 589.38 158.411C590.754 157.612 590.77 156.317 589.38 155.534C587.989 154.751 585.767 154.751 584.393 155.534C583.018 156.333 583.002 157.628 584.393 158.411Z",
    fill: "#E2E2E2"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M590.658 160.425L590.61 160.537C590.274 160.217 589.859 160.249 589.379 160.521L589.075 160.696C588.02 161.304 587.173 162.934 587.173 164.325V168.017L590.706 170.063L594.158 162.471L590.642 160.441L590.658 160.425Z",
    fill: "url(#paint68_linear_46_6883)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M592.623 162.726L592.926 162.55C593.981 161.943 594.828 162.582 594.828 163.989V167.681L590.721 170.047V166.354C590.721 164.948 591.568 163.334 592.623 162.726Z",
    fill: "#CBCFD0"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M595.852 168.4L592.176 166.338C592.032 166.259 591.937 166.083 591.937 165.811C591.937 165.236 592.32 164.468 592.816 164.101C593.087 163.909 593.343 163.861 593.503 163.957L597.179 166.019C597.003 165.923 596.763 165.955 596.492 166.163C595.996 166.53 595.597 167.281 595.613 167.873C595.613 168.145 595.709 168.32 595.852 168.4Z",
    fill: "url(#paint69_linear_46_6883)"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M597.227 166.418L598.473 167.122C598.585 167.186 598.665 167.329 598.665 167.521L597.418 166.818C597.418 166.61 597.338 166.466 597.227 166.418Z",
    fill: "#B37635"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M597.418 166.818L598.665 167.521C598.665 167.969 598.377 168.56 597.978 168.832C597.77 168.976 597.578 169.008 597.45 168.944L596.204 168.24C596.331 168.32 596.523 168.288 596.731 168.129C597.115 167.841 597.418 167.265 597.418 166.818Z",
    fill: "#B37635"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M595.644 168.225L595.612 168.017C595.612 168.017 595.612 167.937 595.612 167.889C595.612 167.313 595.996 166.546 596.491 166.179C596.571 166.115 596.651 166.083 596.731 166.051L596.923 165.971C596.843 166.003 596.747 166.051 596.651 166.131C596.076 166.546 595.612 167.425 595.644 168.081C595.644 168.129 595.644 168.193 595.644 168.24V168.225Z",
    fill: "#9C6B21"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M597.179 169.391L595.9 168.672C595.725 168.576 595.629 168.368 595.613 168.065C595.597 167.393 596.044 166.53 596.62 166.115C596.939 165.891 597.211 165.843 597.419 165.955L598.697 166.674C598.506 166.562 598.218 166.61 597.898 166.834C597.323 167.249 596.859 168.129 596.891 168.784C596.891 169.088 597.003 169.295 597.179 169.391Z",
    fill: "url(#paint70_linear_46_6883)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M599.001 167.265C599.017 167.937 598.57 168.8 597.994 169.215C597.419 169.631 596.939 169.439 596.923 168.768C596.907 168.097 597.355 167.234 597.93 166.818C598.506 166.402 598.985 166.594 599.001 167.265ZM598.665 167.505C598.665 167.058 598.33 166.93 597.946 167.202C597.563 167.473 597.259 168.065 597.259 168.512C597.259 168.96 597.595 169.088 597.978 168.816C598.362 168.544 598.665 167.953 598.665 167.505Z",
    fill: "#D7A74D"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M609.757 133.765C610.684 134.324 610.652 135.219 609.693 135.763C608.718 136.306 607.168 136.29 606.241 135.731C605.314 135.171 605.346 134.276 606.305 133.733C607.264 133.189 608.83 133.205 609.757 133.765ZM609.549 133.877C608.718 133.381 607.36 133.365 606.496 133.845C605.633 134.324 605.601 135.107 606.432 135.603C607.264 136.098 608.622 136.114 609.485 135.635C610.348 135.155 610.38 134.372 609.549 133.877Z",
    fill: "#D0AA67"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M508.089 256.483H513.284C513.284 256.483 513.204 256.308 513.06 256.004C512.037 254.054 507.434 246.622 497.301 248.076C496.725 248.14 496.118 248.252 495.51 248.412C495.447 248.412 495.367 248.444 495.303 248.46C493.848 248.859 492.33 249.499 490.763 250.41C480.95 256.084 472.99 269.925 472.99 281.337C472.99 284.47 473.598 287.075 474.668 289.121C478.808 297.944 487.311 298.072 489.037 298.008C489.229 298.008 489.341 297.992 489.341 297.992L486.768 293.516C487.663 293.229 488.59 292.877 489.517 292.398C489.932 292.19 490.348 291.966 490.763 291.726C500.577 286.052 508.537 272.211 508.537 260.799C508.537 260.287 508.537 259.808 508.489 259.328C508.425 258.322 508.297 257.363 508.089 256.483ZM492.921 287.906C490.524 289.297 488.27 289.856 486.32 289.712C485.281 288.082 484.69 285.876 484.69 283.175C484.69 274.512 490.732 264.028 498.18 259.728C500.577 258.338 502.831 257.762 504.781 257.922C505.82 259.552 506.411 261.742 506.411 264.459C506.411 273.122 500.369 283.607 492.921 287.906Z",
    fill: "#777A85"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M513.059 256.004C510.039 251.353 504.189 250.394 497.476 254.278C487.662 259.952 479.703 273.793 479.703 285.205C479.703 293.069 483.475 297.72 489.037 298.008C491.562 298.136 494.439 297.368 497.476 295.594C507.29 289.92 515.249 276.079 515.249 264.667C515.249 261.071 514.466 258.146 513.059 256.004ZM484.673 283.159C484.673 274.497 490.715 264.012 498.163 259.712C500.561 258.322 502.814 257.746 504.764 257.906C505.803 259.536 506.395 261.726 506.395 264.443C506.395 273.106 500.353 283.591 492.905 287.89C490.507 289.281 488.254 289.84 486.304 289.696C485.265 288.066 484.673 285.861 484.673 283.159Z",
    fill: "#262626"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M511.654 267.592C511.654 276.255 505.612 286.74 498.164 291.039C496.006 292.286 493.976 292.877 492.17 292.877C492.01 292.877 491.866 292.877 491.723 292.877C491.531 292.877 491.339 292.845 491.163 292.829C491.051 292.829 490.939 292.797 490.827 292.765C490.684 292.749 490.54 292.717 490.412 292.669C490.3 292.637 490.188 292.621 490.076 292.573C490.028 292.573 489.996 292.542 489.964 292.526C489.852 292.494 489.741 292.462 489.629 292.414C489.597 292.414 489.565 292.382 489.533 292.382C489.293 292.286 489.069 292.174 488.846 292.046C488.846 292.046 488.846 292.046 488.83 292.046C488.718 291.982 488.606 291.918 488.494 291.838C488.382 291.758 488.254 291.678 488.142 291.598C487.679 291.263 487.263 290.863 486.896 290.416C486.8 290.304 486.72 290.192 486.64 290.08L486.368 289.681C488.318 289.824 490.572 289.265 492.969 287.874C500.417 283.575 506.459 273.074 506.459 264.427C506.459 261.71 505.868 259.504 504.829 257.89C505.084 257.906 505.34 257.938 505.58 257.986C505.692 258.002 505.82 258.034 505.948 258.066C506.059 258.098 506.171 258.13 506.283 258.146C506.523 258.21 506.763 258.306 506.986 258.401C507.098 258.449 507.21 258.497 507.322 258.545C507.434 258.593 507.53 258.657 507.642 258.705C507.961 258.881 508.265 259.073 508.537 259.313C508.745 259.472 508.936 259.648 509.112 259.84C509.272 260 509.416 260.176 509.576 260.351C509.592 260.383 509.624 260.415 509.64 260.431C509.72 260.527 509.799 260.623 509.863 260.735C509.943 260.847 510.023 260.959 510.087 261.071C510.167 261.183 510.231 261.294 510.311 261.422C510.599 261.918 510.838 262.461 511.046 263.069C511.094 263.18 511.126 263.308 511.158 263.436C511.51 264.635 511.717 266.025 511.717 267.576L511.654 267.592Z",
    fill: "#6E6C71"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M511.654 267.592C511.654 276.255 505.612 286.74 498.164 291.039C496.006 292.286 493.976 292.877 492.17 292.877C492.01 292.877 491.866 292.877 491.723 292.877C491.531 292.877 491.339 292.845 491.163 292.829C491.051 292.829 490.939 292.797 490.827 292.765C490.684 292.749 490.54 292.717 490.412 292.669C490.3 292.637 490.188 292.621 490.076 292.573C490.028 292.573 489.996 292.542 489.964 292.526C489.852 292.494 489.741 292.462 489.629 292.414C489.597 292.414 489.565 292.382 489.533 292.382C489.293 292.286 489.069 292.174 488.846 292.046C488.846 292.046 488.846 292.046 488.83 292.046C488.718 291.982 488.606 291.918 488.494 291.838C488.382 291.758 488.254 291.678 488.142 291.598C487.679 291.263 487.263 290.863 486.896 290.416C486.8 290.304 486.72 290.192 486.64 290.08L486.368 289.681C488.318 289.824 490.572 289.265 492.969 287.874C500.417 283.575 506.459 273.074 506.459 264.427C506.459 261.71 505.868 259.504 504.829 257.89C505.084 257.906 505.34 257.938 505.58 257.986C505.692 258.002 505.82 258.034 505.948 258.066C506.059 258.098 506.171 258.13 506.283 258.146C506.523 258.21 506.763 258.306 506.986 258.401C507.098 258.449 507.21 258.497 507.322 258.545C507.434 258.593 507.53 258.657 507.642 258.705C507.961 258.881 508.265 259.073 508.537 259.313C508.745 259.472 508.936 259.648 509.112 259.84C509.272 260 509.416 260.176 509.576 260.351C509.592 260.383 509.624 260.415 509.64 260.431C509.72 260.527 509.799 260.623 509.863 260.735C509.943 260.847 510.023 260.959 510.087 261.071C510.167 261.183 510.231 261.294 510.311 261.422C510.599 261.918 510.838 262.461 511.046 263.069C511.094 263.18 511.126 263.308 511.158 263.436C511.51 264.635 511.717 266.025 511.717 267.576L511.654 267.592Z",
    fill: "#777A85"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M500.433 270.181V258.625C499.698 258.897 498.931 259.265 498.164 259.712C496.661 260.575 495.239 261.678 493.896 262.989V273.937L484.802 285.157C485.026 286.979 485.537 288.514 486.32 289.712L486.592 290.112C486.672 290.224 486.768 290.336 486.848 290.448C486.959 290.592 487.087 290.735 487.215 290.847L497.157 278.588L507.338 279.483L510.631 271.092L500.465 270.197L500.433 270.181ZM491.627 282.984L488.494 286.867C488.19 287.251 487.807 287.347 487.631 287.091L486.8 285.908C486.64 285.669 486.736 285.157 487.039 284.79L490.172 280.922C490.476 280.554 490.859 280.458 491.019 280.698L491.85 281.881C492.026 282.136 491.914 282.632 491.627 283V282.984ZM498.627 265.114C498.627 265.514 498.339 265.993 498.004 266.185L496.326 267.144C495.974 267.352 495.702 267.192 495.702 266.793V262.637C495.702 262.237 495.99 261.742 496.326 261.55L498.004 260.591C498.339 260.399 498.627 260.559 498.627 260.959V265.114ZM506.651 276.175C506.475 276.622 506.091 276.958 505.788 276.926L502.655 276.638C502.351 276.606 502.255 276.239 502.431 275.791L503.278 273.649C503.454 273.202 503.838 272.866 504.141 272.882L507.274 273.154C507.578 273.186 507.674 273.569 507.498 274.017L506.651 276.159V276.175Z",
    fill: "#696C75"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M500.258 269.558L494.216 280.027L491.866 278.668C491.003 278.269 490.46 277.262 490.46 275.807C490.46 273.074 492.362 269.749 494.727 268.391C495.878 267.72 496.917 267.656 497.684 268.071L500.258 269.558Z",
    fill: "#777A85"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M497.157 269.797C494.807 271.156 492.889 274.48 492.889 277.214C492.889 279.947 494.791 281.066 497.157 279.707C499.506 278.348 501.424 275.024 501.424 272.291C501.424 269.558 499.522 268.439 497.157 269.797Z",
    fill: "#262626"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M495.222 226.755L515.105 252.488L510.374 250.666L493.32 238.63L495.222 226.755Z",
    fill: "#777A85"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M515.105 252.488L490.315 233.963L493.32 238.63L510.374 250.666L515.105 252.488Z",
    fill: "#262626"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M491.259 277.038L493.593 281.082L514.563 268.982C514.898 268.822 515.106 268.439 515.106 267.879C515.106 266.825 514.371 265.546 513.46 265.018C513.012 264.763 512.613 264.731 512.309 264.891L491.243 277.038H491.259Z",
    fill: "#C1C4D6"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M492.458 277.134C493.369 277.661 494.105 278.94 494.105 279.995C494.105 281.05 493.369 281.481 492.458 280.954C491.547 280.426 490.812 279.148 490.812 278.093C490.812 277.038 491.547 276.606 492.458 277.134Z",
    fill: "#262626"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M493.001 279.611C493.001 279.867 492.905 280.027 492.777 280.107C492.745 280.107 492.713 280.123 492.681 280.139L485.441 283.175L475.675 279.02L476.49 277.086L485.441 280.89L491.722 278.253C491.722 278.253 491.786 278.221 491.818 278.205C491.946 278.173 492.09 278.205 492.234 278.3C492.649 278.54 492.985 279.116 492.985 279.595L493.001 279.611Z",
    fill: "#C1C4D6"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M488.733 258.721C488.733 258.721 504.924 228.193 497.891 217.868L479.223 257.554L484.817 260.783L488.733 258.705V258.721Z",
    fill: "#C7C0B8"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M466.644 245.935L463.32 251.225C454.337 263.724 435.541 281.034 435.541 281.034C415.147 301.268 402.408 273.042 402.408 273.042L393.825 285.988C397.597 288.833 408.833 297.241 410.687 298.615C411.79 299.43 412.813 300.373 414.012 300.949L435.701 313.543L436.101 307.358L429.148 300.309L424.193 298.439C426.063 297.32 427.949 296.026 429.803 294.795L429.276 297.96L440.64 303.554L458.749 298.216L476.059 279.148L483.667 267.608L486.975 262.317L488.733 258.705L466.628 245.903L466.644 245.935Z",
    fill: "#362C29"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M488.733 258.721C482.579 270.852 457.63 293.836 457.63 293.836C437.235 314.071 424.497 285.845 424.497 285.845L415.914 298.791C419.686 301.636 430.922 310.043 432.776 311.418C434.726 312.856 436.404 314.678 439.297 314.183C443.9 313.399 448.951 309.436 453.714 306.383C456.878 304.353 460.027 302.339 463.192 300.341C463.224 300.309 463.336 300.277 463.368 300.229L478.919 280.474L488.717 258.705L488.733 258.721Z",
    fill: "#C7C0B8"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M424.513 285.845L415.914 298.791L393.825 286.004L402.408 273.042L424.513 285.845Z",
    fill: "#C7C0B8"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M418.104 307.949H423.298C423.298 307.949 423.218 307.773 423.075 307.47C422.052 305.52 417.448 298.088 407.315 299.542C406.74 299.606 406.132 299.718 405.509 299.878C405.445 299.878 405.365 299.91 405.301 299.926C403.847 300.325 402.328 300.965 400.762 301.876C390.948 307.55 382.989 321.391 382.989 332.803C382.989 335.936 383.596 338.541 384.667 340.587C388.807 349.41 397.31 349.537 399.036 349.473C399.228 349.473 399.34 349.457 399.34 349.457L396.766 344.982C397.661 344.694 398.588 344.343 399.515 343.863C399.931 343.656 400.346 343.432 400.762 343.192C410.576 337.518 418.535 323.677 418.535 312.265C418.535 311.753 418.535 311.274 418.487 310.794C418.423 309.787 418.296 308.828 418.088 307.949H418.104ZM402.936 339.372C400.538 340.763 398.285 341.322 396.335 341.178C395.296 339.548 394.704 337.342 394.704 334.641C394.704 325.978 400.746 315.493 408.194 311.194C410.592 309.803 412.845 309.228 414.795 309.388C415.834 311.018 416.426 313.208 416.426 315.925C416.426 324.588 410.384 335.073 402.936 339.372Z",
    fill: "#777A85"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M423.075 307.47C420.054 302.819 414.204 301.86 407.491 305.744C397.677 311.418 389.718 325.259 389.718 336.671C389.718 344.535 393.49 349.186 399.052 349.473C401.577 349.601 404.454 348.834 407.491 347.06C417.305 341.386 425.264 327.545 425.264 316.133C425.264 312.536 424.481 309.612 423.075 307.47ZM394.689 334.625C394.689 325.962 400.73 315.477 408.178 311.178C410.576 309.787 412.829 309.212 414.779 309.372C415.818 311.002 416.41 313.192 416.41 315.909C416.41 324.572 410.368 335.057 402.92 339.356C400.522 340.747 398.269 341.306 396.319 341.162C395.28 339.532 394.689 337.326 394.689 334.625Z",
    fill: "#262626"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M421.668 319.058C421.668 327.72 415.626 338.205 408.178 342.505C406.02 343.751 403.99 344.343 402.184 344.343C402.024 344.343 401.881 344.343 401.737 344.343C401.545 344.343 401.353 344.311 401.177 344.295C401.065 344.295 400.954 344.263 400.842 344.231C400.698 344.215 400.554 344.183 400.426 344.135C400.314 344.103 400.202 344.087 400.09 344.039C400.042 344.039 400.011 344.007 399.979 343.991C399.867 343.959 399.755 343.927 399.643 343.879C399.611 343.879 399.579 343.847 399.547 343.847C399.307 343.751 399.083 343.64 398.86 343.512C398.86 343.512 398.86 343.512 398.844 343.512C398.732 343.448 398.62 343.384 398.508 343.304C398.396 343.224 398.268 343.144 398.156 343.064C397.693 342.729 397.277 342.329 396.91 341.881C396.814 341.77 396.734 341.658 396.654 341.546L396.382 341.146C398.332 341.29 400.586 340.731 402.983 339.34C410.432 335.041 416.473 324.54 416.473 315.893C416.473 313.176 415.882 310.97 414.843 309.356C415.099 309.372 415.354 309.42 415.594 309.452C415.706 309.468 415.834 309.5 415.962 309.532C416.074 309.563 416.185 309.579 416.297 309.611C416.537 309.675 416.777 309.771 417.001 309.867C417.112 309.915 417.224 309.963 417.336 310.011C417.448 310.059 417.544 310.123 417.656 310.171C417.976 310.347 418.279 310.538 418.551 310.778C418.759 310.938 418.951 311.114 419.126 311.306C419.286 311.465 419.43 311.641 419.59 311.817C419.606 311.849 419.638 311.881 419.654 311.897C419.734 311.993 419.814 312.089 419.878 312.201C419.958 312.313 420.037 312.424 420.101 312.536C420.181 312.648 420.245 312.76 420.325 312.888C420.613 313.383 420.853 313.927 421.06 314.534C421.108 314.646 421.14 314.774 421.172 314.902C421.524 316.101 421.732 317.491 421.732 319.042L421.668 319.058Z",
    fill: "#6E6C71"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M421.668 319.058C421.668 327.72 415.626 338.205 408.178 342.505C406.02 343.751 403.99 344.343 402.184 344.343C402.024 344.343 401.881 344.343 401.737 344.343C401.545 344.343 401.353 344.311 401.177 344.295C401.065 344.295 400.954 344.263 400.842 344.231C400.698 344.215 400.554 344.183 400.426 344.135C400.314 344.103 400.202 344.087 400.09 344.039C400.042 344.039 400.011 344.007 399.979 343.991C399.867 343.959 399.755 343.927 399.643 343.879C399.611 343.879 399.579 343.847 399.547 343.847C399.307 343.751 399.083 343.64 398.86 343.512C398.86 343.512 398.86 343.512 398.844 343.512C398.732 343.448 398.62 343.384 398.508 343.304C398.396 343.224 398.268 343.144 398.156 343.064C397.693 342.729 397.277 342.329 396.91 341.881C396.814 341.77 396.734 341.658 396.654 341.546L396.382 341.146C398.332 341.29 400.586 340.731 402.983 339.34C410.432 335.041 416.473 324.54 416.473 315.893C416.473 313.176 415.882 310.97 414.843 309.356C415.099 309.372 415.354 309.42 415.594 309.452C415.706 309.468 415.834 309.5 415.962 309.532C416.074 309.563 416.185 309.579 416.297 309.611C416.537 309.675 416.777 309.771 417.001 309.867C417.112 309.915 417.224 309.963 417.336 310.011C417.448 310.059 417.544 310.123 417.656 310.171C417.976 310.347 418.279 310.538 418.551 310.778C418.759 310.938 418.951 311.114 419.126 311.306C419.286 311.465 419.43 311.641 419.59 311.817C419.606 311.849 419.638 311.881 419.654 311.897C419.734 311.993 419.814 312.089 419.878 312.201C419.958 312.313 420.037 312.424 420.101 312.536C420.181 312.648 420.245 312.76 420.325 312.888C420.613 313.383 420.853 313.927 421.06 314.534C421.108 314.646 421.14 314.774 421.172 314.902C421.524 316.101 421.732 317.491 421.732 319.042L421.668 319.058Z",
    fill: "#777A85"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M410.464 321.647V310.091C409.728 310.363 408.961 310.73 408.194 311.178C406.692 312.041 405.269 313.144 403.926 314.454V325.403L394.832 336.623C395.056 338.445 395.567 339.979 396.35 341.178L396.622 341.578C396.702 341.69 396.782 341.802 396.878 341.913C396.99 342.057 397.118 342.201 397.245 342.313L407.187 330.054L417.368 330.949L420.661 322.558L410.496 321.663L410.464 321.647ZM401.657 334.449L398.524 338.333C398.22 338.717 397.837 338.813 397.661 338.557L396.83 337.374C396.654 337.134 396.766 336.623 397.07 336.255L400.202 332.387C400.506 332.02 400.89 331.924 401.049 332.164L401.881 333.346C402.056 333.602 401.945 334.098 401.657 334.465V334.449ZM408.657 316.58C408.657 316.98 408.37 317.459 408.034 317.651L406.356 318.61C406.004 318.818 405.733 318.658 405.733 318.258V314.103C405.733 313.703 406.02 313.208 406.356 313.016L408.034 312.057C408.37 311.865 408.657 312.025 408.657 312.425V316.58ZM416.681 327.64C416.505 328.088 416.122 328.424 415.818 328.392L412.685 328.104C412.382 328.072 412.286 327.704 412.461 327.257L413.309 325.115C413.484 324.668 413.868 324.332 414.172 324.348L417.304 324.62C417.608 324.652 417.704 325.035 417.528 325.483L416.681 327.625V327.64Z",
    fill: "#696C75"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M410.272 321.023L404.231 331.492L401.881 330.134C401.018 329.734 400.475 328.727 400.475 327.273C400.475 324.54 402.377 321.215 404.742 319.857C405.893 319.185 406.932 319.121 407.699 319.537L410.272 321.023Z",
    fill: "#777A85"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M407.171 321.263C404.822 322.622 402.904 325.946 402.904 328.679C402.904 331.412 404.806 332.531 407.171 331.173C409.521 329.814 411.439 326.49 411.439 323.757C411.439 321.023 409.537 319.905 407.171 321.263Z",
    fill: "#262626"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M449.606 282.456C449.942 282.648 450.421 282.744 451.093 282.728C455.488 282.68 459.564 280.538 463.384 278.348C465.941 276.894 468.498 275.376 470.8 273.537C474.972 270.213 478.456 266.409 481.652 262.157C487.95 253.766 493.88 244.081 497.124 234.059C497.811 231.933 498.339 229.76 498.675 227.57C499.154 224.405 499.905 220.617 497.859 217.852C496.085 215.455 493.144 214.656 490.315 214.32C485.696 213.776 480.725 214.128 476.154 214.895C474.428 215.183 472.702 215.583 471.024 216.094C469.473 216.574 467.939 217.149 466.484 217.852C465.813 218.172 464.998 218.476 464.439 218.971C463.927 219.419 463.464 219.994 463.048 220.537C461.194 222.903 460.091 225.748 458.813 228.433C456.047 234.203 454.321 240.484 450.741 245.855C448.743 248.86 445.962 251.752 445.515 255.493C445.275 257.474 446.122 259.073 447.193 260.671C448.12 262.062 449.494 263.628 449.958 265.226C450.933 268.615 450.533 272.211 449.958 275.615C449.67 277.278 449.335 278.94 449.079 280.618C448.935 281.561 449.079 282.136 449.59 282.44L449.606 282.456Z",
    fill: "#C7C0B8"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M444.923 261.678C445.45 262.461 446.137 263.116 446.745 263.852C448.231 265.658 449.158 267.879 449.622 270.181C450.085 272.467 450.117 274.832 449.957 277.166C450.501 274.704 450.9 272.211 451.14 269.686C451.316 267.911 451.428 266.121 451.14 264.363C450.853 262.605 450.149 260.879 448.887 259.632C448.279 259.041 447.576 258.561 446.841 258.13C446.489 257.922 446.137 257.73 445.738 257.65C445.338 257.57 444.907 257.65 444.603 257.906C443.644 258.769 444.347 260.831 444.907 261.678H444.923Z",
    fill: "#C1C4D6"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M486.207 223.878C485.424 220.154 482.915 216.973 479.159 215.966C477.049 215.407 475.275 215.119 473.085 215.439C470.64 215.806 468.242 216.558 465.973 217.564C462.744 218.987 459.835 221.129 457.47 223.75C454.8 226.691 452.803 230.207 451.492 233.947C450.165 237.687 449.974 241.715 448.599 245.439C447.592 248.156 445.994 250.618 444.987 253.335C444.092 255.748 442.973 261.103 446.074 262.397C451.923 264.827 458.588 262.445 462.984 258.258C464.998 256.34 465.813 253.447 467.379 251.097C469.281 248.252 471.615 245.695 474.316 243.569C476.985 241.459 480.405 239.909 482.579 237.224C484.577 234.746 486.032 231.821 486.431 228.641C486.639 227.074 486.575 225.444 486.239 223.878H486.207Z",
    fill: "#362C29"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M453.219 257.027C455.105 254.853 456.367 252.056 457.598 249.403C458.956 246.51 460.411 243.617 462.425 241.14C464.231 238.918 466.453 237.08 468.578 235.178C470.72 233.276 472.814 231.262 474.3 228.833C475.259 227.266 475.931 225.508 476.138 223.67C476.314 222.088 476.186 219.962 475.131 218.667C474.236 217.564 472.702 217.229 471.279 217.213C462.089 217.069 455.776 224.469 452.755 232.381C450.709 237.751 449.67 243.457 447.576 248.812C446.601 251.305 445.387 253.75 445.275 256.483C445.227 257.554 445.371 258.737 446.138 259.472C447.273 260.559 449.175 260.144 450.517 259.328C451.54 258.705 452.419 257.922 453.187 257.043L453.219 257.027Z",
    fill: "#777A85"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M408.657 294.715H411.774L410.223 325.243C410.239 325.483 410.095 325.738 409.76 325.93C409.152 326.282 408.161 326.282 407.554 325.93C407.266 325.754 407.106 325.531 407.106 325.307L408.657 294.715Z",
    fill: "#C1C4D6"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M409.104 295.371C409.712 295.722 410.703 295.722 411.31 295.371C411.917 295.019 411.917 294.444 411.31 294.108C410.703 293.756 409.712 293.756 409.104 294.108C408.497 294.459 408.497 295.035 409.104 295.371Z",
    fill: "#333333"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M410.735 233.58C411.742 233.02 412.893 232.78 414.139 233.164C416.697 233.963 419.334 236.664 421.508 238.199C422.291 238.758 430.906 243.969 430.762 244.768C429.579 251.193 428.412 257.618 427.23 264.027C426.191 269.718 425.136 275.423 424.097 281.113C423.665 283.511 423.218 285.892 422.786 288.29C422.275 291.039 422.163 293.437 419.574 295.051C414.555 298.168 409.52 301.284 404.278 304.001C400.826 305.791 396.894 306.543 394.944 302.387C393.681 299.702 393.569 296.489 393.361 293.596C393.026 289.009 393.202 284.406 393.681 279.835C394.48 272.211 396.126 264.683 398.588 257.426C400.985 250.346 403.639 243.01 407.666 236.664C408.418 235.466 409.472 234.251 410.735 233.548V233.58Z",
    fill: "#362C29"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M403.574 280.266C404.885 277.773 416.025 249.403 416.809 247.453C417.831 244.896 419.206 241.747 417.08 239.381C416.121 238.311 414.843 237.543 413.372 237.623C412.125 237.703 410.831 239.046 410.144 237.368C406.34 241.667 404.134 247.069 402.184 252.392C400.074 258.194 398.22 263.98 397.005 270.069C396.302 273.553 393.889 281.002 397.773 283.399C399.403 284.39 400.777 283.974 402.04 282.552C402.647 281.849 403.159 281.082 403.59 280.266H403.574Z",
    fill: "#C7C0B8"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M409.792 295.227C409.632 291.231 410.991 286.676 412.269 282.936C413.692 278.748 415.578 274.704 417.704 270.836C419.51 267.544 421.795 264.347 424.4 261.63C425.008 261.007 425.967 260.224 426.862 260.112C427.821 260 428.013 261.071 427.965 261.806C427.421 270.469 423.761 279.004 424.688 287.747C424.816 288.897 425.008 290.048 424.784 291.199C424.592 292.158 424.065 292.685 423.394 293.405C421.731 295.179 419.781 296.809 417.863 298.295C416.249 299.542 413.356 299.254 411.422 298.983C410.096 298.807 409.84 296.777 409.776 295.227H409.792Z",
    fill: "#C7C0B8"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M400.41 217.389L402.36 214L392.323 208.198C392.083 208.086 391.747 208.118 391.38 208.326C390.613 208.774 389.989 209.845 389.989 210.724C389.989 211.139 390.133 211.443 390.357 211.587L400.394 217.389H400.41Z",
    fill: "#575961"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M390.42 209.333L401.4 215.678L400.409 217.405L390.372 211.603C390.148 211.443 390.004 211.155 390.004 210.74C390.004 210.292 390.164 209.781 390.436 209.349L390.42 209.333Z",
    fill: "#333439"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M399.931 216.462C399.931 215.583 400.555 214.512 401.322 214.064C402.089 213.617 402.712 213.968 402.712 214.847C402.712 215.726 402.089 216.797 401.322 217.245C400.555 217.692 399.931 217.341 399.931 216.462Z",
    fill: "#333439"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M401.481 218.587L403.926 214.336L402.456 213.489C402.152 213.345 401.737 213.393 401.289 213.649C400.33 214.208 399.547 215.551 399.547 216.653C399.547 217.181 399.723 217.548 400.01 217.74L401.481 218.587Z",
    fill: "#696B75"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M400.906 217.437C400.906 216.334 401.689 214.991 402.648 214.432C403.607 213.872 404.39 214.32 404.39 215.423C404.39 216.526 403.607 217.868 402.648 218.428C401.689 218.987 400.906 218.539 400.906 217.437Z",
    fill: "#333439"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M430.746 244.784C430.378 246.766 430.027 248.748 429.643 250.746C427.406 250.809 425.152 250.714 422.914 250.49C418.647 250.042 414.395 249.067 410.639 247.037C408.37 245.807 406.308 244.192 404.534 242.29C405.477 240.372 406.5 238.502 407.634 236.712C408.402 235.53 409.456 234.299 410.719 233.612C411.726 233.036 412.877 232.812 414.124 233.196C416.665 233.995 419.318 236.696 421.476 238.231C422.275 238.79 430.89 243.985 430.73 244.8L430.746 244.784Z",
    fill: "#777A85"
  }))), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M400.761 230.878C402.6 236.616 406.723 241.571 412.014 244.432C415.77 246.462 420.037 247.437 424.289 247.885C430.234 248.508 436.292 248.108 442.11 246.718C444.683 246.11 447.288 245.263 449.334 243.569C452.099 241.267 451.54 236.856 450.565 233.803C449.43 230.255 447.352 227.042 444.779 224.373C441.407 220.857 437.203 218.236 432.808 216.126C428.412 214.016 423.761 212.402 418.934 211.779C414.986 211.267 411.007 211.411 407.187 212.466C404.23 213.281 401.049 214.608 399.994 217.756C398.604 221.928 399.435 226.803 400.746 230.894L400.761 230.878Z",
    fill: "#777A85"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M451.269 239.861C450.757 239.973 450.246 240.037 449.734 240.101C444.028 240.692 438.242 240.42 432.584 239.477C427.31 238.582 422.099 237.064 417.384 234.539C412.797 232.077 408.274 229.248 404.646 225.444C404.342 225.124 404.055 224.805 403.767 224.485C402.792 223.366 401.897 222.152 401.289 220.841C400.826 219.834 400.298 218.715 400.075 217.564C401.194 214.544 404.294 213.265 407.203 212.466C411.023 211.411 415.019 211.267 418.951 211.779C423.778 212.402 428.429 214.032 432.824 216.126C437.22 218.236 441.423 220.873 444.796 224.389C447.369 227.058 449.447 230.271 450.581 233.819C451.157 235.609 451.588 237.863 451.285 239.877L451.269 239.861Z",
    fill: "#C7C0B8"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M419.014 240.868C424.065 237.479 428.428 233.068 432.616 228.593C434.438 226.643 436.228 224.677 438.002 222.695C438.482 222.152 438.977 221.592 439.249 220.921C439.505 220.298 439.553 219.61 439.537 218.939C439.537 218.188 439.425 217.437 439.265 216.701C439.185 216.334 439.073 215.966 438.961 215.615C438.338 213.776 437.347 212.05 435.829 210.852C434.374 209.701 432.712 208.838 430.954 208.31C427.438 207.223 423.602 207.431 420.149 208.63C418.998 209.029 418.135 209.541 417.48 210.58C415.051 214.464 413.292 218.731 412.078 223.127C410.591 228.481 409.888 234.235 410.096 239.813C410.16 241.379 410.511 243.249 411.982 243.793C413.021 244.176 414.156 243.713 415.131 243.201C416.489 242.498 417.784 241.715 419.046 240.884L419.014 240.868Z",
    fill: "#777A85"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M419.718 229.36C422.515 227.33 424.929 224.805 427.31 222.28C428.94 220.553 430.587 218.811 432.025 216.909C433.128 215.455 435.621 213.121 434.439 211.091C434.199 210.692 433.815 210.404 433.432 210.164C430.043 207.975 425.68 207.655 421.844 208.662C420.725 208.966 419.686 209.701 418.871 210.516C417.177 212.258 416.154 214.544 415.131 216.701C413.628 219.914 412.637 223.382 412.238 226.915C412.11 228.081 411.615 230.623 412.717 231.406C413.628 232.061 414.987 231.726 415.962 231.406C417.321 230.958 418.567 230.191 419.718 229.344V229.36Z",
    fill: "#C7C0B8"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M448.695 243.809L451.141 239.557L449.67 238.71C449.366 238.566 448.951 238.614 448.503 238.87C447.544 239.429 446.761 240.772 446.761 241.875C446.761 242.402 446.937 242.77 447.225 242.962L448.695 243.809Z",
    fill: "#696B75"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M448.104 242.642C448.104 241.539 448.887 240.197 449.846 239.637C450.805 239.078 451.588 239.525 451.588 240.628C451.588 241.731 450.805 243.074 449.846 243.633C448.887 244.192 448.104 243.745 448.104 242.642Z",
    fill: "#333439"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M459.052 249.195L461.002 245.807L450.964 240.005C450.725 239.893 450.389 239.925 450.021 240.133C449.254 240.58 448.631 241.651 448.631 242.53C448.631 242.946 448.775 243.249 448.998 243.393L459.036 249.195H459.052Z",
    fill: "#575961"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M459.995 247.533L459.036 249.179L448.998 243.377C448.775 243.217 448.631 242.93 448.631 242.514C448.631 242.099 448.775 241.603 449.014 241.188L459.995 247.533Z",
    fill: "#44464D"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M458.573 248.268C458.573 247.389 459.196 246.318 459.963 245.871C460.73 245.423 461.354 245.775 461.354 246.654C461.354 247.533 460.73 248.604 459.963 249.051C459.196 249.499 458.573 249.147 458.573 248.268Z",
    fill: "#333439"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M429.244 235.881C432.585 234.539 436.229 233.899 439.793 233.803C441.791 233.739 446.714 234.075 445.099 237.256C443.901 239.621 442.238 241.284 440.049 242.754C438.339 243.905 436.213 244.448 434.199 244.832C432.025 245.247 429.772 245.311 427.566 245.008C426.287 244.832 424.977 244.496 423.906 243.761C423.33 243.361 422.707 242.85 422.451 242.179C422.164 241.411 422.675 240.756 423.123 240.149C424.066 238.854 425.344 237.831 426.751 237.064C427.55 236.616 428.397 236.233 429.244 235.881Z",
    fill: "#FFE76B"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M440.832 242.115C439.122 243.265 436.996 243.809 434.982 244.192C432.808 244.608 430.555 244.672 428.349 244.368C427.07 244.192 425.76 243.857 424.689 243.122C424.114 242.722 423.49 242.211 423.234 241.539C422.947 240.772 423.458 240.117 423.906 239.509C424.321 238.934 424.817 238.422 425.344 237.959C424.497 238.582 423.73 239.286 423.123 240.133C422.675 240.74 422.164 241.395 422.451 242.163C422.707 242.834 423.33 243.345 423.906 243.745C424.977 244.48 426.287 244.816 427.566 244.992C429.772 245.295 432.009 245.231 434.199 244.816C436.213 244.432 438.355 243.889 440.049 242.738C440.64 242.338 441.2 241.923 441.711 241.491C441.423 241.699 441.136 241.907 440.832 242.115Z",
    fill: "#FF8C00"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M403.096 230.559C403.591 231.15 404.135 231.694 404.694 232.205C405.493 232.924 407.859 235.146 408.978 234.059C409.265 233.771 409.361 233.356 409.425 232.956C410.272 227.762 408.674 219.051 402.488 217.708C401.146 217.421 400.698 218.619 400.459 219.786C399.995 222.136 400.171 224.757 400.986 227.011C401.45 228.305 402.185 229.504 403.08 230.575L403.096 230.559Z",
    fill: "#FFE76B"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M401.274 224.853C401.545 225.716 401.881 226.563 402.232 227.442C402.936 229.184 404.262 230.751 405.893 231.71C406.068 231.821 406.276 231.917 406.484 231.901C406.852 231.869 407.075 231.47 407.203 231.102C407.875 229.12 407.379 227.058 406.676 225.156C405.829 222.855 404.598 220.521 402.488 219.291C401.098 218.491 400.618 220.01 400.634 221.177C400.666 222.487 400.906 223.686 401.289 224.853H401.274Z",
    fill: "#FDFFAB"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M405.125 231.326C404.55 230.815 404.022 230.271 403.527 229.68C402.632 228.625 401.897 227.426 401.433 226.115C400.634 223.862 400.458 221.241 400.906 218.891C400.954 218.635 401.018 218.396 401.098 218.14C400.762 218.555 400.586 219.163 400.474 219.754C400.011 222.104 400.186 224.725 401.002 226.979C401.465 228.273 402.2 229.472 403.095 230.543C403.591 231.134 404.134 231.678 404.694 232.189C405.493 232.908 407.858 235.13 408.977 234.043C409.201 233.819 409.313 233.516 409.377 233.196C408.242 234.203 405.924 232.029 405.141 231.326H405.125Z",
    fill: "#FF8C00"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M436.516 234.922C436.164 234.938 435.845 234.986 435.573 235.002C434.151 235.114 432.744 235.434 431.369 235.817C429.308 236.377 427.55 237.208 425.807 238.454C424.912 239.094 423.186 240.772 424.337 241.923C424.912 242.482 426.063 242.626 426.83 242.706C428.173 242.85 429.691 242.882 430.986 242.53C433.399 241.891 435.765 241.108 437.731 239.493C438.738 238.662 440.096 237.112 439.265 235.737C438.754 234.906 437.555 234.858 436.516 234.938V234.922Z",
    fill: "#FDFFAB"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M409.185 189.61C408.242 187.5 407.044 185.486 405.621 183.648C405.078 182.945 404.518 182.274 403.799 181.746C401.817 180.276 398.844 180.324 396.894 181.842C396.447 182.194 396.015 182.753 396.223 183.281C396.319 183.536 396.559 183.712 396.767 183.888C399.5 186.046 401.625 188.875 403.368 191.896C404.774 194.325 406.021 197.026 408.37 198.576C408.434 198.608 408.514 198.656 408.562 198.592L410.32 199.456C411.407 196.243 410.56 192.695 409.169 189.594L409.185 189.61Z",
    fill: "#C1C4D6"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M406.244 189.37C408.274 192.135 410.144 195.524 410.432 198.481C410.464 198.768 410.464 199.072 410.368 199.28C410.224 199.583 409.888 199.615 409.585 199.631C406.548 199.727 403 198.353 399.611 195.811C399.084 195.412 398.556 194.996 398.077 194.453C397.502 193.813 397.022 193.062 396.59 192.279C395.232 189.77 394.561 186.941 394.928 184.863C395.184 183.408 395.935 182.338 397.07 182.002C398.317 181.65 400.107 182.929 401.513 184.176C402.696 185.215 403.847 186.397 404.918 187.692C405.349 188.219 405.797 188.779 406.228 189.37H406.244Z",
    fill: "#262626"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 215.295C412.11 215.295 411.79 214.975 411.79 214.592V208.997L408.961 198.529L410.304 198.161L413.181 208.902V214.592C413.181 214.975 412.861 215.295 412.478 215.295H412.494Z",
    fill: "#262626"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M461.482 226.995C462.089 226.275 462.281 225.284 462.345 224.341C462.537 221.48 461.801 218.46 459.835 216.382C458.701 215.183 457.198 214.352 455.616 213.888C452.195 212.881 448.232 213.473 445.69 216.174C445.578 216.286 445.467 216.43 445.419 216.574C445.339 216.877 445.546 217.341 445.69 217.612C445.882 217.996 446.138 218.044 446.553 218.268C447.337 218.683 448.072 219.147 448.807 219.61C451.093 221.049 453.442 222.551 454.897 224.805C455.584 225.876 456.143 228.049 457.47 228.513C458.653 228.928 460.714 227.874 461.466 226.995H461.482Z",
    fill: "#C1C4D6"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M449.111 214.08C447.081 214.496 445.211 215.726 444.923 218.364C444.891 218.619 444.891 218.907 444.987 219.227C445.131 219.69 445.466 220.106 445.77 220.489C448.807 224.086 452.355 226.819 455.744 228.177C456.271 228.385 456.798 228.561 457.278 228.593C457.853 228.625 458.333 228.433 458.764 228.129C460.123 227.186 460.794 225.125 460.427 222.631C460.171 220.873 459.42 218.955 458.285 217.309C457.038 215.519 455.248 214.735 453.842 214.352C452.659 214.032 451.508 213.872 450.437 213.936C450.006 213.952 449.558 214.016 449.126 214.096L449.111 214.08Z",
    fill: "#262626"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M439.537 227.682C439.154 227.682 438.834 227.362 438.834 226.979V223.766L445.387 217.357L446.362 218.364L440.24 224.357V226.979C440.24 227.362 439.921 227.682 439.537 227.682Z",
    fill: "#262626"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M411.183 325.978L408.849 330.022L406.196 328.552C405.861 328.392 405.653 328.008 405.653 327.449C405.653 326.394 406.388 325.115 407.299 324.588C407.747 324.332 408.146 324.3 408.45 324.46L411.183 325.994V325.978Z",
    fill: "#C1C4D6"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M409.984 326.074C409.073 326.602 408.338 327.88 408.338 328.935C408.338 329.99 409.073 330.422 409.984 329.894C410.895 329.367 411.63 328.088 411.63 327.033C411.63 325.978 410.895 325.547 409.984 326.074Z",
    fill: "#262626"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.5H820.5C821.693 17.5 822.838 17.9741 823.682 18.818C824.526 19.6619 825 20.8065 825 22V457C825 485.511 813.674 512.854 793.514 533.014C773.354 553.174 746.011 564.5 717.5 564.5H22.5C21.3065 564.5 20.1619 564.026 19.318 563.182C18.4741 562.338 18 561.193 18 560V22C18 20.8065 18.4741 19.6619 19.318 18.818C20.1619 17.9741 21.3065 17.5 22.5 17.5Z",
    stroke: "white",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_46_6883",
    x: 0.5,
    y: 0,
    width: 842,
    height: 582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_46_6883"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_46_6883",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_6883",
    x1: 514.866,
    y1: 468.5,
    x2: 531.296,
    y2: 440.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_46_6883",
    x1: 510.022,
    y1: 465.703,
    x2: 526.437,
    y2: 437.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_46_6883",
    x1: 521.163,
    y1: 472.144,
    x2: 537.593,
    y2: 443.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_46_6883",
    x1: 517.854,
    y1: 470.226,
    x2: 534.285,
    y2: 441.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_46_6883",
    x1: 512.644,
    y1: 469.523,
    x2: 530.081,
    y2: 439.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_46_6883",
    x1: 517.599,
    y1: 470.082,
    x2: 534.029,
    y2: 441.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_46_6883",
    x1: 506.314,
    y1: 400.236,
    x2: 544.306,
    y2: 400.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_46_6883",
    x1: 506.41,
    y1: 372.218,
    x2: 544.386,
    y2: 372.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_46_6883",
    x1: 518.702,
    y1: 373.848,
    x2: 532.112,
    y2: 350.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_46_6883",
    x1: 512.851,
    y1: 362.819,
    x2: 537.96,
    y2: 362.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_46_6883",
    x1: 521.962,
    y1: 365.153,
    x2: 528.866,
    y2: 353.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFD0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_46_6883",
    x1: 536.458,
    y1: 409.33,
    x2: 543.235,
    y2: 397.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_46_6883",
    x1: 425.519,
    y1: 279.387,
    x2: 422.578,
    y2: 274.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_46_6883",
    x1: 425.28,
    y1: 318.994,
    x2: 422.339,
    y2: 313.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_46_6883",
    x1: 424.848,
    y1: 327.289,
    x2: 387.751,
    y2: 263.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_46_6883",
    x1: 388.54,
    y1: 320.623,
    x2: 414.848,
    y2: 275.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADDE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_46_6883",
    x1: 404.757,
    y1: 317.971,
    x2: 385.785,
    y2: 285.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_46_6883",
    x1: 410.592,
    y1: 329.654,
    x2: 405.765,
    y2: 321.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_46_6883",
    x1: 415.195,
    y1: 287.507,
    x2: 410.384,
    y2: 279.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_46_6883",
    x1: 407.666,
    y1: 334.385,
    x2: 377.059,
    y2: 281.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_46_6883",
    x1: 373.254,
    y1: 326.618,
    x2: 395.503,
    y2: 288.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_46_6883",
    x1: 391.348,
    y1: 325.707,
    x2: 372.376,
    y2: 292.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_46_6883",
    x1: 375.908,
    y1: 327.481,
    x2: 363.138,
    y2: 305.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_46_6883",
    x1: 299.556,
    y1: 424.482,
    x2: 328.518,
    y2: 374.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#7B7D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#848697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9EA0AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B4BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_46_6883",
    x1: 345.491,
    y1: 428.526,
    x2: 304.527,
    y2: 357.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_46_6883",
    x1: 289.104,
    y1: 430.524,
    x2: 318.065,
    y2: 380.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_46_6883",
    x1: 335.039,
    y1: 434.568,
    x2: 294.074,
    y2: 363.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_46_6883",
    x1: 303.137,
    y1: 414.877,
    x2: 295.194,
    y2: 401.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_46_6883",
    x1: 314.245,
    y1: 419.975,
    x2: 296.344,
    y2: 388.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_46_6883",
    x1: 292.012,
    y1: 419.448,
    x2: 304.671,
    y2: 397.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_46_6883",
    x1: 349.807,
    y1: 495.863,
    x2: 355.177,
    y2: 486.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#262F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A4245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_46_6883",
    x1: 358.997,
    y1: 500.882,
    x2: 364.08,
    y2: 492.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#262F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A4245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_46_6883",
    x1: 366.238,
    y1: 508.89,
    x2: 374.773,
    y2: 494.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_46_6883",
    x1: 376.036,
    y1: 514.564,
    x2: 384.555,
    y2: 499.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_46_6883",
    x1: 382.94,
    y1: 518.591,
    x2: 391.475,
    y2: 503.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_46_6883",
    x1: 395.471,
    y1: 525.88,
    x2: 404.006,
    y2: 511.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_46_6883",
    x1: 398.7,
    y1: 535.006,
    x2: 413.564,
    y2: 509.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_46_6883",
    x1: 409.265,
    y1: 539.082,
    x2: 422.355,
    y2: 516.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_46_6883",
    x1: 439.425,
    y1: 544.612,
    x2: 442.126,
    y2: 539.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#262F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A4245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_46_6883",
    x1: 440.496,
    y1: 545.235,
    x2: 443.213,
    y2: 540.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#262F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A4245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_46_6883",
    x1: 424.769,
    y1: 542.966,
    x2: 433.416,
    y2: 527.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_46_6883",
    x1: 607.376,
    y1: 351.088,
    x2: 631.798,
    y2: 308.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#DBDBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#CDCDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C5C5CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_46_6883",
    x1: 604.898,
    y1: 349.633,
    x2: 629.304,
    y2: 307.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_46_6883",
    x1: 627.035,
    y1: 325.387,
    x2: 631.03,
    y2: 318.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_46_6883",
    x1: 616.327,
    y1: 322.126,
    x2: 625.853,
    y2: 305.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_46_6883",
    x1: 609.885,
    y1: 348.546,
    x2: 615.782,
    y2: 338.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_46_6883",
    x1: 630.727,
    y1: 330.565,
    x2: 630.807,
    y2: 330.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_46_6883",
    x1: 598.681,
    y1: 345.046,
    x2: 610.253,
    y2: 325.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_46_6883",
    x1: 593.439,
    y1: 343.032,
    x2: 617.861,
    y2: 300.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_46_6883",
    x1: 627.658,
    y1: 339.005,
    x2: 606.656,
    y2: 318.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_46_6883",
    x1: 618.836,
    y1: 331.412,
    x2: 615.528,
    y2: 325.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B8B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AAAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A2A2A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_46_6883",
    x1: 617.844,
    y1: 330.294,
    x2: 615.495,
    y2: 326.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_46_6883",
    x1: 584.759,
    y1: 340.459,
    x2: 611.307,
    y2: 294.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_46_6883",
    x1: 600.374,
    y1: 349.537,
    x2: 626.922,
    y2: 303.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_46_6883",
    x1: 560.561,
    y1: 146.663,
    x2: 577.504,
    y2: 117.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_46_6883",
    x1: 573.46,
    y1: 151.218,
    x2: 587.845,
    y2: 126.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_46_6883",
    x1: 596.348,
    y1: 160.936,
    x2: 607.648,
    y2: 141.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_46_6883",
    x1: 598.138,
    y1: 177.846,
    x2: 630.44,
    y2: 177.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_46_6883",
    x1: 616.007,
    y1: 195.987,
    x2: 629.992,
    y2: 171.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_46_6883",
    x1: 595.181,
    y1: 134.148,
    x2: 631.527,
    y2: 134.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_46_6883",
    x1: 605.538,
    y1: 143.467,
    x2: 601.43,
    y2: 141.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B37635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BE843D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CA9645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3B655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBCA6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F1D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F5E28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F7E68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6E48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3E084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EDDA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6D162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2CB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#DFBD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9A350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_46_6883",
    x1: 606.257,
    y1: 133.717,
    x2: 609.725,
    y2: 135.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B37635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B47736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B97E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#BE843D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA9645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7E68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F5E38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F2DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBCD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#E2B964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9A350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_46_6883",
    x1: 593.263,
    y1: 144.969,
    x2: 633.525,
    y2: 144.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_46_6883",
    x1: 571.366,
    y1: 122.656,
    x2: 576.592,
    y2: 113.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_46_6883",
    x1: 637.617,
    y1: 216.558,
    x2: 658.858,
    y2: 179.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_46_6883",
    x1: 623.455,
    y1: 212.818,
    x2: 648.517,
    y2: 169.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_46_6883",
    x1: 579.693,
    y1: 163.685,
    x2: 583.848,
    y2: 156.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_46_6883",
    x1: 582.49,
    y1: 162.854,
    x2: 591.296,
    y2: 162.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_46_6883",
    x1: 587.909,
    y1: 168.416,
    x2: 592.048,
    y2: 161.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ECF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_46_6883",
    x1: 593.679,
    y1: 167.218,
    x2: 595.053,
    y2: 164.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B37635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BE843D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CA9645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3B655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBCA6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F1D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F5E28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F7E68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6E48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3E084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EDDA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6D162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2CB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#DFBD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9A350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_46_6883",
    x1: 596.188,
    y1: 168.832,
    x2: 597.754,
    y2: 166.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B37635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BE843D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CA9645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3B655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBCA6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F1D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F5E28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F7E68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6E48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3E084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EDDA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6D162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E2CB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#DFBD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9A350"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeProdred);
export default __webpack_public_path__ + "static/media/home-prodred.95ac38ccb761b20df3ca45ded5f82066.svg";
export { ForwardRef as ReactComponent };